// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   QUOTATIONS PAGE — FIGMA SPEC IMPLEMENTATION
   Nodes:
   - Desktop Light: 534:47752 | Dark: 533:51767
   - Tablet Light:  539:64178 | Dark: 539:65371
   - Mobile Light:  551:41126 | Dark: 551:42114
   ========================================================================== */

/* --------------------------------------------------------------------------
   Root Container & Variables Fallback
   -------------------------------------------------------------------------- */
.quotation-page {
  --dash-bg: var(--bg-primary, #f4f7f7);
  --dash-surface: var(--surface-primary, #ffffff);
  --dash-surface-2: var(--surface-secondary, #f4f7f7);
  --dash-surface-3: var(--surface-tertiary, #e8edec);
  --dash-border: var(--border-subtle, #dce3e2);
  --dash-border-strong: var(--border-default, #cdd6d4);
  --dash-text: var(--text-primary, #142624);
  --dash-muted: var(--text-secondary, #506360);
  --dash-brand: var(--interactive-default, #0f766e);
  --interactive-default: #0f766e;
  --interactive-pressed: #0a4a46;
  --interactive-soft: #f0f8f7;
  --text-link: #0f766e;
  --info-soft: #eff6ff;
  --info-text: #1d4ed8;
  --success-soft: #f0fdf4;
  --success-text: #15803d;
  --danger-soft: #fef2f1;
  --danger-text: #a3301f;
  --warning-soft: #fef8ec;
  --warning-text: #7d4412;
  --font-family-primary: "Lexend", -apple-system, BlinkMacSystemFont, sans-serif;
  --font-family-mono: "JetBrains Mono", monospace;

  min-height: 100vh;
  display: flex;
  background: var(--dash-bg);
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  line-height: 1.4;
}

.quotation-page.dark,
.quotation-page[data-theme="dark"] {
  --dash-bg: #101113;
  --dash-surface: #191b1f;
  --dash-surface-2: #22252a;
  --dash-surface-3: #2b2f35;
  --dash-border: #2c3036;
  --dash-border-strong: #3a3f47;
  --dash-text: #f2f3f5;
  --dash-muted: #b3b8c2;
  --dash-brand: #43a79c;
  --interactive-default: #43a79c;
  --interactive-pressed: #83c7be;
  --interactive-soft: #22252a;
  --text-link: #83c7be;
  --info-soft: #1e2b3c;
  --info-text: #aec9ec;
  --success-soft: #1b332b;
  --success-text: #8cd2b2;
  --danger-soft: #382324;
  --danger-text: #f3a6a1;
  --warning-soft: #3b2e19;
  --warning-text: #e5c17d;
}

.quotation-page *,
.quotation-page *::before,
.quotation-page *::after {
  box-sizing: border-box;
}

/* --------------------------------------------------------------------------
   Layout Shell
   -------------------------------------------------------------------------- */
html:has(.quotation-page, .quotation-editor-main-area) {
  scrollbar-gutter: stable;
}

.quotation-page[data-theme] > .screen-loading-modal {
  left: 256px !important;
  top: var(--app-topbar-height, 64px) !important;
  padding: 32px 32px 48px;
  background: var(--bg-primary, #f4f7f7);
  -webkit-backdrop-filter: none;
          backdrop-filter: none;
}

.quotation-page > .screen-loading-modal > .screen-loading-shell {
  width: 100%;
  min-width: 0;
}

@media (min-width: 1025px) {
  body.sidebar-collapsed .quotation-page > .screen-loading-modal {
    left: 0 !important;
  }
}

@media (max-width: 1024px) {
  .quotation-page[data-theme] > .screen-loading-modal {
    left: 0 !important;
    padding: 24px 24px 36px;
  }
}

@media (max-width: 767px) {
  .quotation-page[data-theme] > .screen-loading-modal {
    padding: 16px 16px 28px;
  }
}

.quotation-page .dashboard-main {
  flex: 1 1;
  min-width: 0;
  margin-left: 256px;
  display: flex;
  flex-direction: column;
}

.quotation-content {
  width: 100%;
  min-width: 0;
  /* max-width: 1440px; */
  margin: 0 auto;
  padding: 32px 32px 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Hide tablet & mobile identity rows on desktop by default */
.quotation-tablet-identity-row,
.quotation-mobile-identity {
  display: none;
}

/* --------------------------------------------------------------------------
   Page Header
   -------------------------------------------------------------------------- */
.quotation-page-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.quotation-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.quotation-page-identity h1 {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
  color: var(--dash-text);
}

.quotation-page-identity p {
  margin: 4px 0 0;
  font-size: 14px;
  line-height: 21.7px;
  color: var(--dash-muted);
}

.quotation-create-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  background: var(--interactive-default);
  color: #ffffff !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;
  flex-shrink: 0;
}

.quotation-page.dark .quotation-create-btn,
.quotation-page[data-theme="dark"] .quotation-create-btn {
  color: #101113 !important;
  font-weight: 600;
}

.quotation-create-btn:hover {
  background: var(--interactive-pressed);
}

.quotation-create-btn svg {
  font-size: 16px;
}

.quotation-snapshot-context {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--dash-muted);
}

/* --------------------------------------------------------------------------
   Quote Stat Summary Cards
   -------------------------------------------------------------------------- */
.quotation-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
  min-width: 0;
}

.quotation-stat-card {
  min-width: 0;
  max-width: 100%;
  min-height: 154px;
  padding: 24px;
  border-radius: 14px;
  border: 1px solid var(--dash-border);
  background: var(--dash-surface);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
}

.quotation-stat-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.quotation-stat-card-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--dash-text);
}

.quotation-stat-card-header svg {
  font-size: 20px;
  color: var(--interactive-default);
  flex-shrink: 0;
}

.quotation-stat-card-headline {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.quotation-stat-card-headline strong {
  font-family: var(--font-family-mono);
  font-size: 22px;
  font-weight: 700;
  line-height: 26.4px;
  color: var(--dash-text);
}

.quotation-stat-card-headline p {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--dash-muted);
}

/* --------------------------------------------------------------------------
   Quotations Management (Tabs & Filters)
   -------------------------------------------------------------------------- */
.quotation-management {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.quotation-tabs-wrap {
  border-bottom: 1px solid var(--dash-border);
  width: 100%;
}

.quotation-tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
}

.quotation-tabs::-webkit-scrollbar {
  display: none;
}

.quotation-tab-btn {
  height: 40px;
  padding: 0 12px;
  border: none;
  background: transparent;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: var(--font-size-label-md, 14px);
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-label-md, 18.2px);
  letter-spacing: var(--letter-spacing-label-md, 0.07px);
  color: var(--text-secondary, #506360);
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  transition: color 0.15s ease;
  flex-shrink: 0;
}

.quotation-tab-btn:hover {
  color: var(--text-secondary, #506360);
}

.quotation-tab-btn.active {
  color: var(--text-link);
}

.quotation-tab-btn.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--interactive-default);
  border-radius: 2px 2px 0 0;
}

/* Filter Controls Row */
.quotation-filter-controls {
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
}

.quotation-filter-search {
  height: 40px;
  width: 320px;
  min-width: 80px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--dash-surface);
  display: flex;
  align-items: center;
  gap: 8px;
}

.quotation-filter-search:hover {
  border-color: var(--border-strong, #aebab8);
}

.quotation-filter-search:focus-within {
  border-color: var(--interactive-default, #0f766e);
}

.quotation-filter-search svg {
  font-size: 16px;
  color: var(--dash-muted);
  flex-shrink: 0;
}

.quotation-filter-search input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--dash-text);
}

.quotation-filter-search input::placeholder {
  color: var(--dash-muted);
}

.quotation-dropdowns-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

.quotation-select-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.quotation-select-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  white-space: nowrap;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background 0.15s ease;
}

.quotation-select-trigger:hover {
  border-color: var(--border-strong, #aebab8);
}

.quotation-select-trigger.is-open,
.quotation-select-trigger:focus-visible {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}

.quotation-select-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quotation-select-trigger .select-arrow {
  font-size: 16px;
  color: var(--text-secondary, #506360);
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), color 0.15s ease;
  flex-shrink: 0;
}

.quotation-select-trigger.is-open .select-arrow {
  transform: rotate(180deg);
}

/* Dark mode for select trigger */
.quotation-page.dark .quotation-select-trigger,
.quotation-page[data-theme="dark"] .quotation-select-trigger {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-page.dark .quotation-select-trigger:hover,
.quotation-page[data-theme="dark"] .quotation-select-trigger:hover {
  border-color: var(--border-strong, #69727e);
}

.quotation-page.dark .quotation-select-trigger.is-open,
.quotation-page.dark .quotation-select-trigger:focus-visible,
.quotation-page[data-theme="dark"] .quotation-select-trigger.is-open,
.quotation-page[data-theme="dark"] .quotation-select-trigger:focus-visible {
  border-color: var(--interactive-default, #43a79c);
  box-shadow: none;
}

.quotation-page.dark .quotation-select-trigger .select-arrow,
.quotation-page[data-theme="dark"] .quotation-select-trigger .select-arrow {
  color: var(--text-secondary, #b3b8c2);
}

/* Native select fallback */
.quotation-select-wrap select {
  appearance: none;
  -webkit-appearance: none;
  height: 40px;
  padding: 0 32px 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.quotation-select-wrap select:hover {
  border-color: var(--border-strong, #aebab8);
}

.quotation-select-wrap select:focus {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}

.quotation-page.dark .quotation-select-wrap select,
.quotation-page[data-theme="dark"] .quotation-select-wrap select {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-select-wrap select option {
  background: var(--surface-elevated, #ffffff);
  color: var(--text-primary, #142624);
}

.quotation-page.dark .quotation-select-wrap select option,
.quotation-page[data-theme="dark"] .quotation-select-wrap select option {
  background: var(--surface-elevated, #25282e);
  color: var(--text-primary, #f2f3f5);
}

.quotation-select-wrap > .select-arrow {
  position: absolute;
  right: 12px;
  pointer-events: none;
  font-size: 16px;
  color: var(--text-secondary, #506360);
}

/* Dropdown Menu Panel (Figma Node 122:3500) */
.quotation-dropdown-panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 100;
  min-width: 100%;
  width: max-content;
  max-width: 280px;
  max-height: 260px;
  overflow-y: auto;
  padding: 4px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-elevated, #ffffff);
  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),
    0px 1px 1px rgba(14, 26, 32, 0.04);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.quotation-page.dark .quotation-dropdown-panel,
.quotation-page[data-theme="dark"] .quotation-dropdown-panel {
  background: var(--surface-elevated, #25282e);
  border-color: var(--border-default, #3a3f47);
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.35), 0px 1px 2px rgba(0, 0, 0, 0.2);
}

.quotation-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
  white-space: nowrap;
}

.quotation-dropdown-item:hover {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}

.quotation-dropdown-item.is-selected {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
  font-weight: 500;
}

.quotation-dropdown-item-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quotation-dropdown-check-icon {
  font-size: 16px;
  color: var(--interactive-default, #0f766e);
  flex-shrink: 0;
}

.quotation-page.dark .quotation-dropdown-item,
.quotation-page[data-theme="dark"] .quotation-dropdown-item {
  color: var(--text-primary, #f2f3f5);
}

.quotation-page.dark .quotation-dropdown-item:hover,
.quotation-page[data-theme="dark"] .quotation-dropdown-item:hover {
  background: var(--surface-secondary, #22252a);
  color: var(--text-primary, #f2f3f5);
}

.quotation-page.dark .quotation-dropdown-item.is-selected,
.quotation-page[data-theme="dark"] .quotation-dropdown-item.is-selected {
  background: var(--interactive-soft, #22252a);
  color: var(--interactive-default, #43a79c);
}

.quotation-page.dark .quotation-dropdown-check-icon,
.quotation-page[data-theme="dark"] .quotation-dropdown-check-icon {
  color: var(--interactive-default, #43a79c);
}

/* --------------------------------------------------------------------------
   Table Card & Layout
   -------------------------------------------------------------------------- */
.quotation-table-card {
  width: 100%;
  min-width: 0;
  border-radius: 14px;
  border: 1px solid var(--dash-border);
  background: var(--dash-surface);
  box-shadow: 0px 1px 2px rgba(14, 26, 32, 0.06);
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.quotation-table-context {
  height: 48px;
  padding: 0 16px;
  border-bottom: 1px solid var(--dash-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
}

.quotation-table-context strong {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07px;
  color: var(--dash-text);
}

.quotation-table-context span {
  font-size: 13px;
  letter-spacing: 0.065px;
  color: var(--dash-muted);
}

.quotation-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.quotation-table-card table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.quotation-table-card th {
  height: 44px;
  padding: 0 16px;
  background: var(--dash-surface-2);
  border-bottom: 1px solid var(--dash-border);
  color: var(--dash-muted);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
}

.quotation-table-card td {
  height: 52px;
  padding: 0 16px;
  border-bottom: 1px solid var(--dash-border);
  font-size: 14px;
  color: var(--dash-text);
  white-space: nowrap;
  vertical-align: middle;
}

.quotation-table-card tbody tr:hover {
  background: var(--dash-surface-2);
}

.quotation-clickable-row {
  cursor: pointer;
}

.quotation-clickable-row:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: -2px;
}

.quotation-clickable-row a,
.quotation-clickable-row button,
.quotation-clickable-row input {
  cursor: pointer;
}

/* Checkboxes */
.quotation-table-card input[type="checkbox"],
.quotation-mobile-checkbox {
  width: 16px;
  height: 16px;
  margin: 0;
  border-radius: 4px;
  accent-color: var(--interactive-default);
  cursor: pointer;
}

/* Desktop Columns Widths */
.col-checkbox {
  width: 48px;
  text-align: center;
  padding: 0 8px !important;
}

.quotation-table-card .col-checkbox > input[type="checkbox"] {
  display: block;
  margin-right: auto !important;
  margin-left: auto !important;
}
.col-quoteno {
  width: 140px;
}
.col-customer {
  width: 232px;
}
.col-created {
  width: 124px;
  color: var(--dash-muted) !important;
}
.col-valid {
  width: 124px;
  color: var(--dash-muted) !important;
}
.col-status {
  width: 112px;
}
.col-amount {
  width: 128px;
  text-align: right;
  font-family: var(--font-family-mono);
  font-weight: 500;
  font-size: 16px !important;
}
.col-actions {
  width: 220px;
  text-align: right;
  padding: 0 16px !important;
}

.quotation-page
  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)
  table {
  table-layout: fixed;
}

.quotation-page
  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)
  :is(th, td):is(.col-quoteno, .col-customer, .col-created, .col-valid, .col-status, .col-amount, .col-actions, .tab-col-custquote, .tab-col-statusvalid, .tab-col-amount, .tab-col-actions) {
  width: auto;
  text-align: left;
}

.quotation-page
  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)
  :is(th, td) {
  padding-inline: 16px;
  vertical-align: middle;
}

.quotation-page
  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)
  :is(.col-checkbox, .tab-col-checkbox) {
  width: 48px;
  text-align: center;
}

.quotation-page
  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)
  :is(.col-amount, .col-actions, .tab-col-amount, .tab-col-actions) {
  text-align: right;
}

.quotation-page .quotation-desktop-table-card td.col-customer {
  max-width: 28ch;
  padding-top: 8px;
  padding-bottom: 8px;
  white-space: normal;
  overflow-wrap: anywhere;
}

/* Reserve room for inline actions; headings and loading rows share the columns. */
.quotation-page .quotation-desktop-table-card table {
  --quotation-actions-width: 208px;
  min-width: 0;
}

.quotation-page .quotation-desktop-table-card col {
  width: calc((100% - var(--quotation-actions-width)) / 6);
}

.quotation-page .quotation-desktop-table-card col.col-actions {
  width: var(--quotation-actions-width);
}

.quotation-page .quotation-desktop-table-card :is(th, td) {
  white-space: normal;
  overflow-wrap: anywhere;
}

.quotation-page
  .quotation-desktop-table-card
  :is(th, td):is(.col-amount, .col-actions) {
  text-align: left;
}

.quotation-page .quotation-desktop-table-card th.col-amount {
  font-family: var(--font-family-primary);
  font-size: 14px !important;
}

.quotation-page .quotation-desktop-table-card td.col-amount {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quotation-page .quotation-desktop-table-card th.col-actions {
  text-align: center;
}

.quotation-page .quotation-desktop-table-card .quotation-row-actions-group {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  padding-block: 8px;
}

.quotation-page .quotation-desktop-table-card .quotation-row-action-btn {
  flex: 0 0 auto;
  min-height: 32px;
  height: 32px;
  padding: 0 12px;
  border-radius: var(--radius-sm, 6px);
  white-space: nowrap;
}

.quotation-page
  .quotation-desktop-table-card
  .quotation-row-actions-group
  .quotation-dots-btn {
  flex: 0 0 24px;
  width: 24px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  box-shadow: none;
}

.quotation-page
  .quotation-desktop-table-card
  .quotation-row-actions-group
  .quotation-dots-btn:hover {
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-page .quotation-tablet-table-card .tab-cust-name {
  max-width: 28ch;
  white-space: normal;
  overflow-wrap: anywhere;
}

.quotation-row-actions-group {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  position: relative;
}

.quotation-page
  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)
  :is(th, td):is(.col-actions, .tab-col-actions) {
  text-align: center;
}

.quotation-page
  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)
  .quotation-row-actions-group {
  justify-content: center;
}

.quotation-row-action-btn {
  box-sizing: border-box;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 132px;
  height: 32px;
  padding: 0 12px;
  border-radius: 10px;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.quotation-invoice-created {
  box-sizing: border-box;
  text-decoration: none;
}

.quotation-invoice-created:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.quotation-row-send-btn {
  background: var(--dash-surface-2, #f4f7f7);
  border: 1px solid var(--dash-border-strong, #cdd6d4);
  color: var(--dash-text, #142624);
}

.quotation-row-send-btn:hover {
  background: var(--dash-surface-3, #e8edec);
}

.quotation-row-send-btn > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  stroke-width: 1.75;
}

.quotation-page.dark .quotation-row-send-btn,
.quotation-page[data-theme="dark"] .quotation-row-send-btn {
  background: var(--dash-surface-2, #22252a);
  border-color: var(--dash-border-strong, #3a3f47);
  color: var(--dash-text, #f2f3f5);
}

.quotation-page.dark .quotation-row-send-btn:hover,
.quotation-page[data-theme="dark"] .quotation-row-send-btn:hover {
  background: var(--dash-surface-3, #2b2f35);
}

.quotation-row-invoice-btn {
  background: var(--interactive-default);
  color: #ffffff !important;
  border: none;
}

.quotation-page.dark .quotation-row-invoice-btn,
.quotation-page[data-theme="dark"] .quotation-row-invoice-btn {
  color: #101113 !important;
  font-weight: 600;
}

.quotation-row-invoice-btn:hover {
  background: var(--interactive-pressed);
}

.quotation-row-send-btn-sm,
.quotation-row-invoice-btn-sm {
  height: 28px;
  padding: 0 8px;
  font-size: 12px;
  border-radius: 8px;
}

.quotation-dots-btn {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid var(--dash-border-strong, #cdd6d4);
  background: var(--dash-surface, #ffffff);
  color: var(--dash-muted, #506360);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  flex-shrink: 0;
}

.quotation-dots-btn:hover {
  background: var(--dash-surface-2, #f4f7f7);
  color: var(--dash-text, #142624);
}

.quotation-page.dark .quotation-dots-btn,
.quotation-page[data-theme="dark"] .quotation-dots-btn {
  background: var(--dash-surface-2, #22252a);
  border-color: var(--dash-border-strong, #3a3f47);
  color: var(--dash-muted, #b3b8c2);
}

.quotation-page.dark .quotation-dots-btn:hover,
.quotation-page[data-theme="dark"] .quotation-dots-btn:hover {
  background: var(--dash-surface-3, #2b2f35);
  color: var(--dash-text, #f2f3f5);
}

.quotation-dots-btn svg {
  font-size: 16px;
}

/* Monospace links */
.quotation-mono-link,
.quotation-mono-link:link,
.quotation-mono-link:visited {
  font-family: var(--font-family-mono);
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.28px;
  color: var(--text-link, #0f766e);
  text-transform: uppercase;
  text-decoration: none;
}

.quotation-mono-link:hover,
.quotation-mono-link:active {
  color: var(--text-link, #0f766e);
  text-decoration: underline !important;
  text-underline-offset: 2px;
}

.quotation-mono-link:focus-visible {
  color: var(--text-link, #0f766e);
  border-radius: 2px;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

.quotation-contact-link {
  color: var(--interactive-default, #0f766e);
  font: inherit;
  text-decoration: none;
  text-underline-offset: 2px;
}

.quotation-contact-link:hover {
  text-decoration: underline !important;
  color: var(--interactive-default, #0f766e);
}

.quotation-contact-link:focus-visible {
  border-radius: 2px;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

.tab-cust-name.quotation-contact-link {
  color: var(--interactive-default, #0f766e);
}

.quote-customer-link {
  color: inherit;
  text-decoration: none;
  text-underline-offset: 2px;
}

.quote-customer-link:hover {
  text-decoration: underline !important;
  color: #0f766e;
}

.quote-customer-link:focus-visible {
  border-radius: 2px;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

/* --------------------------------------------------------------------------
   Status Badges (Light & Dark matching Figma)
   -------------------------------------------------------------------------- */
.quotation-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.12px;
  white-space: nowrap;
}

.quotation-status.viewed,
.quotation-status.sent {
  background: var(--info-soft);
  color: var(--info-text);
}

.quotation-status.approved {
  background: var(--success-soft);
  color: var(--success-text);
}

.quotation-status.draft {
  background: var(--dash-surface-3);
  color: var(--dash-muted);
}

.quotation-status.declined {
  background: var(--danger-soft);
  color: var(--danger-text);
}

.quotation-status.expired {
  background: var(--warning-soft);
  color: var(--warning-text);
}

.quotation-status.voided {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}

/* --------------------------------------------------------------------------
   Row Actions & Action Menu Dropdown
   -------------------------------------------------------------------------- */
.quotation-row-action {
  position: relative;
  text-align: center;
}

.quotation-dots-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--dash-muted);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.quotation-dots-btn:hover {
  background: var(--dash-surface-3);
  color: var(--dash-text);
}

.quotation-dots-btn svg {
  font-size: 16px;
}

.quotation-action-menu {
  box-sizing: border-box;
  position: absolute;
  top: 38px;
  right: 0;
  z-index: 50;
  width: 240px;
  padding: 4px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-elevated, #ffffff);
  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),
    0px 1px 1px rgba(14, 26, 32, 0.04);
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.quotation-page.dark .quotation-action-menu,
.quotation-page[data-theme="dark"] .quotation-action-menu {
  background: var(--surface-elevated, #25282e);
  border-color: var(--border-default, #3a3f47);
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.35), 0px 1px 2px rgba(0, 0, 0, 0.2);
}

.quotation-action-menu a,
.quotation-action-menu button,
.quotation-menu-item {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: normal;
  text-align: left;
  text-transform: none;
  color: var(--text-primary, #142624);
  text-decoration: none;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
  white-space: nowrap;
}

.quotation-menu-item > span {
  font: inherit;
  letter-spacing: inherit;
}

.quotation-menu-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: inherit;
}

.quotation-page.dark .quotation-action-menu a,
.quotation-page.dark .quotation-action-menu button,
.quotation-page.dark .quotation-menu-item,
.quotation-page[data-theme="dark"] .quotation-action-menu a,
.quotation-page[data-theme="dark"] .quotation-action-menu button,
.quotation-page[data-theme="dark"] .quotation-menu-item {
  color: var(--text-primary, #f2f3f5);
}

.quotation-action-menu a:hover,
.quotation-action-menu button:hover,
.quotation-menu-item:hover {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}

.quotation-page.dark .quotation-action-menu a:hover,
.quotation-page.dark .quotation-action-menu button:hover,
.quotation-page.dark .quotation-menu-item:hover,
.quotation-page[data-theme="dark"] .quotation-action-menu a:hover,
.quotation-page[data-theme="dark"] .quotation-action-menu button:hover,
.quotation-page[data-theme="dark"] .quotation-menu-item:hover {
  background: var(--surface-secondary, #22252a);
  color: var(--text-primary, #f2f3f5);
}

.quotation-action-menu .disabled,
.quotation-menu-item.disabled,
.quotation-menu-item:disabled {
  opacity: 0.45;
  pointer-events: auto;
  cursor: not-allowed;
}

.quotation-menu-item:disabled:hover {
  background: transparent !important;
}

.quotation-action-menu .quotation-action-delete,
.quotation-menu-item-delete {
  color: var(--danger-text, #a3301f) !important;
}

.quotation-page.dark .quotation-action-menu .quotation-action-delete,
.quotation-page.dark .quotation-menu-item-delete,
.quotation-page[data-theme="dark"]
  .quotation-action-menu
  .quotation-action-delete,
.quotation-page[data-theme="dark"] .quotation-menu-item-delete {
  color: var(--danger-text, #f3aaa4) !important;
}

.quotation-action-menu .quotation-action-delete:hover,
.quotation-menu-item-delete:hover {
  background: var(--danger-soft, #fef2f1) !important;
  color: var(--danger-text, #a3301f) !important;
}

.quotation-page.dark .quotation-action-menu .quotation-action-delete:hover,
.quotation-page.dark .quotation-menu-item-delete:hover,
.quotation-page[data-theme="dark"]
  .quotation-action-menu
  .quotation-action-delete:hover,
.quotation-page[data-theme="dark"] .quotation-menu-item-delete:hover {
  background: var(--danger-soft, #332022) !important;
  color: var(--danger-text, #f3aaa4) !important;
}

.quotation-empty-cell {
  height: 120px !important;
  text-align: center !important;
  color: var(--dash-muted);
  font-size: 14px;
}

/* --------------------------------------------------------------------------
   Pagination Footer
   -------------------------------------------------------------------------- */
.quotation-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 16px;
  border-top: 1px solid var(--dash-border);
  background: var(--dash-surface);
  border-radius: 0 0 14px 14px;
}

.quotation-pagination span {
  font-size: 13px;
  color: var(--dash-muted);
}

.quotation-pagination-btns {
  display: flex;
  gap: 8px;
  align-items: center;
}

.quotation-pagination-btns button {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid var(--dash-border-strong);
  background: var(--dash-surface);
  color: var(--dash-text);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.quotation-pagination-btns button:hover:not(:disabled) {
  background: var(--dash-surface-2);
}

.quotation-pagination-btns button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.quotation-pagination-btns svg {
  font-size: 16px;
}

/* --------------------------------------------------------------------------
   Disclaimer Note
   -------------------------------------------------------------------------- */
.quotation-disclaimer {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--dash-muted);
}

/* ==========================================================================
   DESKTOP / TABLET / MOBILE VISIBILITY SWITCHES
   ========================================================================== */
.quotation-desktop-table-card {
  display: flex;
}
.quotation-tablet-table-card {
  display: none;
}
.quotation-mobile-view {
  display: none;
}

/* ==========================================================================
   TABLET VIEW (768px - 1024px) — Figma Node 539:64178 / 539:65371
   ========================================================================== */
@media (min-width: 768px) and (max-width: 1024px) {
  .quotation-page .dashboard-main {
    margin-left: 0 !important;
  }

  .quotation-content {
    padding: 24px 24px 36px !important;
    gap: 20px !important;
  }

  /* Identity row in tablet content (Launcher + Org selector) */
  .quotation-tablet-identity-row {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100% !important;
  }

  .quotation-tablet-identity-row .dashboard-product-identity {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }

  .quotation-tablet-identity-row .dashboard-mobile-org {
    max-width: 220px !important;
    width: 100% !important;
  }

  .quotation-tablet-identity-row .dashboard-mobile-org .org-switch-icon {
    color: var(--interactive-default) !important;
  }

  .quotation-mobile-identity {
    display: none !important;
  }

  /* Heading */
  .quotation-page-identity h1 {
    font-size: 28px !important;
    line-height: 35px !important;
    letter-spacing: -0.42px !important;
  }

  .quotation-page-identity p {
    font-size: 13px !important;
    line-height: 20.2px !important;
  }

  /* Summary Grid: 2 columns in row 1, 1 full-width card in row 2 */
  .quotation-summary-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px !important;
  }

  .quotation-stat-card {
    padding: 20px !important;
    gap: 16px !important;
  }

  .quotation-stat-card-full {
    grid-column: 1 / -1 !important;
  }

  .quotation-stat-card-header h3 {
    font-size: 17px !important;
    line-height: 23.8px !important;
  }

  .quotation-stat-card-headline strong {
    font-size: 20px !important;
    line-height: 24px !important;
  }

  /* Filters */
  .quotation-filter-controls {
    display: flex !important;
    gap: 12px !important;
  }

  .quotation-filter-search {
    flex: 1 1 !important;
    width: auto !important;
  }

  /* Switch Table views */
  .quotation-desktop-table-card {
    display: none !important;
  }

  .quotation-tablet-table-card {
    display: flex !important;
  }

  .quotation-mobile-view {
    display: none !important;
  }

  /* Tablet Table Column styling */
  .tab-col-checkbox {
    width: 48px;
    text-align: center;
    padding: 0 8px !important;
  }
  .tab-col-custquote {
    width: 225px;
  }
  .tab-col-statusvalid {
    width: 184px;
  }
  .tab-col-amount {
    width: 144px;
    text-align: right;
    font-family: var(--font-family-mono);
    font-weight: 500;
    font-size: 15px !important;
  }
  .tab-col-actions {
    text-align: center;
  }

  .tab-custquote-inner {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .tab-cust-name {
    font-size: 13px;
    line-height: 20.2px;
    color: var(--dash-text);
  }

  .tab-created-date {
    font-size: 13px;
    line-height: 18.2px;
    color: var(--dash-muted);
  }

  .tab-statusvalid-inner {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
  }

  .tab-valid-text {
    font-size: 13px;
    line-height: 18.2px;
    color: var(--dash-muted);
  }

  .quotation-tablet-table-card td {
    height: 104px !important;
    padding: 16px !important;
  }
}

/* ==========================================================================
   MOBILE VIEW (max-width: 767px) — Figma Node 551:41126 / 551:42114
   ========================================================================== */
@media (max-width: 767px) {
  .quotation-page .dashboard-main {
    margin-left: 0 !important;
  }

  .quotation-content {
    padding: 16px 16px 28px !important;
    gap: 20px !important;
  }

  /* Identity in mobile content */
  .quotation-tablet-identity-row {
    display: none !important;
  }

  .quotation-mobile-identity {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
    width: 100% !important;
  }

  .quotation-mobile-brand-title {
    font-size: 13px;
    font-weight: 500;
    line-height: 16.9px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
  }

  .quotation-mobile-identity .dashboard-mobile-org {
    width: 100% !important;
  }

  .quotation-mobile-identity .dashboard-mobile-org .org-switch-icon {
    color: var(--interactive-default) !important;
  }

  /* Header */
  .quotation-page-header {
    gap: 12px !important;
  }

  .quotation-title-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
  }

  .quotation-page-identity h1 {
    font-size: 24px !important;
    line-height: 30px !important;
    letter-spacing: -0.36px !important;
  }

  .quotation-page-identity p {
    font-size: 13px !important;
    line-height: 20.2px !important;
  }

  .quotation-create-btn {
    width: 100% !important;
    height: 40px !important;
  }

  .quotation-snapshot-context {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 4px !important;
  }

  /* Summary Stat Cards: 1 column stacked */
  .quotation-summary-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
  }

  .quotation-stat-card {
    padding: 16px !important;
    min-height: auto !important;
    gap: 16px !important;
  }

  .quotation-stat-card-header h3 {
    font-size: 16px !important;
    line-height: 22.4px !important;
  }

  .quotation-stat-card-headline strong {
    font-size: 20px !important;
    line-height: 24px !important;
  }

  /* Tabs horizontal scroll with fade */
  .quotation-tabs-wrap {
    position: relative;
    overflow: hidden;
  }

  .quotation-tab-btn {
    padding: 0 8px !important;
  }

  /* Filters */
  .quotation-filter-controls {
    flex-direction: column !important;
    gap: 12px !important;
    width: 100% !important;
  }

  .quotation-filter-search {
    width: 100% !important;
  }

  .quotation-dropdowns-group {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 12px !important;
    width: 100% !important;
  }

  .quotation-select-wrap {
    width: 100% !important;
  }

  .quotation-select-trigger {
    width: 100% !important;
  }

  .quotation-select-wrap select {
    width: 100% !important;
  }

  .quotation-dropdown-panel {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* Hide table cards on mobile, show card list */
  .quotation-desktop-table-card {
    display: none !important;
  }

  .quotation-tablet-table-card {
    display: none !important;
  }

  .quotation-mobile-view {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
    width: 100% !important;
  }

  .quotation-mobile-list-header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin-top: 4px;
  }

  .quotation-mobile-list-heading-left strong {
    display: block;
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
    color: var(--dash-text);
  }

  .quotation-mobile-list-heading-left span {
    font-size: 13px;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
  }

  .quotation-mobile-select-btn {
    height: 40px;
    padding: 0 16px;
    border-radius: 10px;
    border: 1px solid var(--dash-border-strong);
    background: var(--dash-surface-2);
    color: var(--dash-text);
    font-family: var(--font-family-primary);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
  }

  .quotation-mobile-select-btn.active {
    background: var(--interactive-default);
    color: #ffffff;
    border-color: var(--interactive-default);
  }

  .quotation-mobile-cards-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .quotation-mobile-card {
    min-width: 0;
    max-width: 100%;
    padding: 16px;
    border-radius: 14px;
    border: 1px solid var(--dash-border);
    background: var(--dash-surface);
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .quotation-mobile-card-top {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  .quotation-mobile-card[aria-hidden="true"] .quotation-mobile-card-top > *,
  .quotation-mobile-card[aria-hidden="true"] .quotation-mobile-card-mid > * {
    min-width: 0;
  }

  .quotation-mobile-card-top .quotation-mono-link {
    flex: 1 1;
  }

  .quotation-mobile-card-top:has(.quotation-row-action-btn) {
    flex-wrap: wrap;
  }

  .quotation-mobile-dots:has(.quotation-row-action-btn) {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  .quotation-mobile-card-client strong {
    font-size: 13px;
    font-weight: 400;
    line-height: 20.2px;
    color: var(--dash-text);
  }

  .quotation-mobile-card-mid {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
  }

  .quotation-mobile-validity {
    font-size: 13px;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
  }

  .quotation-mobile-amount {
    font-family: var(--font-family-mono);
    font-size: 15px;
    font-weight: 500;
    line-height: 19.5px;
    color: var(--dash-text);
  }

  .quotation-mobile-card-footer {
    font-size: 13px;
    line-height: 18.2px;
    letter-spacing: 0.065px;
    color: var(--dash-muted);
  }

  .quotation-mobile-pagination {
    border-radius: 14px !important;
    border: 1px solid var(--dash-border) !important;
  }

  .quotation-empty-mobile {
    padding: 32px 16px;
    text-align: center;
    color: var(--dash-muted);
    font-size: 14px;
  }
}

/* ==========================================================================
   BULK SELECTION TOOLBAR & HIGHLIGHTS (Nodes 533:53489 / 534:20604)
   ========================================================================== */
.quotation-bulk-toolbar {
  height: 64px;
  padding: 0 16px;
  border-bottom: 1px solid var(--dash-border);
  background: var(--dash-surface);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 14px 14px 0 0;
}

.quotation-bulk-summary {
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  color: var(--dash-text);
  letter-spacing: 0.07px;
}

.quotation-bulk-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.quotation-bulk-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  white-space: nowrap;
}

.quotation-bulk-send {
  background: var(--interactive-default);
  color: #ffffff !important;
  border: none;
}

.quotation-page.dark .quotation-bulk-send,
.quotation-page[data-theme="dark"] .quotation-bulk-send {
  color: #101113 !important;
  font-weight: 600;
}

.quotation-bulk-send:hover {
  background: var(--interactive-pressed);
}

.quotation-bulk-send svg {
  font-size: 16px;
}

.quotation-bulk-deselect {
  background: var(--dash-surface);
  color: var(--dash-text);
  border: 1px solid var(--dash-border-strong);
}

.quotation-bulk-deselect:hover {
  background: var(--dash-surface-2);
}

/* Selected row highlight */
.quotation-table-card tbody tr.is-selected-row,
.quotation-table-card tbody tr.is-selected-row:hover {
  background: var(--success-soft, #f0fdf4);
}

.quotation-page.dark .quotation-table-card tbody tr.is-selected-row,
.quotation-page.dark .quotation-table-card tbody tr.is-selected-row:hover,
.quotation-page[data-theme="dark"]
  .quotation-table-card
  tbody
  tr.is-selected-row,
.quotation-page[data-theme="dark"]
  .quotation-table-card
  tbody
  tr.is-selected-row:hover {
  background: rgba(67, 167, 156, 0.12);
}

/* Selected mobile card highlight */
.quotation-mobile-card.is-selected-card {
  background: var(--success-soft, #f0fdf4);
  border-color: var(--interactive-default);
}

.quotation-page.dark .quotation-mobile-card.is-selected-card,
.quotation-page[data-theme="dark"] .quotation-mobile-card.is-selected-card {
  background: rgba(67, 167, 156, 0.12);
  border-color: var(--interactive-default);
}

/* Mobile toolbar */
.quotation-bulk-toolbar-mobile {
  border-radius: 14px;
  border: 1px solid var(--dash-border);
  margin-bottom: 8px;
}

@media (max-width: 767px) {
  .quotation-bulk-toolbar-mobile {
    height: auto;
    min-height: 52px;
    padding: 12px 16px;
    flex-wrap: wrap;
    row-gap: 10px;
  }
}

/* ==========================================================================
   FILTER ACTION BUTTON
   ========================================================================== */
.quotation-clear-filters-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid var(--dash-border);
  background: var(--dash-surface);
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.quotation-clear-filters-action:hover {
  background: var(--dash-surface-2);
  border-color: var(--dash-border-strong);
}

/* ==========================================================================
   STATE MESSAGE DISPLAYS (Initial Empty, Filtered Empty, Loading)
   Nodes: 533:52988 / 534:20434, 533:53198 / 534:20393, 533:53420 / 534:20372
   ========================================================================== */
.quotation-state-cell {
  height: 320px !important;
  text-align: center !important;
  vertical-align: middle !important;
  padding: 40px 16px !important;
}

.quotation-state-mobile {
  border-radius: 14px;
  border: 1px solid var(--dash-border);
  background: var(--dash-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 32px 16px;
}

.quotation-state-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 520px;
  text-align: center;
}

.quotation-state-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: var(--dash-surface-2);
  border: 1px solid var(--dash-border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: var(--interactive-default);
  margin-bottom: 16px;
}

.quotation-state-message h4 {
  margin: 0 0 8px;
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: var(--dash-text);
}

.quotation-state-message p {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 22px;
  color: var(--dash-muted);
  max-width: 480px;
}

.quotation-clear-filters-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid var(--dash-border-strong);
  background: var(--dash-surface);
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quotation-clear-filters-btn:hover {
  background: var(--dash-surface-2);
}

/* Loading spinner */
.quotation-loading-spinner {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid var(--dash-border);
  border-top-color: var(--interactive-default);
  animation: quotation-spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes quotation-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* ==========================================================================
   SEND QUOTE MODAL DIALOG — Figma Node 574:39806 / 574:41037
   ========================================================================== */
.quotation-dialog-scrim {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(14, 26, 32, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.catalogue-item-modal.quotation-editor-shell {
  background: transparent !important;
}

.quotation-page.dark .quotation-dialog-scrim,
.quotation-page[data-theme="dark"] .quotation-dialog-scrim {
  background: rgba(16, 17, 19, 0.64);
}

.quotation-send-dialog {
  width: 100%;
  max-width: 640px;
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #e8edec);
  border-radius: var(--radius-lg, 14px);
  box-shadow: 0px 6px 16px -4px rgba(14, 26, 32, 0.1),
    0px 1px 2px 0px rgba(14, 26, 32, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: quotation-dialog-appear 0.18s ease-out;
}

@keyframes quotation-dialog-appear {
  from {
    opacity: 0;
    transform: scale(0.97) translateY(4px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.quotation-page.dark .quotation-send-dialog,
.quotation-page[data-theme="dark"] .quotation-send-dialog {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
  box-shadow: 0px 10px 25px -4px rgba(0, 0, 0, 0.5),
    0px 2px 4px 0px rgba(0, 0, 0, 0.3);
}

.quotation-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px 20px;
  border-bottom: 1px solid var(--border-subtle, #e8edec);
}

.quotation-page.dark .quotation-dialog-header,
.quotation-page[data-theme="dark"] .quotation-dialog-header {
  border-bottom-color: var(--border-subtle, #2c3036);
}

.quotation-dialog-header h3 {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quotation-page.dark .quotation-dialog-header h3,
.quotation-page[data-theme="dark"] .quotation-dialog-header h3 {
  color: var(--text-primary, #f2f3f5);
}

.quotation-dialog-close-btn {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md, 10px);
  border: none;
  background: transparent;
  color: var(--dash-muted, #506360);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.quotation-dialog-close-btn:hover {
  background: var(--dash-surface-2, #f4f7f7);
  color: var(--dash-text, #142624);
}

.quotation-page.dark .quotation-dialog-close-btn,
.quotation-page[data-theme="dark"] .quotation-dialog-close-btn {
  color: var(--dash-muted, #b3b8c2);
}

.quotation-page.dark .quotation-dialog-close-btn:hover,
.quotation-page[data-theme="dark"] .quotation-dialog-close-btn:hover {
  background: var(--dash-surface-2, #22252a);
  color: var(--dash-text, #f2f3f5);
}

.quotation-dialog-close-btn svg {
  font-size: 18px;
}

.quotation-dialog-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  max-height: calc(85vh - 140px);
}

.quotation-dialog-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.quotation-dialog-field label {
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
  color: var(--text-primary, #142624);
}

.quotation-page.dark .quotation-dialog-field label,
.quotation-page[data-theme="dark"] .quotation-dialog-field label {
  color: var(--text-primary, #f2f3f5);
}

.quotation-dialog-field input {
  height: 40px;
  width: 100%;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 14px;
  line-height: 21.7px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.quotation-page.dark .quotation-dialog-field input,
.quotation-page[data-theme="dark"] .quotation-dialog-field input {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-dialog-field input:focus {
  border-color: var(--interactive-default, #43a79c);
  box-shadow: none;
}

.quotation-page .quotation-dialog-field input[aria-invalid="true"] {
  border-color: var(--danger-text, #a3301f);
}
.quotation-page .quotation-dialog-field input[aria-invalid="true"]:focus {
  box-shadow: none;
}
.quotation-send-dialog .quotation-field-error {
  margin: 0;
  color: var(--danger-text, #a3301f);
  font: 400 12px/18px var(--font-family-primary, "Lexend", sans-serif);
}
.quotation-send-dialog .quotation-recipient-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2, 8px);
  min-height: 44px;
  padding: var(--space-2, 8px);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 14px/20px var(--font-family-primary, "Lexend", sans-serif);
}
.quotation-send-dialog .quotation-recipient-box:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.quotation-send-dialog .quotation-recipient-box.has-error {
  border-color: var(--danger-text, #a3301f);
}
.quotation-recipient-box .quotation-recipient-chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1, 4px);
  max-width: 100%;
  min-height: 28px;
  padding: 4px 8px;
  border-radius: var(--radius-sm, 6px);
  background: var(--interactive-soft, #f0f8f7);
  color: var(--text-primary, #142624);
  font: inherit;
}
.quotation-recipient-chip > span {
  min-width: 0;
  overflow-wrap: anywhere;
}
.quotation-recipient-box .quotation-recipient-chip--saved {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}
.quotation-send-dialog .quotation-recipient-chip button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.quotation-send-dialog .quotation-recipient-chip button:hover {
  background: var(--surface-tertiary, #e8edec);
}
.quotation-send-dialog .quotation-recipient-chip button:disabled {
  opacity: 0.5;
  cursor: default;
}
.quotation-recipient-chip svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
.quotation-send-dialog
  .quotation-recipient-box
  input.quotation-recipient-entry {
  flex: 1 1 160px;
  width: auto;
  min-width: 0;
  height: 32px;
  padding: 4px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  outline: none;
  box-shadow: none;
}
.quotation-recipient-loading {
  color: var(--text-secondary, #506360);
}
.quotation-page .quotation-notifications {
  position: fixed;
  top: 72px;
  right: 24px;
  z-index: 1200;
  width: 360px;
  max-width: calc(100vw - 32px);
  max-height: 70vh;
  overflow-y: auto;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 12px;
  background: var(--surface-elevated, #fff);
  color: var(--text-primary, #142624);
  box-shadow: var(--elevation-md, 0 6px 16px rgba(14, 26, 32, 0.14));
  font: 400 13px/20px var(--font-family-primary, "Lexend", sans-serif);
}
.quotation-notifications > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.quotation-notifications > header strong {
  font-weight: 500;
}
.quotation-notifications > header button {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.quotation-notifications > button {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  padding: 14px 16px;
  border: 0;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.quotation-notifications > button:hover,
.quotation-notifications > button.is-unread {
  background: var(--interactive-soft, #f0f8f7);
}
.quotation-notifications small {
  color: var(--text-secondary, #506360);
  font-size: 11px;
}
.quotation-notifications > p {
  margin: 0;
  padding: 20px 16px;
  color: var(--text-secondary, #506360);
}
.quotation-recipient-hint {
  color: var(--text-secondary, #506360);
  font: 400 12px/18px var(--font-family-primary, "Lexend", sans-serif);
}
.quotation-send-dialog .quotation-email-preview-cta {
  cursor: default;
}

.quotation-dialog-preview-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.quotation-dialog-preview-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
  color: var(--text-secondary, #506360);
}

.quotation-page.dark .quotation-dialog-preview-heading,
.quotation-page[data-theme="dark"] .quotation-dialog-preview-heading {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-dialog-preview-heading svg {
  font-size: 16px;
}

.quotation-dialog-email-card {
  padding: 20px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-subtle, #e8edec);
  background: var(--surface-secondary, #f4f7f7);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.quotation-page.dark .quotation-dialog-email-card,
.quotation-page[data-theme="dark"] .quotation-dialog-email-card {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-subtle, #2c3036);
}

.quotation-followup-message {
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  border: 1px solid var(--border-subtle, #e8edec);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 14px;
  line-height: 1.55;
  resize: vertical;
}

.quotation-email-greeting {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.quotation-page.dark .quotation-email-greeting,
.quotation-page[data-theme="dark"] .quotation-email-greeting {
  color: var(--text-primary, #f2f3f5);
}

.quotation-email-text {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.quotation-page.dark .quotation-email-text,
.quotation-page[data-theme="dark"] .quotation-email-text {
  color: var(--text-primary, #f2f3f5);
}

.quotation-email-validity {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quotation-page.dark .quotation-email-validity,
.quotation-page[data-theme="dark"] .quotation-email-validity {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-email-preview-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  width: -moz-fit-content;
  width: fit-content;
  -webkit-user-select: none;
          user-select: none;
}

.quotation-approval-success {
  display: flex;
  align-items: center;
  gap: var(--space-2, 8px);
  margin-top: var(--space-2, 8px);
  color: var(--success-text, #115a33);
  font: 600 14px var(--font-family-primary);
}
.quotation-approval-success svg {
  width: 18px;
  height: 18px;
}

.quotation-send-success-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 20px;
  padding: 12px 14px;
  border: 1px solid
    color-mix(in srgb, var(--success-text, #15803d) 28%, transparent);
  border-radius: 10px;
  background: var(--success-soft, #f0fdf4);
  color: var(--success-text, #15803d);
  font: 500 13px/18px var(--font-family-primary);
}

.quotation-send-success-banner > svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
}

.quotation-send-success-banner > span {
  flex: 1 1;
}

.quotation-send-success-banner > button {
  display: grid;
  width: 28px;
  height: 28px;
  padding: 0;
  place-items: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.quotation-send-success-banner > button:hover {
  background: color-mix(in srgb, currentColor 10%, transparent);
}
.quotation-review-dialog.MuiPaper-root {
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
}
.quotation-review-body {
  padding: var(--space-4, 16px);
  overflow-y: auto;
}
.quotation-review-dialog .quotation-modal-header,
.quotation-review-dialog .quotation-modal-footer {
  flex-shrink: 0;
}
.quotation-review-dialog .quotation-preview-details strong {
  overflow-wrap: anywhere;
}
.quotation-review-dialog .quotation-preview-copy p {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.quotation-review-dialog .quotation-preview-table {
  min-width: 720px;
}

.quotation-page.dark .quotation-email-preview-cta,
.quotation-page[data-theme="dark"] .quotation-email-preview-cta,
.quotation-preview-shell.dark .quotation-email-preview-cta {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-email-signoff {
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--text-secondary, #506360);
}

.quotation-email-signoff p {
  margin: 0;
  line-height: 21.7px;
}

.quotation-page.dark .quotation-email-signoff,
.quotation-page[data-theme="dark"] .quotation-email-signoff {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-dialog-delivery-options {
  display: flex;
  align-items: center;
  gap: 24px;
}

.quotation-dialog-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.quotation-dialog-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--interactive-default, #43a79c);
  cursor: pointer;
  margin: 0;
}

.quotation-dialog-checkbox span {
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.quotation-page.dark .quotation-dialog-checkbox span,
.quotation-page[data-theme="dark"] .quotation-dialog-checkbox span {
  color: var(--text-primary, #f2f3f5);
}

.quotation-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-subtle, #e8edec);
  background: var(--surface-primary, #ffffff);
}

.quotation-page.dark .quotation-dialog-footer,
.quotation-page[data-theme="dark"] .quotation-dialog-footer {
  border-top-color: var(--border-subtle, #2c3036);
  background: var(--surface-primary, #191b1f);
}

.quotation-dialog-cancel-btn {
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.quotation-dialog-cancel-btn:hover {
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-page.dark .quotation-dialog-cancel-btn,
.quotation-page[data-theme="dark"] .quotation-dialog-cancel-btn,
.quotation-preview-shell.dark .quotation-dialog-cancel-btn {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-page.dark .quotation-dialog-cancel-btn:hover,
.quotation-page[data-theme="dark"] .quotation-dialog-cancel-btn:hover,
.quotation-preview-shell.dark .quotation-dialog-cancel-btn:hover {
  background: var(--surface-tertiary, #2b2f35);
}

.quotation-dialog-send-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: none;
  background: var(--interactive-default, #43a79c);
  color: #ffffff !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.quotation-page.dark .quotation-dialog-send-btn,
.quotation-page[data-theme="dark"] .quotation-dialog-send-btn {
  color: #101113 !important;
  font-weight: 600;
}

.quotation-dialog-send-btn:hover:not(:disabled) {
  background: var(--interactive-pressed, #36877e);
}

.quotation-dialog-send-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.quotation-dialog-send-btn svg {
  font-size: 16px;
}

@media (max-width: 767px) {
  .quotation-send-dialog {
    max-width: 100%;
    margin: 8px;
  }
  .quotation-dialog-header,
  .quotation-dialog-body,
  .quotation-dialog-footer {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .quotation-dialog-delivery-options {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
  }
}

/* ==========================================================================
   DRAFT QUOTE EDITOR (Create & Edit) — Figma Node 582:37868 / 890:53450
   ========================================================================== */
.quotation-editor-page {
  font-family: var(--font-family-primary);
  display: flex;
  min-height: calc(100vh - 64px);
  background: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
}

.quotation-editor-shell {
  min-height: 100vh;
  background: var(--bg-primary, #f4f7f7);
}

.quotation-editor-main-area {
  min-width: 0;
  background: var(--bg-primary, #f4f7f7);
}

.quotation-editor-page.dark,
.quotation-editor-page[data-theme="dark"] {
  background: var(--bg-primary, #101113);
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-content {
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 auto;
  width: 100%;
}

@media (max-width: 1023px) {
  .quotation-editor-content {
    padding: 24px 20px;
    gap: 20px;
  }
}

@media (max-width: 767px) {
  .quotation-editor-content {
    padding: 16px;
    gap: 20px;
  }
}

/* Header */
.quotation-editor-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.quotation-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  height: 40px;
  padding: 0 12px !important;
  color: var(--text-link, #0f766e);
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  transition: opacity 0.15s ease;
}

.quotation-back-link span {
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: normal !important;
  white-space: nowrap;
}

.quotation-back-link svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.quotation-page.dark .quotation-back-link,
.quotation-editor-page.dark .quotation-back-link,
.quotation-editor-page[data-theme="dark"] .quotation-back-link {
  color: var(--interactive-default, #43a79c);
}

.quotation-back-link:hover {
  text-decoration: underline;
}

.quotation-editor-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-6, 24px);
  flex-wrap: wrap;
}

.quotation-editor-identity {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
  flex: 1 1 auto;
  min-width: 0;
}

.quotation-editor-identity h1 {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: var(--font-size-h1, 32px);
  font-weight: var(--font-weight-semibold, 600);
  line-height: var(--line-height-h1, 1.25);
  letter-spacing: var(--letter-spacing-h1, -0.48px);
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-editor-identity h1,
.quotation-editor-page[data-theme="dark"] .quotation-editor-identity h1 {
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3, 12px);
}

.quotation-draft-status-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 6px;
  border: 0;
  border-radius: var(--radius-pill, 999px);
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
  font-size: 11px;
  font-weight: 500;
  line-height: 14.3px;
  font-style: normal;
  letter-spacing: 0.11px;
  white-space: nowrap;
  flex-shrink: 0;
}

.quotation-meta-docno {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-family-mono);
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.28px;
  text-transform: uppercase;
  color: var(--text-primary, #142624);
  white-space: nowrap;
}

.quotation-editor-page.dark .quotation-meta-docno,
.quotation-editor-page[data-theme="dark"] .quotation-meta-docno {
  color: var(--text-primary, #f2f3f5);
}

.quotation-meta-notsent {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
  white-space: nowrap;
}

.quotation-editor-page.dark .quotation-meta-notsent,
.quotation-editor-page[data-theme="dark"] .quotation-meta-notsent {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-save-indicator {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1, 4px);
  min-height: 21px;
  padding: 2px 8px;
  border: 0;
  border-radius: var(--radius-pill, 999px);
  background: var(--interactive-selected, #dcefec);
  color: var(--interactive-default, #0f766e);
  font-size: 11px;
  font-weight: 400;
  line-height: 15.4px;
  letter-spacing: 0.11px;
  white-space: nowrap;
}

.quotation-editor-header .quotation-save-indicator svg {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.quotation-editor-page.dark .quotation-save-indicator,
.quotation-editor-page[data-theme="dark"] .quotation-save-indicator {
  background: rgba(67, 167, 156, 0.15);
  color: var(--interactive-default, #43a79c);
}

.quotation-editor-header .quotation-save-indicator.unsaved {
  border: 1px solid var(--warning-border, #f9d98f);
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}

.quotation-save-indicator.unsaved i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.quotation-history-link-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  background: transparent;
  border: none;
  border-radius: var(--radius-md, 10px);
  color: var(--interactive-default, #0f766e);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
}

.quotation-history-link-btn:hover {
  background: var(--interactive-hover-soft, #edf8f7);
  text-decoration: none;
}

.quotation-history-link-btn svg,
.quotation-history-link-btn img {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

.quotation-history-link-btn:focus-visible {
  border-radius: 4px;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 3px;
}

.quotation-editor-page.dark .quotation-history-link-btn,
.quotation-editor-page[data-theme="dark"] .quotation-history-link-btn {
  color: var(--interactive-default, #43a79c);
}

.quotation-meta-attribution {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-1, 4px);
  font-size: 13px;
  color: var(--text-secondary, #506360);
  line-height: 18.2px;
  letter-spacing: 0.065px;
  overflow-wrap: anywhere;
}

.quotation-editor-header-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-2, 8px) var(--space-4, 16px);
  padding-top: var(--space-3, 12px);
  border-top: 1px solid var(--border-subtle, #dce3e2);
}

.quotation-editor-header-details strong {
  color: var(--text-primary, #142624);
  font-weight: var(--font-weight-medium, 500);
}

.quotation-editor-page.dark .quotation-meta-attribution,
.quotation-editor-page[data-theme="dark"] .quotation-meta-attribution {
  color: var(--text-secondary, #b3b8c2);
}

/* Header Action Buttons */
.quotation-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.quotation-editor-subtitle {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-2, 8px);
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  overflow-wrap: anywhere;
}

.quotation-editor-page.dark .quotation-draft-status-pill,
.quotation-editor-page[data-theme="dark"] .quotation-draft-status-pill {
  background: var(--surface-tertiary, #2b2f35);
  color: var(--text-secondary, #b3b8c2);
}

.quotation-editor-page.dark .quotation-editor-subtitle,
.quotation-editor-page[data-theme="dark"] .quotation-editor-subtitle {
  color: var(--text-secondary, #b3b8c2);
}

@media (max-width: 1199px) {
  .quotation-editor-title-row {
    align-items: flex-start;
    flex-wrap: wrap;
    overflow: visible;
  }

  .quotation-editor-meta-row {
    flex-wrap: wrap;
    overflow: visible;
  }
}

@media (max-width: 767px) {
  .quotation-editor-identity h1 {
    font-size: var(--font-size-h1, 24px);
    line-height: var(--line-height-h1, 30px);
    letter-spacing: var(--letter-spacing-h1, -0.36px);
  }

  .quotation-header-actions {
    display: none;
  }

  .quotation-editor-header {
    gap: 20px;
  }

  .quotation-back-link {
    height: 44px;
  }

  .quotation-editor-identity {
    gap: 12px;
  }

  .quotation-editor-meta-row {
    align-items: center;
    gap: 12px;
  }

  .quotation-meta-notsent,
  .quotation-meta-attribution {
    flex: 1 0 100%;
    white-space: normal;
  }

  .quotation-meta-notsent {
    order: 4;
  }

  .quotation-meta-attribution {
    order: 5;
  }

  .quotation-history-link-btn {
    order: 6;
    height: 44px;
    margin-left: -12px;
  }

  .quotation-editor-header-details {
    display: none;
  }
}

.quotation-save-draft-action-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quotation-save-draft-action-btn[aria-busy="true"]
  > :not(.quotation-save-draft-spinner) {
  visibility: hidden;
}

.quotation-save-draft-action-btn .quotation-save-draft-spinner {
  position: absolute;
}

.quotation-save-draft-action-btn:hover {
  background: var(--surface-tertiary, #e8edec);
}

.quotation-editor-page.dark .quotation-save-draft-action-btn,
.quotation-editor-page[data-theme="dark"] .quotation-save-draft-action-btn {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-page.dark .quotation-save-draft-action-btn:hover,
.quotation-editor-page[data-theme="dark"]
  .quotation-save-draft-action-btn:hover {
  background: var(--surface-tertiary, #2b2f35);
}

.quotation-send-quote-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: none;
  background: var(--interactive-default, #0f766e);
  color: #ffffff !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quotation-send-quote-action-btn:hover {
  background: var(--interactive-pressed, #0d5f58);
}

.quotation-editor-page.dark .quotation-send-quote-action-btn,
.quotation-editor-page[data-theme="dark"] .quotation-send-quote-action-btn {
  background: var(--interactive-default, #43a79c);
  color: #101113 !important;
  font-weight: 600;
}

/* Two-column layout */
.quotation-editor-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 24px;
  align-items: start;
}

@media (max-width: 1023px) {
  .quotation-editor-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .quotation-editor-layout {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .quotation-totals-sidebar {
    display: contents;
  }

  .quotation-grand-total-card {
    order: -1;
  }

  .quotation-editor-main {
    order: 0;
  }

  .quotation-summary-card {
    order: 1;
  }

  .quotation-sidebar-doc-actions {
    order: 2;
  }

  .quotation-guidance-card {
    order: 3;
  }
}

.quotation-editor-cards-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

/* Form Card */
.quotation-editor-card {
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
}

.quotation-editor-page.dark .quotation-editor-card,
.quotation-editor-page[data-theme="dark"] .quotation-editor-card {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
}

.quotation-editor-card-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quotation-editor-card-header h3 {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-editor-card-header h3,
.quotation-editor-page[data-theme="dark"] .quotation-editor-card-header h3 {
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-card-header p {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-editor-card-header p,
.quotation-editor-page[data-theme="dark"] .quotation-editor-card-header p {
  color: var(--text-secondary, #b3b8c2);
}

/* Form Row & Fields */
.quotation-form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  width: 100%;
}

.quotation-field-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  position: relative;
}

.quotation-field-label-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.quotation-field-wrap > label,
.quotation-field-label-row label,
.quotation-field-label {
  display: block;
  margin: 0;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
  color: var(--text-primary, #142624);
  -webkit-user-select: none;
          user-select: none;
}

.quotation-editor-page.dark .quotation-field-wrap > label,
.quotation-editor-page[data-theme="dark"] .quotation-field-wrap > label,
.quotation-editor-page.dark .quotation-field-label-row label,
.quotation-editor-page[data-theme="dark"] .quotation-field-label-row label,
.quotation-editor-page.dark .quotation-field-label,
.quotation-editor-page[data-theme="dark"] .quotation-field-label,
.quotation-editor-shell.dark .quotation-field-wrap > label,
.quotation-editor-shell.dark .quotation-field-label-row label,
.quotation-editor-shell.dark .quotation-field-label {
  color: var(--text-primary, #f2f3f5);
}

.quotation-auto-generated-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  color: var(--text-tertiary, #6b7b78);
  flex-shrink: 0;
}

.quotation-auto-generated-icon svg {
  width: 12px;
  height: 12px;
  display: block;
}

.quotation-editor-page.dark .quotation-auto-generated-icon,
.quotation-editor-page[data-theme="dark"] .quotation-auto-generated-icon,
.quotation-editor-shell.dark .quotation-auto-generated-icon {
  color: var(--text-tertiary, #828b94);
}

.quotation-field-tag {
  font-size: 12px;
  color: var(--text-secondary, #506360);
}

.quotation-input-box {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  width: 100%;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.quotation-editor-page.dark .quotation-input-box,
.quotation-editor-page[data-theme="dark"] .quotation-input-box {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
}

.quotation-editor-page.dark
  .quotation-quote-date-field
  .figma-datepicker__input-container,
.quotation-editor-page[data-theme="dark"]
  .quotation-quote-date-field
  .figma-datepicker__input-container {
  background-color: var(--surface-primary, #191b1f) !important;
}

.quotation-input-box:focus-within {
  border: 2px solid var(--interactive-default, #0f766e);
  padding-inline: 11px;
  box-shadow: var(--field-focus-ring, 0 0 0 3px rgba(15, 186, 196, 0.22));
}

.quotation-editor-page.dark .quotation-input-box:focus-within,
.quotation-editor-page[data-theme="dark"] .quotation-input-box:focus-within {
  border-color: var(--interactive-default, #43a79c);
  box-shadow: none;
}

.quotation-editor-page
  .quotation-input-box:has(> #quotation-customer-input):focus-within {
  box-shadow: none;
}

.quotation-input-box input,
.quotation-input-box select {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-input-box input,
.quotation-editor-page.dark .quotation-input-box select,
.quotation-editor-page[data-theme="dark"] .quotation-input-box input,
.quotation-editor-page[data-theme="dark"] .quotation-input-box select {
  color: var(--text-primary, #f2f3f5);
}

.quotation-input-box input::placeholder {
  color: var(--text-tertiary, #6b7b78);
}

.quotation-input-box svg {
  color: var(--text-secondary, #506360);
  font-size: 16px;
  flex-shrink: 0;
}

.quotation-editor-page.dark .quotation-input-box svg,
.quotation-editor-page[data-theme="dark"] .quotation-input-box svg {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-input-box.quotation-input-readonly,
.quotation-input-box.disabled {
  background: var(--surface-secondary, #f4f7f7);
  border-color: var(--border-subtle, #dce3e2);
  cursor: default;
}

.quotation-input-box.quotation-input-readonly input,
.quotation-input-box.disabled input {
  color: var(--text-secondary, #506360);
  cursor: default;
  font-size: 13px;
  background: transparent;
}

.quotation-editor-page.dark .quotation-input-box.quotation-input-readonly,
.quotation-editor-page.dark .quotation-input-box.disabled,
.quotation-editor-page[data-theme="dark"]
  .quotation-input-box.quotation-input-readonly,
.quotation-editor-page[data-theme="dark"] .quotation-input-box.disabled,
.quotation-editor-shell.dark .quotation-input-box.quotation-input-readonly,
.quotation-editor-shell.dark .quotation-input-box.disabled {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-subtle, #2c3036);
}

.quotation-editor-page.dark .quotation-input-box.quotation-input-readonly input,
.quotation-editor-page.dark .quotation-input-box.disabled input,
.quotation-editor-page[data-theme="dark"]
  .quotation-input-box.quotation-input-readonly
  input,
.quotation-editor-page[data-theme="dark"] .quotation-input-box.disabled input,
.quotation-editor-shell.dark
  .quotation-input-box.quotation-input-readonly
  input,
.quotation-editor-shell.dark .quotation-input-box.disabled input {
  color: var(--text-secondary, #b3b8c2);
}

/* Combobox Autocomplete Dropdown */
.quotation-autocomplete-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 80;
  background: var(--surface-elevated, #ffffff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  box-shadow: 0 8px 20px rgba(14, 26, 32, 0.12);
  max-height: 260px;
  overflow-y: auto;
  padding: 4px;
}

.quotation-editor-page.dark .quotation-autocomplete-dropdown,
.quotation-editor-page[data-theme="dark"] .quotation-autocomplete-dropdown {
  background: var(--surface-elevated, #25282e);
  border-color: var(--border-default, #3a3f47);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.quotation-autocomplete-item {
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transition: background 0.12s ease;
}

.quotation-autocomplete-item:hover {
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-editor-page.dark .quotation-autocomplete-item:hover,
.quotation-editor-page[data-theme="dark"] .quotation-autocomplete-item:hover {
  background: var(--surface-secondary, #22252a);
}

.quotation-autocomplete-item strong {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-autocomplete-item strong,
.quotation-editor-page[data-theme="dark"] .quotation-autocomplete-item strong {
  color: var(--text-primary, #f2f3f5);
}

.quotation-autocomplete-item span {
  font-size: 12px;
  color: var(--text-secondary, #506360);
}

.quotation-autocomplete-item.quotation-catalogue-option {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding-right: 52px;
  align-items: stretch;
  border: 0;
  background: transparent;
  font-family: var(--font-family-primary);
  text-align: left;
  overflow-wrap: anywhere;
}

.quotation-catalogue-option-row {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
}

.quotation-catalogue-option-edit {
  position: absolute;
  top: 50%;
  right: 4px;
  z-index: 1;
  display: grid;
  width: 36px;
  height: 36px;
  padding: 0;
  transform: translateY(-50%);
  place-items: center;
  border: 1px solid transparent;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.quotation-catalogue-option-edit svg {
  width: 16px;
  height: 16px;
  stroke-width: 1.8;
}

.quotation-catalogue-option-edit:hover,
.quotation-catalogue-option-edit:focus-visible {
  border-color: var(--border-default, #ccd6d4);
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
  outline: none;
}

.quotation-editor-page.dark .quotation-catalogue-option-edit,
.quotation-editor-page[data-theme="dark"] .quotation-catalogue-option-edit,
.invoice-editor-shell.dark .quotation-catalogue-option-edit {
  color: var(--text-secondary, #b7c1bf);
}

.quotation-editor-page.dark .quotation-catalogue-option-edit:hover,
.quotation-editor-page.dark .quotation-catalogue-option-edit:focus-visible,
.quotation-editor-page[data-theme="dark"]
  .quotation-catalogue-option-edit:hover,
.quotation-editor-page[data-theme="dark"]
  .quotation-catalogue-option-edit:focus-visible,
.invoice-editor-shell.dark .quotation-catalogue-option-edit:hover,
.invoice-editor-shell.dark .quotation-catalogue-option-edit:focus-visible {
  border-color: var(--border-default, #3a3f47);
  background: rgba(67, 167, 156, 0.15);
  color: var(--interactive-default, #43a79c);
}

@media (min-width: 481px) and (max-width: 900px) {
  .quotation-autocomplete-item.quotation-catalogue-option {
    padding-right: 56px;
  }

  .quotation-catalogue-option-edit {
    width: 40px;
    height: 40px;
  }
}

.quotation-autocomplete-item.quotation-catalogue-option:hover {
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-autocomplete-item.quotation-catalogue-option > strong {
  align-self: stretch;
  text-align: left;
  font: 500 14px/21.7px var(--font-family-primary);
}

.quotation-catalogue-option:focus-visible {
  outline: 1px solid var(--interactive-default, #0f766e);
  outline-offset: -1px;
}

.quotation-editor-page .quotation-customer-option {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.quotation-customer-option-select {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 0;
  border: 0;
  background: transparent;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.quotation-customer-option-select strong,
.quotation-customer-option-select span {
  max-width: 100%;
  overflow-wrap: anywhere;
}

.quotation-customer-option-actions {
  display: flex;
  flex-shrink: 0;
  margin-left: auto;
  gap: 4px;
}

.quotation-customer-option-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}

.quotation-customer-option-actions button:hover {
  background: var(--surface-primary, #ffffff);
}

.quotation-customer-option-actions button:disabled {
  opacity: 0.5;
  cursor: wait;
}

.quotation-customer-option-actions button:focus-visible,
.quotation-customer-option-select:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

.quotation-customer-option-actions .quotation-customer-delete-action {
  color: var(--danger-text, #c23a2b);
}

.quotation-modal-submit-btn.quotation-customer-delete-confirm {
  background: var(--danger-text, #c23a2b);
  color: #ffffff !important;
}

.quotation-autocomplete-no-match {
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.quotation-autocomplete-no-match strong {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quotation-autocomplete-no-match span {
  font-size: 12px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-autocomplete-no-match strong,
.quotation-editor-page[data-theme="dark"]
  .quotation-autocomplete-no-match
  strong,
.quotation-editor-shell.dark .quotation-autocomplete-no-match strong {
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-page.dark .quotation-autocomplete-no-match span,
.quotation-editor-page[data-theme="dark"] .quotation-autocomplete-no-match span,
.quotation-editor-shell.dark .quotation-autocomplete-no-match span {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-autocomplete-add-action {
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  background: transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.12s ease;
}

.quotation-autocomplete-add-action:hover {
  background: var(--interactive-soft, #dcefec);
}

.quotation-editor-page.dark .quotation-autocomplete-add-action,
.quotation-editor-page[data-theme="dark"] .quotation-autocomplete-add-action {
  color: var(--text-primary, #f2f3f5);
  border-color: var(--border-subtle, #2c3036);
}

.quotation-editor-page.dark .quotation-autocomplete-add-action:hover,
.quotation-editor-page[data-theme="dark"]
  .quotation-autocomplete-add-action:hover {
  background: rgba(67, 167, 156, 0.15);
}

/* Pricing Basis Row (Figma Node 610:77741 — No background, no border) */
.quotation-pricing-basis-row,
.quotation-pricing-basis-bar {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 16px !important;
  width: 100% !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin-bottom: 8px !important;
}

.quotation-pricing-basis-label,
.quotation-pricing-basis-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-pricing-basis-label,
.quotation-editor-page.dark .quotation-pricing-basis-left,
.quotation-editor-page[data-theme="dark"] .quotation-pricing-basis-label,
.quotation-editor-page[data-theme="dark"] .quotation-pricing-basis-left {
  color: var(--text-primary, #f2f3f5);
}

.quotation-pricing-basis-select-wrap,
.quotation-pricing-basis-select-box {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 40px;
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  padding: 0 12px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.quotation-editor-page.dark .quotation-pricing-basis-select-wrap,
.quotation-editor-page.dark .quotation-pricing-basis-select-box,
.quotation-editor-page[data-theme="dark"] .quotation-pricing-basis-select-wrap,
.quotation-editor-page[data-theme="dark"] .quotation-pricing-basis-select-box {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
}

.quotation-pricing-basis-select-wrap:focus-within,
.quotation-pricing-basis-select-box:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}

.quotation-editor-page.dark .quotation-pricing-basis-select-wrap:focus-within,
.quotation-editor-page.dark .quotation-pricing-basis-select-box:focus-within,
.quotation-editor-page[data-theme="dark"]
  .quotation-pricing-basis-select-wrap:focus-within,
.quotation-editor-page[data-theme="dark"]
  .quotation-pricing-basis-select-box:focus-within {
  border-color: var(--interactive-default, #43a79c);
  box-shadow: none;
}

.quotation-pricing-basis-select-wrap select,
.quotation-pricing-basis-select-box select,
.quotation-pricing-basis-select {
  appearance: none;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 400;
  color: var(--text-primary, #142624);
  padding-right: 22px;
  cursor: pointer;
}

.quotation-editor-page.dark .quotation-pricing-basis-select-wrap select,
.quotation-editor-page.dark .quotation-pricing-basis-select-box select,
.quotation-editor-page.dark .quotation-pricing-basis-select,
.quotation-editor-page[data-theme="dark"]
  .quotation-pricing-basis-select-wrap
  select,
.quotation-editor-page[data-theme="dark"]
  .quotation-pricing-basis-select-box
  select,
.quotation-editor-page[data-theme="dark"] .quotation-pricing-basis-select {
  color: var(--text-primary, #f2f3f5);
}

.quotation-pricing-basis-select-wrap svg,
.quotation-pricing-basis-select-box svg {
  position: absolute;
  right: 12px;
  pointer-events: none;
  font-size: 16px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-pricing-basis-select-wrap svg,
.quotation-editor-page.dark .quotation-pricing-basis-select-box svg,
.quotation-editor-page[data-theme="dark"]
  .quotation-pricing-basis-select-wrap
  svg,
.quotation-editor-page[data-theme="dark"]
  .quotation-pricing-basis-select-box
  svg {
  color: var(--text-secondary, #b3b8c2);
}

/* Items Table (Figma Node 610:77737 & 722:28069 — No outer table border) */
.quotation-items-table-wrapper {
  overflow: visible !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.quotation-editor-page.dark .quotation-items-table-wrapper,
.quotation-editor-page[data-theme="dark"] .quotation-items-table-wrapper {
  background: transparent !important;
  border: none !important;
}

.quotation-items-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 720px;
}

.quotation-items-table th {
  height: 40px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.12px;
  color: var(--text-secondary, #506360);
  background: var(--surface-secondary, #f4f7f7);
  text-align: left;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  white-space: nowrap;
}

.quotation-editor-page.dark .quotation-items-table th,
.quotation-editor-page[data-theme="dark"] .quotation-items-table th {
  background: var(--surface-secondary, #22252a);
  color: var(--text-secondary, #b3b8c2);
  border-bottom-color: var(--border-subtle, #2c3036);
}

.quotation-items-table td {
  padding: 12px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  vertical-align: top;
}

.quotation-editor-page.dark .quotation-items-table td,
.quotation-editor-page[data-theme="dark"] .quotation-items-table td {
  border-bottom-color: var(--border-subtle, #2c3036);
}

.quotation-col-item {
  width: 220px;
}
.quotation-col-desc {
  min-width: 180px;
}
.quotation-col-qty {
  width: 80px;
}
.quotation-col-price {
  width: 110px;
}
.quotation-col-tax {
  width: 100px;
}
.quotation-col-total {
  width: 110px;
  text-align: right;
}
.quotation-col-del {
  width: 44px;
  text-align: center;
}

.quotation-cell-input {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s ease;
}

.quotation-editor-page.dark .quotation-cell-input,
.quotation-editor-page[data-theme="dark"] .quotation-cell-input {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-cell-input:focus {
  border-color: var(--interactive-default, #0f766e);
}

.quotation-editor-page.dark .quotation-cell-input:focus,
.quotation-editor-page[data-theme="dark"] .quotation-cell-input:focus {
  border-color: var(--interactive-default, #43a79c);
}

.quotation-cell-amount {
  font-family: var(--font-family-mono);
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary, #142624);
  line-height: 36px;
  text-align: right;
  white-space: nowrap;
}

.quotation-editor-page.dark .quotation-cell-amount,
.quotation-editor-page[data-theme="dark"] .quotation-cell-amount {
  color: var(--text-primary, #f2f3f5);
}

.quotation-cell-delete-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--text-secondary, #506360);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 2px;
  transition: background 0.15s ease, color 0.15s ease;
}

.quotation-cell-delete-btn:hover {
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
}

.quotation-editor-page.dark .quotation-cell-delete-btn:hover,
.quotation-editor-page[data-theme="dark"] .quotation-cell-delete-btn:hover {
  background: var(--danger-soft, #332022);
  color: var(--danger-text, #f3aaa4);
}

.quotation-cell-delete-btn svg {
  font-size: 16px;
}

/* Discount row in cell */
.quotation-line-discount-control {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.quotation-line-discount-control select {
  height: 28px;
  padding: 0 6px;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  outline: none;
}

.quotation-line-discount-control input {
  height: 28px;
  width: 70px;
  padding: 0 6px;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  outline: none;
}

/* Items Actions Bar (Figma Node 610:77737) */
.quotation-items-actions-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-top: 8px;
  flex-wrap: wrap;
}

.quotation-items-buttons-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quotation-action-outline-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4) !important;
  background: var(--surface-primary, #ffffff) !important;
  color: var(--text-primary, #142624) !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: background 0.15s ease;
}

.quotation-action-outline-btn:hover {
  background: var(--surface-tertiary, #e8edec) !important;
}

.quotation-editor-page.dark .quotation-action-outline-btn,
.quotation-editor-page[data-theme="dark"] .quotation-action-outline-btn {
  background: var(--surface-primary, #191b1f) !important;
  border-color: var(--border-default, #3a3f47) !important;
  color: var(--text-primary, #f2f3f5) !important;
}

.quotation-editor-page.dark .quotation-action-outline-btn:hover,
.quotation-editor-page[data-theme="dark"] .quotation-action-outline-btn:hover {
  background: var(--surface-tertiary, #2b2f35) !important;
}

.quotation-action-outline-btn svg {
  font-size: 16px;
}

.quotation-action-link-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--surface-primary, #ffffff) !important;
  border: 1px solid var(--border-default, #cdd6d4) !important;
  border-radius: var(--radius-md, 10px);
  outline: none !important;
  box-shadow: none !important;
  padding: 0 16px !important;
  color: var(--text-primary, #142624) !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  height: 40px;
  transition: opacity 0.15s ease;
}

.quotation-action-link-btn:hover {
  opacity: 0.85;
  text-decoration: none;
}

.quotation-editor-page.dark .quotation-action-link-btn,
.quotation-editor-page[data-theme="dark"] .quotation-action-link-btn {
  color: var(--text-primary, #f2f3f5) !important;
}

.quotation-action-link-btn svg {
  font-size: 16px;
}

.quotation-items-spacer {
  flex: 1 1;
}

.quotation-total-item-discounts-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 36px;
  padding: 0 16px;
  border-radius: 9999px;
  background: var(--surface-secondary, #f4f7f7);
  border: none;
  font-family: var(--font-family-primary);
  font-size: 13px;
  color: var(--text-secondary, #506360);
  margin-left: auto;
}

.quotation-editor-page.dark .quotation-total-item-discounts-badge,
.quotation-editor-page[data-theme="dark"]
  .quotation-total-item-discounts-badge {
  background: var(--surface-secondary, #22252a);
  color: var(--text-secondary, #b3b8c2);
}

.quotation-total-item-discounts-badge strong {
  font-family: var(--font-family-mono);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-total-item-discounts-badge strong,
.quotation-editor-page[data-theme="dark"]
  .quotation-total-item-discounts-badge
  strong {
  color: var(--text-primary, #f2f3f5);
}

.quotation-field-footnote {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-field-footnote,
.quotation-editor-page[data-theme="dark"] .quotation-field-footnote,
.quotation-editor-shell.dark .quotation-field-footnote {
  color: var(--text-secondary, #b3b8c2);
}

/* Notes & Attachments */
.quotation-textarea-box {
  width: 100%;
  min-height: 90px;
  padding: 10px 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 14px;
  line-height: 20px;
  outline: none;
  resize: vertical;
  transition: border-color 0.15s ease;
}

.quotation-editor-page.dark .quotation-textarea-box,
.quotation-editor-page[data-theme="dark"] .quotation-textarea-box {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-textarea-box:focus {
  border-color: var(--interactive-default, #0f766e);
}

.quotation-editor-page.dark .quotation-textarea-box:focus,
.quotation-editor-page[data-theme="dark"] .quotation-textarea-box:focus {
  border-color: var(--interactive-default, #43a79c);
}

#quotation-terms[readonly] {
  border: none;
  background: transparent;
  resize: none;
}

/* Attachments dropzone */
.quotation-attachments-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quotation-dropzone {
  border: 1.5px dashed var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease;
  text-align: center;
}

.quotation-editor-page.dark .quotation-dropzone,
.quotation-editor-page[data-theme="dark"] .quotation-dropzone {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-default, #3a3f47);
}

.quotation-dropzone:hover {
  border-color: var(--interactive-default, #0f766e);
}

.quotation-editor-page.dark .quotation-dropzone:hover,
.quotation-editor-page[data-theme="dark"] .quotation-dropzone:hover {
  border-color: var(--interactive-default, #43a79c);
}

.quotation-dropzone svg {
  font-size: 24px;
  color: var(--interactive-default, #0f766e);
}

.quotation-editor-page.dark .quotation-dropzone svg,
.quotation-editor-page[data-theme="dark"] .quotation-dropzone svg {
  color: var(--interactive-default, #43a79c);
}

.quotation-dropzone p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-dropzone p,
.quotation-editor-page[data-theme="dark"] .quotation-dropzone p {
  color: var(--text-primary, #f2f3f5);
}

.quotation-dropzone span {
  font-size: 12px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-dropzone span,
.quotation-editor-page[data-theme="dark"] .quotation-dropzone span {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-attachments-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.quotation-attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid var(--border-subtle, #dce3e2);
  background: var(--surface-primary, #ffffff);
}

.quotation-editor-page.dark .quotation-attachment-item,
.quotation-editor-page[data-theme="dark"] .quotation-attachment-item {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
}

.quotation-attachment-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-attachment-info,
.quotation-editor-page[data-theme="dark"] .quotation-attachment-info {
  color: var(--text-primary, #f2f3f5);
}

.quotation-attachment-remove-btn {
  background: transparent;
  border: none;
  color: var(--text-secondary, #506360);
  cursor: pointer;
  padding: 4px;
}

.quotation-attachment-remove-btn:hover {
  color: var(--danger-text, #a3301f);
}

/* Sidebar Totals & Review */
.quotation-totals-sidebar {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: sticky;
  top: 88px;
  max-height: calc(100vh - 112px);
  overflow-y: auto;
  overscroll-behavior: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.quotation-totals-sidebar::-webkit-scrollbar {
  display: none;
}

@media (max-width: 1023px) {
  .quotation-totals-sidebar {
    position: static;
    max-height: none;
    overflow-y: visible;
  }
}

.quotation-grand-total-card {
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.quotation-editor-page.dark .quotation-grand-total-card,
.quotation-editor-page[data-theme="dark"] .quotation-grand-total-card {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
}

.quotation-grand-total-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.quotation-grand-total-header span {
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-grand-total-header span,
.quotation-editor-page[data-theme="dark"] .quotation-grand-total-header span {
  color: var(--text-primary, #f2f3f5);
}

.quotation-grand-total-header svg {
  color: var(--interactive-default, #0f766e);
  font-size: 20px;
}

.quotation-editor-page.dark .quotation-grand-total-header svg,
.quotation-editor-page[data-theme="dark"] .quotation-grand-total-header svg {
  color: var(--interactive-default, #43a79c);
}

.quotation-grand-total-headline {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.quotation-grand-total-headline strong {
  font-family: var(--font-family-mono);
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-grand-total-headline strong,
.quotation-editor-page[data-theme="dark"]
  .quotation-grand-total-headline
  strong {
  color: var(--text-primary, #f2f3f5);
}

.quotation-grand-total-headline span {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-grand-total-headline span,
.quotation-editor-page[data-theme="dark"] .quotation-grand-total-headline span {
  color: var(--text-secondary, #b3b8c2);
}

/* Sidebar Document Actions */
.quotation-sidebar-doc-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
}

.quotation-sidebar-download-btn,
.quotation-sidebar-doc-hint {
  grid-column: 1 / -1;
}

.quotation-sidebar-doc-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  padding: 12px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  font-family: var(--font-family-primary);
  font-size: 13px;
  line-height: 20px;
}

.quotation-sidebar-doc-hint > svg {
  flex: 0 0 16px;
  margin-top: 2px;
}

.quotation-sidebar-save-btn,
.quotation-sidebar-preview-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quotation-sidebar-save-btn:hover:not(:disabled),
.quotation-sidebar-preview-btn:hover:not(:disabled) {
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-sidebar-save-btn:disabled,
.quotation-sidebar-preview-btn:disabled,
.quotation-sidebar-download-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quotation-editor-page.dark .quotation-sidebar-save-btn,
.quotation-editor-page[data-theme="dark"] .quotation-sidebar-save-btn,
.quotation-editor-page.dark .quotation-sidebar-preview-btn,
.quotation-editor-page[data-theme="dark"] .quotation-sidebar-preview-btn {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-page.dark .quotation-sidebar-save-btn:hover:not(:disabled),
.quotation-editor-page[data-theme="dark"]
  .quotation-sidebar-save-btn:hover:not(:disabled),
.quotation-editor-page.dark .quotation-sidebar-preview-btn:hover:not(:disabled),
.quotation-editor-page[data-theme="dark"]
  .quotation-sidebar-preview-btn:hover:not(:disabled) {
  background: var(--surface-secondary, #22252a);
}

.quotation-sidebar-download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--interactive-default, #0f766e);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quotation-sidebar-download-btn:hover:not(:disabled) {
  background: var(--interactive-soft, #dcefec);
}

.quotation-editor-page.dark .quotation-sidebar-download-btn,
.quotation-editor-page[data-theme="dark"] .quotation-sidebar-download-btn {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--interactive-default, #43a79c);
}

.quotation-editor-page.dark
  .quotation-sidebar-download-btn:hover:not(:disabled),
.quotation-editor-page[data-theme="dark"]
  .quotation-sidebar-download-btn:hover:not(:disabled) {
  background: rgba(67, 167, 156, 0.15);
}

/* Sidebar Quote Summary Breakdown */
.quotation-summary-card {
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
}

.quotation-editor-page.dark .quotation-summary-card,
.quotation-editor-page[data-theme="dark"] .quotation-summary-card {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
}

.quotation-summary-card h4 {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-summary-card h4,
.quotation-editor-page[data-theme="dark"] .quotation-summary-card h4 {
  color: var(--text-primary, #f2f3f5);
}

.quotation-summary-breakdown-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.quotation-summary-label {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-summary-label,
.quotation-editor-page[data-theme="dark"] .quotation-summary-label {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-summary-value {
  font-family: var(--font-family-mono);
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary, #142624);
  white-space: nowrap;
}

.quotation-editor-page.dark .quotation-summary-value,
.quotation-editor-page[data-theme="dark"] .quotation-summary-value {
  color: var(--text-primary, #f2f3f5);
}

.quotation-summary-divider {
  height: 1px;
  background: var(--border-subtle, #dce3e2);
  width: 100%;
}

.quotation-editor-page.dark .quotation-summary-divider,
.quotation-editor-page[data-theme="dark"] .quotation-summary-divider {
  background: var(--border-subtle, #2c3036);
}

.quotation-summary-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.quotation-summary-total-row .quotation-summary-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark
  .quotation-summary-total-row
  .quotation-summary-label,
.quotation-editor-page[data-theme="dark"]
  .quotation-summary-total-row
  .quotation-summary-label {
  color: var(--text-primary, #f2f3f5);
}

.quotation-summary-total-row .quotation-summary-value {
  font-size: 17px;
  font-weight: 700;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark
  .quotation-summary-total-row
  .quotation-summary-value,
.quotation-editor-page[data-theme="dark"]
  .quotation-summary-total-row
  .quotation-summary-value {
  color: var(--text-primary, #f2f3f5);
}

.quotation-summary-footnote {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 12px;
  line-height: 16.8px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-summary-footnote,
.quotation-editor-page[data-theme="dark"] .quotation-summary-footnote {
  color: var(--text-secondary, #b3b8c2);
}

/* Sidebar Draft Delivery Guidance */
.quotation-guidance-card {
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.quotation-editor-page.dark .quotation-guidance-card,
.quotation-editor-page[data-theme="dark"] .quotation-guidance-card {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
}

.quotation-guidance-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-guidance-header,
.quotation-editor-page[data-theme="dark"] .quotation-guidance-header {
  color: var(--text-primary, #f2f3f5);
}

.quotation-guidance-header svg {
  color: var(--interactive-default, #0f766e);
  font-size: 16px;
}

.quotation-editor-page.dark .quotation-guidance-header svg,
.quotation-editor-page[data-theme="dark"] .quotation-guidance-header svg {
  color: var(--interactive-default, #43a79c);
}

.quotation-guidance-card p {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-guidance-card p,
.quotation-editor-page[data-theme="dark"] .quotation-guidance-card p {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-panel-send-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: none;
  background: var(--interactive-default, #0f766e);
  color: #ffffff !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
  width: 100%;
}

.quotation-panel-send-btn:hover {
  background: var(--interactive-pressed, #0d5f58);
}

.quotation-editor-page.dark .quotation-panel-send-btn,
.quotation-editor-page[data-theme="dark"] .quotation-panel-send-btn {
  background: var(--interactive-default, #43a79c);
  color: #101113 !important;
  font-weight: 600;
}

/* ==========================================================================
   QUICK CREATE MODAL DIALOGS (Customer 835:55403 & Item 722:57203)
   ========================================================================== */
.quotation-modal-dialog {
  width: 100%;
  max-width: 560px;
  background: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #e8edec);
  border-radius: var(--radius-lg, 14px);
  box-shadow: 0px 5px 14px 0px rgba(23, 59, 52, 0.13),
    0px 1px 2px 0px rgba(14, 26, 32, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: quotation-dialog-appear 0.18s ease-out;
}

/* Catalogue item modal — Figma 722:57203 */
.quotation-document-preview {
  position: relative;
  width: min(100%, 900px);
  height: 78vh;
  max-height: min(760px, calc(100dvh - 48px));
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  overflow: hidden;
  outline: none;
}
.quotation-document-preview > img,
.quotation-document-preview > iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  object-fit: contain;
}
.quotation-document-preview > iframe.quotation-document-preview-pdf {
  /* Crop the native PDF viewer's dark outer gutter. */
  width: calc(100% + 16px);
  height: calc(100% + 8px);
  max-width: none;
  margin: -8px -8px 0;
  background: #fff;
}
.quotation-document-preview:has(> iframe.quotation-document-preview-pdf)::after {
  /* Cover the remaining PDF gutter beside the scrollbar. */
  content: "";
  position: absolute;
  top: 0;
  right: 6px;
  bottom: 0;
  width: 10px;
  background: #fff;
  pointer-events: none;
}
.quotation-document-preview-close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 6px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-sm, 6px);
  background: var(--surface-primary, #fff);
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.quotation-document-preview-close:hover {
  color: var(--text-primary, #142624);
  background: var(--surface-secondary, #f4f7f7);
}
.quotation-document-preview-close:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

.quotation-catalogue-modal {
  max-width: 640px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.1),
    0 1px 2px rgba(14, 26, 32, 0.04);
}

.quotation-catalogue-modal .quotation-modal-header {
  padding: 20px 20px 20px 24px;
}

.quotation-catalogue-modal .quotation-modal-body {
  padding: 20px 24px;
  gap: 16px;
}

.quotation-catalogue-modal .quotation-modal-footer {
  padding: 16px 24px 20px;
}

.quotation-catalogue-modal .quotation-modal-cancel-btn,
.quotation-catalogue-modal .quotation-modal-submit-btn {
  padding-inline: 12px;
}

.quotation-catalogue-row {
  display: grid;
  gap: 16px;
  width: 100%;
  align-items: start;
}

.quotation-catalogue-row-three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.quotation-catalogue-row-two {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.quotation-catalogue-row-two > .quotation-field-wrap:first-child {
  grid-column: span 2;
}

.quotation-catalogue-modal .quotation-field-wrap {
  gap: 8px;
  min-width: 0;
}

.quotation-catalogue-modal .quotation-field-wrap > label {
  margin: 0;
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
}

.quotation-catalogue-modal
  .quotation-field-wrap
  > label.quotation-optional-label {
  color: var(--text-secondary, #506360);
}

.quotation-catalogue-modal .quotation-input-box,
.quotation-catalogue-modal .quotation-select-box {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  height: 40px;
  min-width: 0;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
}

.quotation-catalogue-modal .quotation-select-box {
  padding-right: 10px;
  position: relative;
}

.quotation-catalogue-modal .quotation-input-box input,
.quotation-catalogue-modal .quotation-select-box select {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: 0;
  outline: 0;
  appearance: none;
  background: transparent;
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 21.7px;
}

.quotation-catalogue-modal .quotation-input-box input::placeholder {
  color: var(--text-tertiary, #6b7b78);
  opacity: 1;
}

.quotation-catalogue-modal .quotation-select-box svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  pointer-events: none;
  color: var(--text-primary, #142624);
}

.quotation-catalogue-modal .quotation-money-input > span {
  color: var(--text-tertiary, #6b7b78);
  font-family: var(--font-family-primary);
  font-size: 14px;
}

.quotation-catalogue-modal .quotation-money-input input {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 15px;
  font-weight: 500;
}

.quotation-catalogue-modal .quotation-field-disabled {
  opacity: 0.75;
}

.quotation-catalogue-modal .quotation-field-disabled > label {
  color: var(--text-disabled, #8a9896);
}

.quotation-catalogue-modal .quotation-field-disabled .quotation-input-box {
  border-color: var(--border-subtle, #dce3e2);
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-catalogue-modal .quotation-required-star {
  color: var(--danger-default, #c23a2b);
}

.quotation-catalogue-modal .quotation-input-box.quotation-input-error {
  border-color: var(--danger-default, #c23a2b);
}

.quotation-catalogue-modal .quotation-field-error {
  display: block;
  width: 100%;
  margin: -2px 0 0;
  color: var(--danger-default, #c23a2b);
  font-family: var(--font-family-primary);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

/* Reuse the Figma dropdown in compact quotation-editor fields. */
.quotation-custom-dropdown-wrap {
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
}

.quotation-custom-dropdown-wrap .quotation-figma-dropdown,
.quotation-discount-type-wrap .quotation-figma-dropdown {
  height: 40px;
}

.quotation-pricing-basis-select-wrap.quotation-custom-dropdown-wrap {
  width: 164px;
  height: 40px;
}

.quotation-item-details-row
  .quotation-col-gst-select.quotation-custom-dropdown-wrap {
  display: block;
  width: 92px;
  height: 40px;
}

.quotation-item-details-row
  .quotation-col-gst-select.quotation-custom-dropdown-wrap
  .quotation-figma-dropdown-trigger {
  padding-inline: 12px 10px;
}

.quotation-item-details-row
  .quotation-col-gst-select.quotation-custom-dropdown-wrap
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger {
  padding-inline: 11px 9px;
}

.quotation-discount-type-wrap .quotation-figma-dropdown-menu {
  min-width: 148px;
}

.quotation-item-details-row
  .quotation-col-gst-select
  .quotation-figma-dropdown-menu {
  min-width: 92px;
}

/* Ensure open dropdowns float above following rows, discount rows, and card borders */
.quotation-pricing-basis-row:has(.quotation-figma-dropdown.is-open),
.quotation-item-row-card:has(.quotation-figma-dropdown.is-open),
.quotation-item-details-row:has(.quotation-figma-dropdown.is-open),
.quotation-item-discount-row:has(.quotation-figma-dropdown.is-open) {
  position: relative;
  z-index: 120;
}

.quotation-figma-dropdown.is-open {
  position: relative;
  z-index: 120;
}

/* The legacy GST field rule positions every nested SVG absolutely.
   Reset both trigger chevron and option check so flexbox centers them naturally. */
.quotation-item-details-row
  .quotation-col-gst-select
  .quotation-figma-dropdown-trigger
  svg,
.quotation-item-details-row
  .quotation-col-gst-select
  .quotation-figma-dropdown-option
  svg {
  position: static !important;
  right: auto !important;
  top: auto !important;
  transform: none;
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  pointer-events: none;
  transition: transform 0.15s ease;
}

.quotation-item-details-row
  .quotation-col-gst-select
  .quotation-figma-dropdown-option
  svg {
  color: currentColor;
}

.quotation-item-details-row
  .quotation-col-gst-select
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger
  svg {
  transform: rotate(180deg) !important;
}

@media (max-width: 600px) {
  .quotation-catalogue-row-three,
  .quotation-catalogue-row-two {
    grid-template-columns: 1fr;
  }

  .quotation-catalogue-row-two > .quotation-field-wrap:first-child {
    grid-column: auto;
  }

  .quotation-catalogue-modal .quotation-modal-body {
    max-height: calc(100vh - 180px);
  }
}

.quotation-editor-shell.dark .quotation-modal-dialog,
.quotation-editor-shell[data-theme="dark"] .quotation-modal-dialog {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
  box-shadow: 0px 10px 25px -4px rgba(0, 0, 0, 0.5);
}

.quotation-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid var(--border-subtle, #e8edec);
}

.quotation-editor-shell.dark .quotation-modal-header,
.quotation-editor-shell[data-theme="dark"] .quotation-modal-header {
  border-bottom-color: var(--border-subtle, #2c3036);
}

.quotation-modal-header h3 {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quotation-editor-shell.dark .quotation-modal-header h3,
.quotation-editor-shell[data-theme="dark"] .quotation-modal-header h3 {
  color: var(--text-primary, #f2f3f5);
}

.quotation-modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  max-height: calc(85vh - 140px);
}

.quotation-modal-caption {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-shell.dark .quotation-modal-caption,
.quotation-editor-shell[data-theme="dark"] .quotation-modal-caption {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-modal-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
}

@media (max-width: 600px) {
  .quotation-modal-form-row {
    grid-template-columns: 1fr;
  }
}

.quotation-modal-switch-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  cursor: pointer;
}

.quotation-modal-switch-track {
  width: 38px;
  height: 22px;
  border-radius: 999px;
  background: var(--surface-tertiary, #e8edec);
  position: relative;
  transition: background 0.2s ease;
  flex-shrink: 0;
}

.quotation-modal-switch-track.active {
  background: var(--interactive-default, #0f766e);
}

.quotation-editor-shell.dark .quotation-modal-switch-track {
  background: var(--surface-tertiary, #2c3036);
}

.quotation-editor-shell.dark .quotation-modal-switch-track.active {
  background: var(--interactive-default, #43a79c);
}

.quotation-modal-switch-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ffffff;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.quotation-modal-switch-track.active .quotation-modal-switch-thumb {
  transform: translateX(16px);
}

.quotation-modal-switch-label {
  font-family: var(--font-family-primary);
  font-size: 14px;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
  -webkit-user-select: none;
          user-select: none;
}

.quotation-editor-shell.dark .quotation-modal-switch-label,
.quotation-editor-shell[data-theme="dark"] .quotation-modal-switch-label {
  color: var(--text-primary, #f2f3f5);
}

.quotation-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid var(--border-subtle, #e8edec);
}

.quotation-editor-shell.dark .quotation-modal-footer,
.quotation-editor-shell[data-theme="dark"] .quotation-modal-footer {
  border-top-color: var(--border-subtle, #2c3036);
}

.quotation-modal-cancel-btn {
  height: 40px;
  padding: 0 16px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quotation-modal-cancel-btn:hover {
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-editor-shell.dark .quotation-modal-cancel-btn,
.quotation-editor-shell[data-theme="dark"] .quotation-modal-cancel-btn {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-modal-submit-btn {
  height: 40px;
  padding: 0 18px;
  border-radius: var(--radius-md, 10px);
  border: none;
  background: var(--interactive-default, #0f766e);
  color: #ffffff !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quotation-modal-submit-btn:hover {
  background: var(--interactive-pressed, #0d5f58);
}

.quotation-modal-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quotation-editor-shell.dark .quotation-modal-submit-btn,
.quotation-editor-shell[data-theme="dark"] .quotation-modal-submit-btn {
  background: var(--interactive-default, #43a79c);
  color: #101113 !important;
  font-weight: 600;
}

/* ==========================================================================
   FIGMA DRAFT EDITOR LIGHT/DARK & ITEM SEARCH FILTERED RESULTS (Nodes 582:37868 & 722:28011)
   ========================================================================== */

/* Aliases for Editor Header & Column Layout */
.quotation-editor-main {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
  flex: 1 1;
}

.quotation-card-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 0;
}

.quotation-card-header h3 {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-card-header h3,
.quotation-editor-page[data-theme="dark"] .quotation-card-header h3,
.quotation-editor-shell.dark .quotation-card-header h3 {
  color: var(--text-primary, #f2f3f5);
}

.quotation-card-header p {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-card-header p,
.quotation-editor-page[data-theme="dark"] .quotation-card-header p,
.quotation-editor-shell.dark .quotation-card-header p {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-card-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.quotation-customer-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.quotation-quote-settings-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  width: 100%;
}

/* Two-column and three-column row layouts in cards */
.quotation-form-row.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
}

.quotation-form-row.three-col {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  width: 100%;
}

.quotation-form-row.full {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
}

.quotation-combobox-wrap .quotation-input-box svg,
.quotation-quote-settings-row .quotation-figma-dropdown-trigger svg {
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-combobox-wrap .quotation-input-box svg,
.quotation-editor-page[data-theme="dark"]
  .quotation-combobox-wrap
  .quotation-input-box
  svg,
.quotation-editor-shell.dark .quotation-combobox-wrap .quotation-input-box svg,
.quotation-editor-page.dark
  .quotation-quote-settings-row
  .quotation-figma-dropdown-trigger
  svg,
.quotation-editor-page[data-theme="dark"]
  .quotation-quote-settings-row
  .quotation-figma-dropdown-trigger
  svg,
.quotation-editor-shell.dark
  .quotation-quote-settings-row
  .quotation-figma-dropdown-trigger
  svg {
  color: var(--text-secondary, #b3b8c2);
}

@media (max-width: 768px) {
  .quotation-form-row.two-col,
  .quotation-form-row.three-col,
  .quotation-quote-settings-row {
    grid-template-columns: 1fr;
  }
}

/* Items Table Header & Column Titles (Figma Node 610:77747) */
.quotation-items-col-headings,
.quotation-items-table-header {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  height: 40px !important;
  padding: 0 12px !important;
  background: var(--surface-secondary, #f4f7f7) !important;
  border-radius: 6px !important;
  border: none !important;
  font-family: var(--font-family-primary);
  font-size: 13px !important;
  font-weight: 500 !important;
  color: var(--text-secondary, #506360) !important;
  letter-spacing: 0.06px;
  margin-bottom: 4px;
}

.quotation-editor-page.dark .quotation-items-col-headings,
.quotation-editor-page.dark .quotation-items-table-header,
.quotation-editor-page[data-theme="dark"] .quotation-items-col-headings,
.quotation-editor-page[data-theme="dark"] .quotation-items-table-header {
  background: var(--surface-secondary, #22252a) !important;
  border: none !important;
  color: var(--text-secondary, #b3b8c2) !important;
}

.quotation-items-col-headings .quotation-col-item,
.quotation-items-table-header .quotation-col-item {
  flex: 1 0;
  min-width: 0;
}

.quotation-items-col-headings .quotation-col-qty,
.quotation-items-table-header .quotation-col-qty {
  width: 48px;
  text-align: center;
}

.quotation-items-col-headings .quotation-col-price,
.quotation-items-table-header .quotation-col-price {
  width: 104px;
}

.quotation-items-col-headings .quotation-col-gst,
.quotation-items-table-header .quotation-col-gst {
  width: 92px;
}

.quotation-items-col-headings .quotation-col-total,
.quotation-items-table-header .quotation-col-total {
  width: 108px;
  text-align: right;
}

.quotation-items-col-headings .quotation-col-action,
.quotation-items-table-header .quotation-col-action {
  width: 32px;
}

.quotation-items-table-body.is-scrollable {
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: var(--border-strong, #aebab8) transparent;
}

.quotation-items-table-body.is-scrollable::-webkit-scrollbar {
  width: 6px;
}

.quotation-items-table-body.is-scrollable::-webkit-scrollbar-thumb {
  border-radius: var(--radius-pill, 999px);
  background: var(--border-strong, #aebab8);
}

.quotation-items-table-body.is-scrollable:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

/* Individual Item Row Card (Node 582 & 722) */
.quotation-item-row-card,
.quotation-editable-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  width: 100%;
  position: relative;
}

.quotation-editor-page .quotation-items-table-body.is-reordering {
  cursor: grabbing;
  -webkit-user-select: none;
          user-select: none;
}

.quotation-editor-page
  .quotation-items-table-body.is-reordering
  .quotation-item-row-card:not(.is-dragging) {
  transform: translate3d(0, var(--quotation-row-shift-y, 0px), 0);
  transition: transform 180ms cubic-bezier(0.2, 0, 0, 1), box-shadow 180ms ease,
    background-color 180ms ease;
}

.quotation-editor-page.quotation-item-drag-layer {
  position: fixed;
  z-index: 10000;
  inset: 0;
  display: block;
  width: 100vw;
  height: 100vh;
  min-height: 0;
  overflow: visible !important;
  background: transparent !important;
  pointer-events: none;
}

.quotation-editor-page.dark .quotation-item-row-card,
.quotation-editor-page.dark .quotation-editable-item,
.quotation-editor-page[data-theme="dark"] .quotation-item-row-card,
.quotation-editor-page[data-theme="dark"] .quotation-editable-item {
  border-bottom-color: var(--border-subtle, #2c3036);
}

.quotation-item-row-card:last-child,
.quotation-editable-item:last-child {
  border-bottom: none;
}

/* Row 1: Item Name Combobox */
.quotation-editor-page .quotation-item-drag-handle {
  display: inline-grid;
  flex: 0 0 24px;
  width: 24px;
  height: 32px;
  padding: 0;
  place-items: center;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-secondary);
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}
.quotation-editor-page .quotation-item-drag-handle:active {
  cursor: grabbing;
}
.quotation-editor-page
  .quotation-item-row-card.is-dragging
  .quotation-item-drag-handle {
  background: var(--interactive-soft, #e6f4f2);
  color: var(--interactive-default, #0f766e);
  cursor: grabbing;
}
.quotation-editor-page
  .quotation-item-row-card.is-dragging
  .quotation-item-drag-handle
  svg {
  animation: quotation-drag-handle-pulse 700ms ease-in-out infinite alternate;
}
.quotation-editor-page .quotation-item-drag-handle:focus-visible {
  outline: 2px solid var(--interactive-default);
  outline-offset: 2px;
}
.quotation-editor-page .quotation-item-drag-handle:disabled {
  cursor: default;
  opacity: 0.4;
}
.quotation-editor-page
  .quotation-item-row-card.is-dragging:not(.quotation-item-drag-preview) {
  background: var(--interactive-soft, #e6f4f2);
  box-shadow: none;
  opacity: 0.2;
  outline: 2px dashed var(--interactive-default, #0f766e);
  outline-offset: -2px;
}
.quotation-editor-page .quotation-item-row-card.quotation-item-drag-preview {
  position: fixed !important;
  z-index: 1;
  box-sizing: border-box;
  margin: 0;
  padding-inline: var(--space-3, 12px);
  overflow: visible !important;
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #ffffff);
  box-shadow: 0 18px 36px rgba(14, 38, 36, 0.18),
    0 4px 10px rgba(14, 38, 36, 0.12);
  opacity: 0.98;
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: -2px;
  transform: translate3d(
      var(--quotation-drag-offset-x, 0px),
      var(--quotation-drag-offset-y, 0px),
      0
    )
    scale(1.012);
  transition: background-color 140ms ease, box-shadow 140ms ease,
    opacity 140ms ease, outline-color 140ms ease;
  will-change: transform;
  animation: quotation-item-drag-lift 160ms ease-out;
  pointer-events: none;
}
.quotation-editor-page .quotation-item-row-card.quotation-item-drag-preview * {
  pointer-events: none !important;
}
.quotation-editor-page .quotation-item-row-card.drop-before {
  background: var(--interactive-soft, #e6f4f2);
  box-shadow: inset 0 3px 0 var(--interactive-default);
}
.quotation-editor-page .quotation-item-row-card.drop-after {
  background: var(--interactive-soft, #e6f4f2);
  box-shadow: inset 0 -3px 0 var(--interactive-default);
}

.quotation-editor-page.dark
  .quotation-item-row-card.quotation-item-drag-preview,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-row-card.quotation-item-drag-preview {
  background: var(--surface-elevated, #25282e);
  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.48), 0 4px 12px rgba(0, 0, 0, 0.34);
}

@keyframes quotation-item-drag-lift {
  from {
    opacity: 0.72;
    filter: saturate(0.8);
  }
  to {
    opacity: 0.98;
    filter: saturate(1);
  }
}

@keyframes quotation-drag-handle-pulse {
  from {
    transform: scale(0.92);
  }
  to {
    transform: scale(1.08);
  }
}

@media (prefers-reduced-motion: reduce) {
  .quotation-editor-page .quotation-item-row-card,
  .quotation-editor-page .quotation-item-drag-handle svg {
    animation: none !important;
    transition: none !important;
  }
}

.quotation-item-search-row {
  width: 100%;
  position: relative;
}

.quotation-item-search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  width: 100%;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.quotation-editor-page.dark .quotation-item-search-box,
.quotation-editor-page[data-theme="dark"] .quotation-item-search-box {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
}

.quotation-item-search-box:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}

.quotation-editor-page.dark .quotation-item-search-box:focus-within,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-search-box:focus-within {
  border-color: var(--interactive-default, #43a79c);
  box-shadow: none;
}

.quotation-item-search-box svg {
  color: var(--text-secondary, #506360);
  font-size: 16px;
  flex-shrink: 0;
}

.quotation-item-search-toggle {
  display: inline-grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  padding: 0;
  place-items: center;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}

.quotation-item-search-toggle:hover {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}

.quotation-item-search-toggle:hover svg {
  color: currentColor;
}

.quotation-item-search-toggle:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 1px;
}

.quotation-item-search-toggle svg {
  transition: transform 0.15s ease;
}

.quotation-item-search-toggle[aria-expanded="true"] svg {
  transform: rotate(180deg);
}

.quotation-item-search-row:has(.quotation-item-search-dropdown)
  .quotation-item-search-toggle
  svg {
  transform: rotate(180deg);
}

.quotation-editor-page.dark .quotation-item-search-toggle:hover,
.quotation-editor-page[data-theme="dark"] .quotation-item-search-toggle:hover {
  background: var(--surface-secondary, #22252a);
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-page.dark .quotation-item-search-box svg,
.quotation-editor-page[data-theme="dark"] .quotation-item-search-box svg {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-item-search-box input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-primary);
  font-size: 14px;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-item-search-box input,
.quotation-editor-page[data-theme="dark"] .quotation-item-search-box input {
  color: var(--text-primary, #f2f3f5);
}

.quotation-item-search-box input::placeholder {
  color: var(--text-secondary, #6b7b78);
}

/* Row 2: Details Row (Description, Qty, Unit Price, GST, Line Total, Trash) */
.quotation-item-details-row,
.quotation-item-main-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.quotation-item-details-row .quotation-col-desc,
.quotation-item-main-row .quotation-item-field-desc {
  flex: 1 0;
  min-width: 0;
}

.quotation-item-details-row .quotation-col-desc input,
.quotation-item-main-row .quotation-item-field-desc input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-subtle, #dce3e2);
  background: var(--surface-primary, #ffffff);
  font-family: var(--font-family-primary);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-primary, #142624);
  outline: none;
  transition: border-color 0.15s ease;
}

.quotation-editor-page.dark
  .quotation-item-details-row
  .quotation-col-desc
  input,
.quotation-editor-page.dark
  .quotation-item-main-row
  .quotation-item-field-desc
  input,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-details-row
  .quotation-col-desc
  input,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-main-row
  .quotation-item-field-desc
  input {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
  color: var(--text-primary, #f2f3f5);
}

.quotation-item-details-row .quotation-col-desc input::placeholder,
.quotation-item-main-row .quotation-item-field-desc input::placeholder {
  color: var(--text-disabled, #8a9896);
}

.quotation-item-details-row .quotation-col-desc input:focus,
.quotation-item-main-row .quotation-item-field-desc input:focus {
  border-color: var(--interactive-default, #0f766e);
}

.quotation-item-details-row .quotation-col-qty-input,
.quotation-item-main-row .quotation-item-field-qty {
  width: 48px;
  flex-shrink: 0;
}

.quotation-item-details-row .quotation-col-qty-input input,
.quotation-item-main-row .quotation-item-field-qty input {
  width: 100%;
  height: 40px;
  padding: 0 8px;
  text-align: center;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--text-primary, #142624);
  outline: none;
}

.quotation-editor-page.dark
  .quotation-item-details-row
  .quotation-col-qty-input
  input,
.quotation-editor-page.dark
  .quotation-item-main-row
  .quotation-item-field-qty
  input,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-details-row
  .quotation-col-qty-input
  input,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-main-row
  .quotation-item-field-qty
  input {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-item-details-row .quotation-col-price-input,
.quotation-item-main-row .quotation-item-field-price {
  width: 104px;
  flex-shrink: 0;
}

.quotation-item-details-row .quotation-col-price-input input,
.quotation-item-main-row .quotation-item-field-price input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  font-family: var(--font-family-mono);
  font-size: 14px;
  color: var(--text-primary, #142624);
  outline: none;
}

.quotation-editor-page.dark
  .quotation-item-details-row
  .quotation-col-price-input
  input,
.quotation-editor-page.dark
  .quotation-item-main-row
  .quotation-item-field-price
  input,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-details-row
  .quotation-col-price-input
  input,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-main-row
  .quotation-item-field-price
  input {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-item-details-row .quotation-col-gst-select,
.quotation-item-main-row .quotation-item-field-gst {
  width: 92px;
  height: 40px;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  padding: 0 8px;
}

.quotation-editor-page.dark
  .quotation-item-details-row
  .quotation-col-gst-select,
.quotation-editor-page.dark .quotation-item-main-row .quotation-item-field-gst,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-details-row
  .quotation-col-gst-select,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-main-row
  .quotation-item-field-gst {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
}

.quotation-item-details-row .quotation-col-gst-select select,
.quotation-item-main-row .quotation-item-field-gst select {
  width: 100%;
  height: 100%;
  padding-right: 20px;
  border: none !important;
  background: transparent !important;
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--text-primary, #142624);
  outline: none;
  cursor: pointer;
  appearance: none;
}

.quotation-editor-page.dark
  .quotation-item-details-row
  .quotation-col-gst-select
  select,
.quotation-editor-page.dark
  .quotation-item-main-row
  .quotation-item-field-gst
  select,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-details-row
  .quotation-col-gst-select
  select,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-main-row
  .quotation-item-field-gst
  select {
  color: var(--text-primary, #f2f3f5);
}

.quotation-item-details-row
  .quotation-col-gst-select:not(.quotation-custom-dropdown-wrap)
  svg,
.quotation-item-main-row .quotation-item-field-gst svg {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--text-secondary, #506360);
  font-size: 16px;
}

.quotation-editor-page.dark
  .quotation-item-details-row
  .quotation-col-gst-select
  svg,
.quotation-editor-page.dark
  .quotation-item-main-row
  .quotation-item-field-gst
  svg,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-details-row
  .quotation-col-gst-select
  svg,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-details-row
  .quotation-col-gst-select
  svg {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-item-details-row .quotation-col-line-total,
.quotation-item-main-row .quotation-item-cell-line-total {
  width: 108px;
  min-width: 0;
  min-height: 40px;
  height: auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: var(--space-2, 8px) 10px;
  background: var(--surface-secondary, #f4f7f7);
  border-radius: var(--radius-md, 10px);
  font-family: var(--font-family-mono);
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary, #142624);
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: right;
  flex-shrink: 0;
}

.quotation-item-details-row .quotation-col-line-total > span,
.quotation-item-main-row .quotation-item-cell-line-total > span {
  min-width: 0;
  max-width: 100%;
}

.quotation-editor-page.dark
  .quotation-item-details-row
  .quotation-col-line-total,
.quotation-editor-page.dark
  .quotation-item-main-row
  .quotation-item-cell-line-total,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-details-row
  .quotation-col-line-total,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-main-row
  .quotation-item-cell-line-total {
  background: var(--surface-secondary, #22252a);
  color: var(--text-primary, #f2f3f5);
}

.quotation-item-details-row .quotation-col-row-action,
.quotation-item-main-row .quotation-item-cell-remove {
  width: 32px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.quotation-item-remove-btn {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md, 10px);
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  color: var(--text-secondary, #506360);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s ease;
  padding: 0 !important;
}

.quotation-item-remove-btn:hover {
  color: var(--text-primary, #142624);
  background: transparent !important;
}

.quotation-editor-page.dark .quotation-item-remove-btn,
.quotation-editor-page[data-theme="dark"] .quotation-item-remove-btn {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-editor-page.dark .quotation-item-remove-btn:hover,
.quotation-editor-page[data-theme="dark"] .quotation-item-remove-btn:hover {
  color: #f2f3f5;
  background: transparent !important;
}

.quotation-item-remove-btn svg {
  font-size: inherit;
}

.quotation-item-remove-btn span {
  display: none;
}

/* Row 3: Discount Row */
.quotation-item-discount-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.quotation-total-discounts {
  display: flex;
  align-items: center;
  gap: var(--space-5, 20px);
  padding: var(--space-1, 4px) var(--space-3, 12px);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-xl, 20px);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  white-space: nowrap;
}

.quotation-total-discounts span {
  font-size: 11px;
  font-weight: 500;
  line-height: 14.3px;
  letter-spacing: 0.11px;
}

.quotation-total-discounts strong {
  color: var(--text-primary, #142624);
  font-family: var(--font-family-mono);
  font-size: 15px;
  font-weight: 500;
  line-height: 19.5px;
}

.quotation-discount-type-wrap,
.quotation-account-wrap,
.quotation-item-field-disc-type {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 148px;
}

.quotation-discount-type-wrap label,
.quotation-account-wrap label,
.quotation-item-field-disc-type label {
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-discount-type-wrap label,
.quotation-editor-page.dark .quotation-account-wrap label,
.quotation-editor-page.dark .quotation-item-field-disc-type label,
.quotation-editor-page[data-theme="dark"] .quotation-discount-type-wrap label,
.quotation-editor-page[data-theme="dark"] .quotation-account-wrap label,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-field-disc-type
  label {
  color: var(--text-primary, #f2f3f5);
}

.quotation-discount-type-wrap .quotation-select-box,
.quotation-account-wrap .quotation-select-box,
.quotation-item-field-disc-type .quotation-select-input-container {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  position: relative;
}

.quotation-editor-page.dark .quotation-discount-type-wrap .quotation-select-box,
.quotation-editor-page.dark .quotation-account-wrap .quotation-select-box,
.quotation-editor-page.dark
  .quotation-item-field-disc-type
  .quotation-select-input-container,
.quotation-editor-page[data-theme="dark"]
  .quotation-discount-type-wrap
  .quotation-select-box,
.quotation-editor-page[data-theme="dark"]
  .quotation-account-wrap
  .quotation-select-box,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-field-disc-type
  .quotation-select-input-container {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
}

.quotation-discount-type-wrap select,
.quotation-account-wrap select,
.quotation-item-field-disc-type select {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--text-primary, #142624);
  appearance: none;
  cursor: pointer;
}

.quotation-editor-page.dark .quotation-discount-type-wrap select,
.quotation-editor-page.dark .quotation-item-field-disc-type select,
.quotation-editor-page[data-theme="dark"] .quotation-discount-type-wrap select,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-field-disc-type
  select {
  color: var(--text-primary, #f2f3f5);
}

.quotation-discount-type-wrap .quotation-select-box svg,
.quotation-item-field-disc-type .quotation-select-input-container svg {
  color: var(--text-secondary, #506360);
  font-size: 16px;
  pointer-events: none;
}

.quotation-discount-val-wrap,
.quotation-item-field-disc-val {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 148px;
}

.quotation-discount-val-wrap label,
.quotation-item-field-disc-val label {
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
  color: var(--text-primary, #142624);
}

.quotation-discount-val-wrap.disabled,
.quotation-item-field-disc-val.disabled {
  opacity: 0.65;
}

.quotation-discount-val-wrap.disabled label,
.quotation-item-field-disc-val.disabled label {
  color: var(--text-disabled, #8a9896);
}

.quotation-discount-val-wrap .quotation-input-box,
.quotation-item-field-disc-val .quotation-input-container {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
}

.quotation-discount-val-wrap.disabled .quotation-input-box,
.quotation-item-field-disc-val.disabled .quotation-input-container {
  background: var(--surface-secondary, #f4f7f7);
  border-color: var(--border-subtle, #dce3e2);
}

.quotation-editor-page.dark .quotation-discount-val-wrap .quotation-input-box,
.quotation-editor-page.dark
  .quotation-item-field-disc-val
  .quotation-input-container,
.quotation-editor-page[data-theme="dark"]
  .quotation-discount-val-wrap
  .quotation-input-box,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-field-disc-val
  .quotation-input-container {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
}

.quotation-editor-page.dark
  .quotation-discount-val-wrap.disabled
  .quotation-input-box,
.quotation-editor-page.dark
  .quotation-item-field-disc-val.disabled
  .quotation-input-container,
.quotation-editor-page[data-theme="dark"]
  .quotation-discount-val-wrap.disabled
  .quotation-input-box,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-field-disc-val.disabled
  .quotation-input-container {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-subtle, #2c3036);
}

.quotation-discount-val-wrap input,
.quotation-item-field-disc-val input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-mono);
  font-size: 14px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-discount-val-wrap input,
.quotation-editor-page.dark .quotation-item-field-disc-val input,
.quotation-editor-page[data-theme="dark"] .quotation-discount-val-wrap input,
.quotation-editor-page[data-theme="dark"] .quotation-item-field-disc-val input {
  color: var(--text-primary, #f2f3f5);
}

/* ==========================================================================
   ITEM SEARCH DROPDOWN (FIGMA NODE 722:28011)
   ========================================================================== */
.quotation-item-search-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 95;
  background: var(--surface-elevated, #ffffff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  box-shadow: 0px 6px 16px -4px rgba(14, 26, 32, 0.1),
    0px 1px 2px 0px rgba(14, 26, 32, 0.04);
  overflow: hidden;
}

.quotation-editor-page.dark .quotation-item-search-dropdown,
.quotation-editor-page[data-theme="dark"] .quotation-item-search-dropdown {
  background: var(--surface-elevated, #25282e);
  border-color: var(--border-default, #3a3f47);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);
}

.quotation-item-search-results-list {
  padding: 4px;
  max-height: 250px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: var(--border-strong, #aebab8) transparent;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.quotation-item-search-results-list::-webkit-scrollbar {
  width: 6px;
}

.quotation-item-search-results-list::-webkit-scrollbar-track {
  background: transparent;
}

.quotation-item-search-results-list::-webkit-scrollbar-thumb {
  border-radius: var(--radius-pill, 999px);
  background: var(--border-strong, #aebab8);
}

.quotation-item-result-card {
  width: 100%;
  padding: 8px;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transition: background 0.12s ease;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
}

.quotation-new-item-option {
  margin: 4px;
  width: calc(100% - 8px);
  padding: 10px 12px;
  gap: 3px;
  border: 0;
  background: transparent;
  color: var(--text-primary, #142624);
}

.quotation-new-item-option .quotation-item-result-name {
  font-weight: 600;
}

.quotation-new-item-option .quotation-match-icon {
  width: 18px;
  height: 18px;
}

.quotation-editor-page.dark .quotation-new-item-option,
.quotation-editor-page[data-theme="dark"] .quotation-new-item-option {
  border: 0;
  background: transparent;
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-page
  .quotation-item-search-results-list
  .quotation-new-item-option
  .quotation-item-result-name,
.quotation-editor-page
  .quotation-item-search-results-list
  .quotation-new-item-option
  .quotation-item-result-name-group
  .quotation-match-icon {
  color: inherit;
}

.quotation-item-result-card:hover,
.quotation-item-result-card.selected {
  background: var(--interactive-soft, #f0f8f7);
}

.quotation-editor-page.dark .quotation-item-result-card:hover,
.quotation-editor-page.dark .quotation-item-result-card.selected,
.quotation-editor-page[data-theme="dark"] .quotation-item-result-card:hover,
.quotation-editor-page[data-theme="dark"] .quotation-item-result-card.selected {
  background: rgba(67, 167, 156, 0.15);
}

.quotation-item-result-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.quotation-item-result-name-group {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.quotation-item-result-name-group .quotation-match-icon {
  width: 14px;
  height: 14px;
  color: var(--interactive-default, #0f766e);
}

.quotation-editor-page.dark
  .quotation-item-result-name-group
  .quotation-match-icon,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-result-name-group
  .quotation-match-icon {
  color: var(--interactive-default, #43a79c);
}

.quotation-item-result-name {
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--interactive-default, #0f766e);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quotation-editor-page.dark .quotation-item-result-name,
.quotation-editor-page[data-theme="dark"] .quotation-item-result-name {
  color: var(--interactive-default, #43a79c);
}

.quotation-item-result-price-group {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.quotation-item-result-gst-label {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-tertiary, #6b7b78);
}

.quotation-editor-page.dark .quotation-item-result-gst-label,
.quotation-editor-page[data-theme="dark"] .quotation-item-result-gst-label {
  color: var(--text-tertiary, #959fa8);
}

.quotation-item-result-price {
  font-family: var(--font-family-mono);
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  color: var(--interactive-default, #0f766e);
}

.quotation-editor-page.dark .quotation-item-result-price,
.quotation-editor-page[data-theme="dark"] .quotation-item-result-price {
  color: var(--interactive-default, #43a79c);
}

.quotation-item-result-sub {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--interactive-default, #0f766e);
  opacity: 0.75;
}

.quotation-editor-page.dark .quotation-item-result-sub,
.quotation-editor-page[data-theme="dark"] .quotation-item-result-sub {
  color: var(--interactive-default, #43a79c);
  opacity: 0.85;
}

:is(.quotation-editor-page, .invoice-editor-shell)
  .quotation-item-search-results-list
  .quotation-new-item-option:hover {
  background: var(--surface-secondary);
}

:is(.quotation-editor-page, .invoice-editor-shell)
  .quotation-item-search-results-list
  .quotation-new-item-option
  .quotation-item-result-sub {
  color: var(--text-secondary);
  opacity: 1;
}

.quotation-item-search-divider {
  height: 1px;
  background: var(--border-subtle, #dce3e2);
  width: 100%;
}

.quotation-editor-page.dark .quotation-item-search-divider,
.quotation-editor-page[data-theme="dark"] .quotation-item-search-divider {
  background: var(--border-subtle, #2c3036);
}

.quotation-item-search-footer-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  width: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--interactive-default, #0f766e);
  transition: background 0.12s ease;
}

.quotation-item-search-footer-btn:hover {
  background: var(--interactive-soft, #f0f8f7);
}

.quotation-editor-page.dark .quotation-item-search-footer-btn,
.quotation-editor-page[data-theme="dark"] .quotation-item-search-footer-btn {
  color: var(--interactive-default, #43a79c);
}

.quotation-editor-page.dark .quotation-item-search-footer-btn:hover,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-search-footer-btn:hover {
  background: rgba(67, 167, 156, 0.15);
}

.quotation-item-search-footer-btn svg {
  width: 16px;
  height: 16px;
  color: var(--interactive-default, #0f766e);
}

.quotation-editor-page.dark .quotation-item-search-footer-btn svg,
.quotation-editor-page[data-theme="dark"]
  .quotation-item-search-footer-btn
  svg {
  color: var(--interactive-default, #43a79c);
}

/* Editors share column tracks so headings and fields keep the same bounds. */
@media (min-width: 768px) {
  .document-items-aligned {
    --document-item-columns: minmax(0, 4fr) minmax(40px, 0.5fr) minmax(72px, 1fr)
      minmax(76px, 0.8fr) 96px 32px;
  }

  .document-items-aligned .quotation-items-table-header,
  .document-items-aligned .quotation-item-details-row {
    display: grid !important;
    grid-template-columns: var(--document-item-columns);
    column-gap: 8px;
    align-items: start;
  }

  .document-items-aligned .quotation-items-table-header {
    align-items: center !important;
    padding-inline: 0 !important;
  }

  .document-items-aligned:has(> .quotation-items-table-body.is-scrollable)
    .quotation-items-table-header {
    overflow-y: hidden;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
  }

  .document-items-aligned .quotation-items-table-body.is-scrollable {
    scrollbar-gutter: stable;
  }

  .document-items-aligned .quotation-items-table-header::-webkit-scrollbar {
    width: 6px;
  }

  .document-items-aligned .quotation-items-table-header > div,
  .document-items-aligned .quotation-item-details-row > div {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .document-items-aligned .quotation-items-table-header
    :is(.quotation-col-item, .quotation-col-price, .quotation-col-gst) {
    padding-left: 12px;
  }

  .document-items-aligned .quotation-items-table-header .quotation-col-total {
    padding-right: 10px;
  }

  .quotation-item-row-card.document-items-aligned {
    display: grid;
    grid-template-columns: var(--document-item-columns);
    align-items: start;
  }

  .quotation-item-row-card.document-items-aligned > .quotation-item-search-row {
    grid-column: 1;
    grid-row: 1;
    min-width: 0;
  }

  .quotation-item-row-card.document-items-aligned .quotation-item-search-box {
    gap: var(--space-1, 4px);
    padding-inline: var(--space-2, 8px);
  }

  .quotation-item-row-card.document-items-aligned > .quotation-item-details-row {
    display: contents !important;
  }

  .document-items-aligned .quotation-item-details-row > .quotation-col-desc {
    grid-column: 1;
    grid-row: 2;
  }

  .document-items-aligned .quotation-item-details-row
    > :is(.quotation-col-qty-input, .quotation-col-price-input,
      .quotation-col-gst-select, .quotation-col-line-total, .quotation-col-row-action) {
    grid-row: 1;
  }

  .document-items-aligned .quotation-item-details-row > .quotation-col-qty-input {
    grid-column: 2;
  }

  .document-items-aligned .quotation-item-details-row > .quotation-col-price-input {
    grid-column: 3;
  }

  .document-items-aligned .quotation-item-details-row > .quotation-col-gst-select {
    grid-column: 4;
    width: 100%;
  }

  .document-items-aligned .quotation-item-details-row > .quotation-col-line-total {
    grid-column: 5;
    justify-self: end;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
  }

  .document-items-aligned .quotation-item-details-row > .quotation-col-row-action {
    grid-column: 6;
  }

  .quotation-item-row-card.document-items-aligned > .quotation-item-discount-row {
    grid-column: 1 / -1;
    grid-row: 3;
  }
}

/* Responsive items and pricing layout */
@media (max-width: 767px) {
  .quotation-editor-card {
    padding: 16px;
    gap: 16px;
  }

  .quotation-editor-main {
    gap: 20px;
  }

  .quotation-card-header h3,
  .quotation-grand-total-header span,
  .quotation-summary-card h4 {
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: -0.08px;
  }

  .quotation-grand-total-card,
  .quotation-summary-card,
  .quotation-guidance-card {
    padding: 16px;
  }

  .quotation-grand-total-headline strong {
    font-size: 20px;
    line-height: 24px;
  }

  .quotation-card-body,
  .quotation-items-table-body,
  .quotation-item-row-card {
    min-width: 0;
  }

  .quotation-items-table-header {
    display: none !important;
  }

  .quotation-item-row-card {
    gap: 12px;
    padding: 16px 0;
  }

  .quotation-item-details-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    align-items: end;
  }

  .quotation-item-details-row > [data-label] {
    position: relative;
    width: 100%;
    min-width: 0;
    margin-top: 22px;
  }

  .quotation-item-details-row > [data-label]::before {
    content: attr(data-label);
    position: absolute;
    bottom: calc(100% + 6px);
    left: 0;
    color: var(--text-secondary, #506360);
    font-family: var(--font-family-primary);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }

  .quotation-editor-page.dark
    .quotation-item-details-row
    > [data-label]::before,
  .quotation-editor-page[data-theme="dark"]
    .quotation-item-details-row
    > [data-label]::before {
    color: var(--text-secondary, #b3b8c2);
  }

  .quotation-item-details-row .quotation-col-desc {
    grid-column: 1 / -1;
  }

  .quotation-item-details-row .quotation-col-qty-input,
  .quotation-item-details-row .quotation-col-price-input,
  .quotation-item-details-row .quotation-col-line-total,
  .quotation-item-details-row
    .quotation-col-gst-select.quotation-custom-dropdown-wrap {
    width: 100%;
  }

  .quotation-item-details-row .quotation-col-line-total {
    justify-content: flex-end;
  }

  .quotation-item-details-row .quotation-col-row-action {
    grid-column: 1 / -1;
    width: auto;
    height: 32px;
    justify-content: flex-end;
  }

  .quotation-item-details-row .quotation-col-row-action:empty {
    display: none;
  }

  .quotation-item-remove-btn {
    width: auto;
    gap: 6px;
    padding: 0 8px !important;
  }

  .quotation-item-remove-btn span {
    display: inline;
    font-family: var(--font-family-primary);
    font-size: 12px;
    font-weight: 500;
  }

  .quotation-item-discount-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .quotation-discount-type-wrap,
  .quotation-discount-val-wrap {
    width: 100%;
    min-width: 0;
  }

  .quotation-items-spacer {
    display: none;
  }

  .quotation-total-item-discounts-badge {
    width: 100%;
    margin-left: 0;
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .quotation-pricing-basis-row,
  .quotation-pricing-basis-bar {
    align-items: stretch !important;
    flex-direction: column;
    gap: 8px !important;
  }

  .quotation-pricing-basis-select-wrap.quotation-custom-dropdown-wrap {
    width: 100%;
  }

  .quotation-item-discount-row {
    grid-template-columns: 1fr;
  }

  .quotation-item-result-top {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .quotation-item-result-price-group {
    padding-left: 22px;
  }

  .quotation-catalogue-option-row {
    min-width: 0;
  }

  .quotation-catalogue-option-edit {
    width: 44px;
    height: 44px;
  }

  .quotation-autocomplete-item.quotation-catalogue-option {
    padding: 10px 56px 10px 8px;
  }

  .quotation-action-outline-btn,
  .quotation-action-link-btn {
    flex: 1 1 auto;
    justify-content: center;
  }
}

/* History & notes drawer — Figma 604:62471 */
.quotation-editor-main-area.history-open .quotation-editor-content {
  margin-right: 480px;
}

.quotation-history-drawer {
  position: fixed;
  z-index: 850;
  top: 64px;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 480px;
  padding: 24px;
  overflow-y: auto;
  border-left: 1px solid var(--border-subtle, #dce3e2);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  box-shadow: -1px 0 2px rgba(14, 26, 32, 0.04);
}

.quotation-history-drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.quotation-history-drawer-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
}

.quotation-history-drawer-header p {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}

.quotation-history-drawer-header button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  cursor: pointer;
}

.quotation-history-drawer-header button:hover {
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-history-drawer-header svg {
  width: 16px;
  height: 16px;
}

.quotation-history-private {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-history-private > svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}

.quotation-history-private strong {
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
}

.quotation-history-private p {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
}

.quotation-history-filters {
  display: flex;
  align-items: center;
  gap: 8px;
}

.quotation-history-filters button {
  height: 40px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
}

.quotation-history-filters button.active {
  background: var(--interactive-default, #0f766e);
  color: #fff;
}

.quotation-history-caption {
  margin: -4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
}

.quotation-history-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.quotation-history-view-all {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--interactive-default, #0f766e);
  font: 500 13px / normal var(--font-family-primary);
  cursor: pointer;
}

.quotation-history-view-all:hover {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-hover-soft, #edf8f7);
}

.quotation-history-view-all:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

.quotation-history-view-all svg,
.quotation-history-view-all img {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

.quotation-history-event {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
}

.quotation-history-event.note {
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-history-event strong {
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
}

.quotation-history-event > span,
.quotation-history-event > p {
  margin: 0;
  font-size: 14px;
  line-height: 21.7px;
}

.quotation-history-event time {
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
}

.quotation-history-empty {
  padding: 24px 16px;
  border: 1px dashed var(--border-default, #cdd6d4);
  border-radius: 10px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  text-align: center;
}

.quotation-history-composer {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px 12px;
  padding-bottom: 8px;
}

.quotation-history-composer label,
.quotation-history-composer textarea {
  grid-column: 1 / -1;
}

.quotation-history-composer label {
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
}

.quotation-history-composer textarea {
  width: 100%;
  height: 120px;
  padding: 12px;
  resize: vertical;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  outline: none;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 14px/21.7px var(--font-family-primary);
}

.quotation-history-composer textarea::placeholder {
  color: var(--text-tertiary, #6b7b78);
}

.quotation-history-composer textarea:focus {
  border: 2px solid var(--interactive-default, #0f766e);
  padding: 11px;
  box-shadow: none;
}

.quotation-history-composer > span {
  align-self: center;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
}

.quotation-history-composer button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  background: var(--interactive-default, #0f766e);
  color: #fff;
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
}

.quotation-history-composer button:disabled {
  background: var(--interactive-disabled, #cdd6d4);
  color: var(--on-interactive-disabled, #8a9896);
  opacity: 0.75;
  cursor: not-allowed;
}

.quotation-history-composer button svg {
  width: 16px;
  height: 16px;
}

.quotation-editor-shell.dark .quotation-history-drawer,
.quotation-editor-shell.dark .quotation-history-event,
.quotation-editor-shell.dark .quotation-history-composer textarea {
  border-color: var(--border-subtle, #2c3036);
  background: var(--surface-primary, #191b1f);
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-shell.dark .quotation-history-private,
.quotation-editor-shell.dark .quotation-history-event.note {
  background: var(--surface-secondary, #22252a);
}

.quotation-editor-shell.dark .quotation-history-view-all {
  border-color: var(--border-default, #3a4048);
  background: var(--surface-primary, #191b1f);
  color: var(--interactive-default, #43a79c);
}

.quotation-editor-shell.dark .quotation-history-view-all:hover {
  border-color: var(--interactive-default, #43a79c);
  background: var(--surface-secondary, #22252a);
}

@media (max-width: 1180px) {
  .quotation-editor-main-area.history-open .quotation-editor-content {
    margin-right: 0;
  }
  .quotation-history-drawer {
    width: min(480px, 100vw);
    box-shadow: -12px 0 30px rgba(14, 26, 32, 0.18);
  }
}

/* Customer quotation preview — Figma 589:33102 */
.quotation-preview-shell {
  min-height: 100vh;
  background: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
}
.quotation-preview-main {
  min-width: 0;
}
.quotation-customer-preview {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
  font-family: var(--font-family-primary);
}
.quotation-preview-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: -moz-fit-content;
  width: fit-content;
  height: 40px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--text-link, #0f766e);
  font: 500 13px var(--font-family-primary);
  cursor: pointer;
}
.quotation-preview-back svg {
  width: 16px;
  height: 16px;
}
.quotation-preview-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
.quotation-preview-heading-row h1 {
  margin: 0 0 8px;
  color: var(--text-primary, #142624);
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
}
.quotation-preview-status-row {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
}
.quotation-preview-number {
  color: var(--text-primary, #142624);
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.28px;
  text-transform: uppercase;
}
.quotation-preview-status {
  height: 22px;
  padding: 3px 6px;
  border-radius: 999px;
  background: var(--surface-tertiary, #e8edec);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}
.quotation-preview-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.quotation-preview-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  font: 500 14px var(--font-family-primary);
  letter-spacing: 0.07px;
  cursor: pointer;
}
.quotation-preview-actions svg {
  width: 16px;
  height: 16px;
}
.quotation-preview-secondary {
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}
.quotation-preview-primary {
  border: 0;
  background: var(--interactive-default, #0f766e);
  color: #fff;
}
.quotation-preview-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
}
.quotation-preview-notice > svg {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  color: var(--text-secondary, #506360);
}
.quotation-preview-notice div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.quotation-preview-notice strong {
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
}
.quotation-preview-notice span {
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.quotation-preview-document {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.quotation-preview-document-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.quotation-preview-document-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
}
.quotation-preview-document-header > div {
  text-align: right;
}
.quotation-preview-document-header h3 {
  margin: 0 0 8px;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
}
.quotation-preview-document-header span {
  color: var(--text-secondary, #506360);
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.28px;
  text-transform: uppercase;
}
.quotation-preview-rule {
  height: 1px;
  background: var(--border-subtle, #dce3e2);
}
.quotation-preview-details {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
}
.quotation-preview-details div {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.quotation-preview-details span {
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
}
.quotation-preview-details strong {
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
}
.quotation-preview-items-section h4,
.quotation-preview-approval h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
}
.quotation-preview-items-section > p {
  margin: 2px 0 12px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
}
.quotation-preview-table-wrap {
  overflow-x: auto;
}
.quotation-preview-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.quotation-preview-table th {
  height: 44px;
  padding: 0 12px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  font-size: 12px;
  font-weight: 500;
  text-align: left;
}
.quotation-preview-table th:first-child {
  width: 50%;
}
.quotation-preview-table th:not(:first-child),
.quotation-preview-table td:not(:first-child) {
  text-align: right;
}
.quotation-preview-table td {
  padding: 8px 12px;
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 14px;
  vertical-align: top;
}
.quotation-preview-table td:first-child {
  font-family: var(--font-family-primary);
  text-align: left;
}
.quotation-preview-table td:first-child strong,
.quotation-preview-table td:first-child span {
  display: block;
}
.quotation-preview-table td:first-child strong {
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
}
.quotation-preview-table td:first-child span {
  margin-top: 4px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
}
.quotation-preview-bottom-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(320px, 1fr);
  gap: 40px;
}
.quotation-preview-copy {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.quotation-preview-copy strong {
  font-size: 14px;
  font-weight: 500;
}
.quotation-preview-copy p {
  margin: 8px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 21.7px;
}
.quotation-preview-totals {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.quotation-preview-totals > div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
}
.quotation-preview-totals strong {
  color: var(--text-primary, #142624);
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 14px;
  font-weight: 500;
}
.quotation-preview-totals .quotation-preview-total {
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
  color: var(--text-primary, #142624);
  font-weight: 500;
}
.quotation-preview-total strong {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 20px;
  font-weight: 700;
}
.quotation-preview-total small {
  margin-top: 4px;
  color: var(--text-secondary, #506360);
  font: 400 12px var(--font-family-primary);
}
.quotation-preview-totals > p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 12px;
}
.quotation-preview-online {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.quotation-preview-online-label {
  display: flex;
  justify-content: space-between;
  color: var(--text-secondary, #506360);
  font-size: 13px;
}
.quotation-preview-online-label strong {
  font-size: 14px;
  font-weight: 500;
}
.quotation-preview-approval {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 24px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}
.quotation-preview-approval p {
  margin: 8px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 21.7px;
}
.quotation-preview-disabled-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.quotation-preview-disabled-actions button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border: 0;
  border-radius: 10px;
  color: var(--text-disabled, #8a9896);
  background: transparent;
  font: 500 13px var(--font-family-primary);
  opacity: 0.75;
}
.quotation-preview-disabled-actions button:last-child {
  background: var(--interactive-disabled, #cdd6d4);
}
.quotation-preview-shell.dark .quotation-preview-document,
.quotation-preview-shell.dark .quotation-preview-approval {
  background: var(--surface-primary, #191b1f);
}
@media (max-width: 900px) {
  .quotation-customer-preview {
    padding: 24px 16px;
  }
  .quotation-preview-heading-row,
  .quotation-preview-approval {
    align-items: flex-start;
    flex-direction: column;
  }
  .quotation-preview-details {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .quotation-preview-bottom-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .quotation-preview-heading-row h1,
  .quotation-preview-document-header h3 {
    font-size: 26px;
    line-height: 34px;
  }
  .quotation-preview-heading-row,
  .quotation-preview-document-header,
  .quotation-preview-online-label {
    align-items: flex-start;
    flex-direction: column;
  }
  .quotation-preview-actions {
    width: 100%;
  }
  .quotation-preview-actions button {
    flex: 1 1;
  }
  .quotation-preview-document {
    padding: 20px 16px;
  }
  .quotation-preview-details {
    grid-template-columns: 1fr;
  }
  .quotation-preview-table {
    min-width: 720px;
  }
  .quotation-preview-disabled-actions {
    width: 100%;
    flex-wrap: wrap;
  }
}

.quotation-item-no-results {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quotation-item-no-results strong {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-item-no-results strong,
.quotation-editor-page[data-theme="dark"] .quotation-item-no-results strong {
  color: var(--text-primary, #f2f3f5);
}

.quotation-item-no-results span {
  font-size: 12px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-item-no-results span,
.quotation-editor-page[data-theme="dark"] .quotation-item-no-results span {
  color: var(--text-secondary, #b3b8c2);
}

/* ==========================================================================
   EMPTY ATTACHMENTS CARD (FIGMA NODE 582:38601)
   ========================================================================== */
.quotation-empty-attachments-box {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--surface-secondary, #f4f7f7);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  width: 100%;
}

.quotation-editor-page.dark .quotation-empty-attachments-box,
.quotation-editor-page[data-theme="dark"] .quotation-empty-attachments-box {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-subtle, #2c3036);
}

.quotation-attachment-indicator-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--interactive-default, #0f766e);
}

.quotation-attachment-indicator-icon svg {
  width: 22px;
  height: 22px;
}

.quotation-editor-page.dark .quotation-attachment-indicator-icon,
.quotation-editor-page[data-theme="dark"] .quotation-attachment-indicator-icon {
  color: var(--interactive-default, #43a79c);
}

.quotation-attachment-guidance-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 0;
  min-width: 0;
}

.quotation-attachment-guidance-content h4 {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: var(--text-primary, #142624);
}

.quotation-editor-page.dark .quotation-attachment-guidance-content h4,
.quotation-editor-page[data-theme="dark"]
  .quotation-attachment-guidance-content
  h4 {
  color: var(--text-primary, #f2f3f5);
}

.quotation-attachment-guidance-content p {
  margin: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quotation-editor-page.dark .quotation-attachment-guidance-content p,
.quotation-editor-page[data-theme="dark"]
  .quotation-attachment-guidance-content
  p {
  color: var(--text-secondary, #b3b8c2);
}

.quotation-add-attachment-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
  transition: background 0.12s ease;
}

.quotation-add-attachment-btn:hover {
  background: #e8edec;
}

.quotation-editor-page.dark .quotation-add-attachment-btn,
.quotation-editor-page[data-theme="dark"] .quotation-add-attachment-btn {
  background: var(--surface-secondary, #22252a);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quotation-editor-page.dark .quotation-add-attachment-btn:hover,
.quotation-editor-page[data-theme="dark"] .quotation-add-attachment-btn:hover {
  background: #2a2e35;
}

.quotation-add-attachment-btn.outline {
  background: transparent;
  align-self: flex-start;
  margin-top: 8px;
}

/* ==========================================================================
   QUOTE DETAILS SCREEN (Figma Nodes 623:40457 - Sent & 623:51504 - Approved)
   ========================================================================== */

.quote-details-shell {
  min-height: 100vh;
  background: var(--bg-primary, #f4f7f7);
}

.quote-details-content {
  display: flex;
  flex-direction: column;
  padding: 32px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  font-family: var(--font-family-primary);
}

/* Header */
.quote-details-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.quote-details-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border: 0;
  border-radius: var(--radius-md, 10px);
  background: transparent;
  color: var(--text-link, #0f766e);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  align-self: flex-start;
  transition: background 0.15s ease;
}

.quote-details-back-btn:hover {
  background: var(--surface-secondary, #e8edec);
}

.quote-details-back-btn svg {
  width: 16px;
  height: 16px;
}

.quote-details-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.quote-details-title-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.quote-details-title {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
  color: var(--text-primary, #142624);
}

.quote-details-identity-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.quote-number-pill {
  font-family: var(--font-family-mono, monospace);
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.28px;
  text-transform: uppercase;
  color: var(--text-primary, #142624);
}

.quote-identity-dot {
  color: var(--text-secondary, #506360);
  font-size: 14px;
}

.quote-customer-name {
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
  color: var(--text-primary, #142624);
}

.quote-status-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  font-size: 12px;
  font-weight: 500;
  line-height: 15.6px;
  letter-spacing: 0.12px;
  white-space: nowrap;
}

.quote-status-pill.sent {
  background: var(--info-soft, #eff6ff);
  color: var(--info-text, #1d4ed8);
}

.quote-status-pill.approved {
  background: var(--success-soft, #f0fdf4);
  color: var(--success-text, #15803d);
}

.quote-status-pill.draft {
  background: #f1f5f9;
  color: #475569;
}

.quote-status-pill.viewed {
  background: var(--info-soft, #eff6ff);
  color: var(--info-text, #1d4ed8);
}

.quote-status-pill.declined {
  background: #fef2f2;
  color: #b91c1c;
}

.quote-status-pill.expired {
  background: #fff7ed;
  color: #b45309;
}

.quote-details-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.quote-details-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.quote-details-action-btn:hover {
  background: var(--surface-secondary, #f4f7f7);
  border-color: var(--border-strong, #8a9896);
}

.quote-details-action-btn svg {
  width: 16px;
  height: 16px;
}

.quote-details-primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: var(--radius-md, 10px);
  background: var(--interactive-default, #0f766e);
  color: #fff;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quote-details-primary-btn:hover {
  background: var(--interactive-hover, #0d655e);
}

.quote-details-primary-btn:disabled {
  background: var(--interactive-disabled, #cdd6d4);
  color: var(--on-interactive-disabled, #8a9896);
  cursor: not-allowed;
}

.quote-details-primary-btn svg {
  width: 16px;
  height: 16px;
}

.quote-details-meta-line {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}

/* Two-column Grid */
.quote-details-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  align-items: start;
}

@media (max-width: 1024px) {
  .quote-details-grid {
    grid-template-columns: 1fr;
  }
}

.quote-details-main-col {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

/* Card Structure */
.quote-details-card {
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  padding: 24px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.quote-card-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quote-card-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quote-card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quote-content-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

@media (max-width: 600px) {
  .quote-content-meta-grid {
    grid-template-columns: 1fr;
  }
}

.quote-meta-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.quote-meta-label {
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quote-meta-val {
  font-size: 14px;
  font-weight: 500;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.quote-card-divider {
  border: 0;
  height: 1px;
  background: var(--border-subtle, #dce3e2);
  margin: 0;
}

/* Items & Pricing Table */
.quote-items-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.quote-items-table-header {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) 48px 112px 64px 96px 112px;
  background: var(--surface-secondary, #f4f7f7);
  border-radius: var(--radius-sm, 6px);
  min-height: 44px;
  align-items: center;
  padding: 0 12px;
  gap: 12px;
}

.quote-th {
  font-size: 12px;
  font-weight: 500;
  line-height: 15.6px;
  letter-spacing: 0.12px;
  color: var(--text-secondary, #506360);
}

.quote-th.text-right {
  text-align: right;
}

.quote-items-table-body {
  display: flex;
  flex-direction: column;
}

.quote-item-row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) 48px 112px 64px 96px 112px;
  align-items: center;
  padding: 12px;
  gap: 12px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  min-height: 56px;
}

.quote-item-desc {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quote-item-name {
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
}

.quote-item-sub {
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quote-cell-qty {
  font-size: 14px;
  text-align: right;
  color: var(--text-primary, #142624);
}

.quote-cell-money {
  font-family: var(--font-family-mono, monospace);
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  text-align: right;
  color: var(--text-primary, #142624);
}

.quote-cell-gst {
  font-size: 14px;
  text-align: right;
  color: var(--text-primary, #142624);
}

.quote-cell-discount {
  font-size: 14px;
  text-align: right;
  color: var(--text-primary, #142624);
}

/* Scope, Terms & Totals Breakdown */
.quote-scope-totals-row {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 32px;
  padding-top: 8px;
}

@media (max-width: 860px) {
  .quote-scope-totals-row {
    grid-template-columns: 1fr;
  }
}

.quote-scope-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.quote-scope-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.quote-scope-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
  color: var(--text-primary, #142624);
}

.quote-scope-desc {
  margin: 0;
  font-size: 14px;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
  white-space: pre-line;
}

.quote-totals-col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.quote-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 21.7px;
  color: var(--text-secondary, #506360);
}

.quote-total-val {
  font-family: var(--font-family-mono, monospace);
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quote-grand-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary, #142624);
}

.quote-grand-total-val {
  font-family: var(--font-family-mono, monospace);
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary, #142624);
}

.quote-totals-footnote {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 16.8px;
  color: var(--text-secondary, #506360);
}

/* Attachments */
.quote-attachments-body {
  width: 100%;
}

.quote-attachments-empty {
  margin: 0;
  font-size: 14px;
  color: var(--text-secondary, #506360);
}

.quote-attachments-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.quote-attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
}

.quote-attachment-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary, #142624);
}

.quote-attachment-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 0;
  color: var(--interactive-default, #0f766e);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: var(--radius-sm, 6px);
}

.quote-attachment-btn:hover {
  background: #e8edec;
}

/* Sidebar */
.quote-details-sidebar {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.quote-summary-total-card {
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  padding: 24px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.quote-summary-total-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.quote-summary-total-header svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  color: var(--interactive-default, #0f766e);
}

.quote-summary-amount {
  margin: 0 0 6px;
  font-family: var(--font-family-mono, monospace);
  font-size: 26px;
  font-weight: 700;
  line-height: 32px;
  color: var(--text-primary, #142624);
}

.quote-summary-caption {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quote-sidebar-status-card {
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  padding: 24px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.quote-sidebar-status-card.sent {
  padding-top: 22px;
}

.quote-sidebar-status-card.approved {
  border-top: 3px solid var(--success-text, #15803d);
  padding-top: 22px;
}

.quote-sidebar-status-card.declined {
  border-top: 3px solid #c24136;
  padding-top: 22px;
}

.quote-sidebar-status-card.expired {
  border-top: 3px solid #b45309;
  padding-top: 22px;
}

.quote-status-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quote-status-card-header.approved svg {
  color: var(--success-text, #15803d);
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.quote-status-card-header > svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.quote-sidebar-status-card.sent .quote-status-card-header > svg {
  color: var(--info-text, #1d4ed8);
}

.quote-status-card-header.declined svg,
.quote-status-card-header.expired svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.quote-status-card-header.declined svg {
  color: #c24136;
}

.quote-status-card-header.expired svg {
  color: #b45309;
}

.quote-status-meta-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quote-status-meta-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quote-status-meta-row-label {
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quote-status-meta-row-val {
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--text-primary, #142624);
  word-break: break-word;
}

.quote-meta-footnote {
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.ready-to-invoice-box {
  background: var(--surface-secondary, #f4f7f7);
  border-radius: var(--radius-md, 10px);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ready-to-invoice-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  color: var(--text-primary, #142624);
}

.ready-to-invoice-desc {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
  color: var(--text-secondary, #506360);
}

.quote-original-delivery-box {
  border-top: 1px solid var(--border-subtle, #dce3e2);
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quote-status-card-actions {
  display: flex;
  gap: 8px;
}

.quote-status-sub-btn {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--interactive-default, #0f766e);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.quote-status-sub-btn:hover {
  background: var(--interactive-soft, #f0f8f7);
  border-color: var(--interactive-default, #0f766e);
}

.quote-status-sub-btn svg {
  width: 16px;
  height: 16px;
}

.quote-status-revise-btn {
  width: 100%;
  flex: none;
}

/* Viewed state status actions & subtexts (Figma 663:64332) */
.quote-status-card-actions.viewed-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.quote-status-primary-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  width: 100%;
  border: 0;
  border-radius: var(--radius-md, 10px);
  background: var(--interactive-default, #0f766e);
  color: #fff;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.quote-status-primary-btn:hover {
  background: var(--interactive-hover, #0d655e);
}

.quote-status-primary-btn svg {
  width: 16px;
  height: 16px;
}

.quote-status-secondary-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  width: 100%;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.quote-status-secondary-btn:hover {
  background: #e8edec;
  border-color: var(--border-strong, #8a9896);
}

.quote-status-secondary-btn svg {
  width: 16px;
  height: 16px;
}

.quote-meta-subtext {
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quote-sidebar-disclaimer {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

/* Bottom History & Notes Section */
.quote-details-history-section {
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;
}

.quotation-editor-shell.dark .quotation-editor-history-section {
  border-color: var(--border-subtle, #2c3036);
  background: var(--surface-primary, #191b1f);
  color: var(--text-primary, #f2f3f5);
}

.quote-history-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.quote-history-header > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quote-history-header .quotation-history-link-btn {
  flex-shrink: 0;
  padding: 4px 0;
}

.quote-history-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: -0.09px;
  color: var(--text-primary, #142624);
}

.quote-history-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quote-history-privacy-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
}

.quote-history-privacy-banner svg {
  width: 20px;
  height: 20px;
  color: var(--text-secondary, #506360);
  flex-shrink: 0;
  margin-top: 2px;
}

.quote-history-privacy-banner strong {
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.2px;
  letter-spacing: 0.07px;
  color: var(--text-primary, #142624);
}

.quote-history-privacy-banner p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
  color: var(--text-secondary, #506360);
}

.quote-history-two-col {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  align-items: start;
}

@media (max-width: 900px) {
  .quote-history-header {
    flex-direction: column;
  }

  .quote-history-two-col {
    grid-template-columns: 1fr;
  }
}

.quote-history-activity-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quote-details-history-section .quotation-history-event {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px 16px;
}

.quote-details-history-section .quotation-history-event > time {
  grid-column: 2;
  grid-row: 1;
  white-space: nowrap;
}

.quote-details-history-section .quotation-history-event > span,
.quote-details-history-section .quotation-history-event > p {
  grid-column: 1 / -1;
}

.quote-history-composer-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Dark Mode Overrides for Quote Details */
.quote-details-shell.dark,
.quote-details-page.dark,
.quote-details-page[data-theme="dark"] {
  background: var(--bg-primary, #181b1f);
  color: var(--text-primary, #f2f3f5);
}

.quote-details-page.dark .quote-details-title,
.quote-details-page.dark .quote-number-pill,
.quote-details-page.dark .quote-customer-name,
.quote-details-page.dark .quote-card-title,
.quote-details-page.dark .quote-meta-val,
.quote-details-page.dark .quote-item-name,
.quote-details-page.dark .quote-cell-qty,
.quote-details-page.dark .quote-cell-money,
.quote-details-page.dark .quote-cell-gst,
.quote-details-page.dark .quote-cell-discount,
.quote-details-page.dark .quote-scope-title,
.quote-details-page.dark .quote-scope-desc,
.quote-details-page.dark .quote-total-val,
.quote-details-page.dark .quote-grand-total-row,
.quote-details-page.dark .quote-grand-total-val,
.quote-details-page.dark .quote-summary-amount,
.quote-details-page.dark .quote-status-card-header,
.quote-details-page.dark .quote-status-meta-row-val,
.quote-details-page.dark .ready-to-invoice-title,
.quote-details-page.dark .quote-history-title,
.quote-details-page.dark .quote-history-privacy-banner strong,
.quote-details-page.dark .quote-attachment-info {
  color: var(--text-primary, #f2f3f5);
}

.quote-details-page.dark .quote-details-card,
.quote-details-page.dark .quote-summary-total-card,
.quote-details-page.dark .quote-sidebar-status-card,
.quote-details-page.dark .quote-details-history-section {
  background: var(--surface-primary, #20242a);
  border-color: var(--border-subtle, #2f343b);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.quote-details-page.dark .quote-details-action-btn,
.quote-details-page.dark .quote-status-sub-btn,
.quote-details-page.dark .quote-status-secondary-btn {
  background: var(--surface-secondary, #282c34);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.quote-details-page.dark .quote-details-action-btn:hover,
.quote-details-page.dark .quote-status-sub-btn:hover,
.quote-details-page.dark .quote-status-secondary-btn:hover {
  background: #323741;
}

.quote-details-page.dark .quote-items-table-header,
.quote-details-page.dark .ready-to-invoice-box,
.quote-details-page.dark .quote-attachment-item,
.quote-details-page.dark .quote-history-privacy-banner {
  background: var(--surface-secondary, #282c34);
  border-color: var(--border-subtle, #2f343b);
}

.quote-details-page.dark .quote-card-divider,
.quote-details-page.dark .quote-item-row,
.quote-details-page.dark .quote-grand-total-row,
.quote-details-page.dark .quote-original-delivery-box {
  border-color: var(--border-subtle, #2f343b);
}

/* Create invoice dialog */
.quote-create-invoice-scrim {
  z-index: 1400;
}

.quote-create-invoice-dialog {
  width: min(100% - 32px, 560px);
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 16px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 20px 48px rgba(20, 38, 36, 0.2);
}

.quote-create-invoice-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}

.quote-create-invoice-header h2 {
  margin: 0;
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.quote-create-invoice-header p {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  line-height: 20px;
}

.quote-create-invoice-close {
  display: inline-grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}

.quote-create-invoice-close:hover:not(:disabled) {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}

.quote-create-invoice-close svg {
  width: 20px;
  height: 20px;
}

.quote-create-invoice-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
}

.quote-create-invoice-source {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 12px;
  padding: 14px;
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
}

.quote-create-invoice-source-label {
  grid-column: 1 / -1;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 16px;
}

.quote-create-invoice-source strong,
.quote-create-invoice-source span:last-child {
  color: var(--text-primary, #142624);
  font-size: 14px;
  line-height: 20px;
}

.quote-create-invoice-source strong {
  font-weight: 600;
}

.quote-create-invoice-source span:last-child {
  text-align: right;
}

.quote-create-invoice-summary {
  display: grid;
  grid-template-columns: 1.3fr 1.5fr 0.7fr;
  gap: 12px;
}

.quote-create-invoice-summary div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.quote-create-invoice-summary span {
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 16px;
}

.quote-create-invoice-summary strong {
  overflow: hidden;
  color: var(--text-primary, #142624);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quote-create-invoice-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border-radius: 10px;
  background: var(--interactive-soft, #f0f8f7);
  color: var(--text-secondary, #506360);
}

.quote-create-invoice-note svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  color: var(--interactive-default, #0f766e);
}

.quote-create-invoice-note p {
  margin: 0;
  font-size: 13px;
  line-height: 18px;
}

.quote-create-invoice-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}

.quote-create-invoice-cancel,
.quote-create-invoice-confirm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.quote-create-invoice-cancel {
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
}

.quote-create-invoice-confirm {
  border: 1px solid var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: #fff;
}

.quote-create-invoice-confirm:hover:not(:disabled) {
  background: var(--interactive-hover, #0d655e);
}

.quote-create-invoice-cancel:disabled,
.quote-create-invoice-confirm:disabled,
.quote-create-invoice-close:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.quote-create-invoice-confirm svg {
  width: 16px;
  height: 16px;
}

.quote-details-page.dark .quote-create-invoice-dialog {
  background: var(--surface-primary, #20242a);
  border-color: var(--border-subtle, #2f343b);
}

.quote-details-page.dark .quote-create-invoice-header,
.quote-details-page.dark .quote-create-invoice-footer {
  border-color: var(--border-subtle, #2f343b);
}

.quote-details-page.dark .quote-create-invoice-header h2,
.quote-details-page.dark .quote-create-invoice-source strong,
.quote-details-page.dark .quote-create-invoice-source span:last-child,
.quote-details-page.dark .quote-create-invoice-summary strong {
  color: var(--text-primary, #f2f3f5);
}

.quote-details-page.dark .quote-create-invoice-source,
.quote-details-page.dark .quote-create-invoice-cancel {
  background: var(--surface-secondary, #282c34);
  border-color: var(--border-default, #3a3f47);
}

.quote-details-page.dark .quote-create-invoice-cancel {
  color: var(--text-primary, #f2f3f5);
}

@media (max-width: 767px) {
  .quote-details-content {
    padding: 20px 16px 32px;
  }

  .quote-details-header {
    gap: 12px;
    margin-bottom: 20px;
  }

  .quote-details-title {
    font-size: 28px;
    line-height: 35px;
  }

  .quote-details-title-row,
  .quote-details-actions {
    width: 100%;
  }

  .quote-details-actions {
    gap: 8px;
  }

  .quote-details-action-btn,
  .quote-details-primary-btn {
    flex: 1 1 150px;
  }

  .quote-details-card,
  .quote-summary-total-card,
  .quote-sidebar-status-card,
  .quote-details-history-section {
    padding: 20px;
  }

  .quote-items-table-header,
  .quote-item-row {
    min-width: 720px;
  }

  .quote-sidebar-status-card {
    gap: 16px;
  }
}

@media (max-width: 520px) {
  .quote-create-invoice-header,
  .quote-create-invoice-body {
    padding: 20px;
  }

  .quote-create-invoice-footer {
    padding: 14px 20px;
  }

  .quote-create-invoice-summary {
    grid-template-columns: 1fr 1fr;
  }

  .quote-create-invoice-summary div:last-child {
    grid-column: 1 / -1;
  }
}
.quotation-send-failed-dialog {
  max-width: 560px;
}
.quotation-send-failed-body {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.quotation-send-failed-body > svg {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  color: var(--danger-text, #c23a2b);
}
.quotation-send-failed-body strong {
  display: block;
  margin-bottom: 6px;
  color: var(--text-primary, #142624);
  font-size: 14px;
}
.quotation-send-failed-body p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 20px;
}
.quotation-modal-submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.quotation-send-success-dialog {
  max-width: 560px;
}
.quotation-send-success-body {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.quotation-send-success-body > svg {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  color: var(--success-text, #15803d);
}
.quotation-send-success-body strong {
  display: block;
  margin-bottom: 6px;
  color: var(--text-primary, #142624);
  font-size: 14px;
}
.quotation-send-success-body p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 20px;
}
.quotation-send-success-body p + p {
  margin-top: 6px;
}
.quotation-editor-card.quotation-attachments-card {
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}

.quotation-attachments-card .quotation-card-header {
  margin-bottom: 0;
}

.quotation-attachments-card .quotation-card-body {
  gap: 0;
}

.quotation-attachments-card .quotation-attachment-summary {
  margin-bottom: var(--space-3, 12px);
  padding: var(--space-4, 16px);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
}

.quotation-attachments-card .quotation-attachment-summary strong {
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
}

.quotation-attachments-card .quotation-attachment-summary p {
  margin: 3px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 17px;
}

.quotation-attachments-card .quotation-attachments-list {
  margin-bottom: var(--space-3, 12px);
}

.quotation-attachments-card .quotation-attachment-info {
  min-width: 0;
  overflow-wrap: anywhere;
}

.quotation-attachments-card .quotation-attachment-actions {
  display: flex;
  flex-shrink: 0;
  gap: var(--space-2, 8px);
}

.quotation-attachments-card .quotation-attachment-view-btn {
  padding: 4px;
  border: none;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}

.quotation-attachments-card .quotation-attachment-view-btn:hover {
  color: var(--interactive-default, #0f766e);
}

.quotation-attachments-card .quotation-attachment-upload {
  display: inline-flex;
  width: max-content;
  align-self: flex-start;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  box-sizing: border-box;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.quotation-attachments-card .quotation-attachment-upload input {
  display: none;
}

.quotation-attachments-card .quotation-attachment-info > svg,
.quotation-attachments-card .quotation-attachment-upload > svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.quotation-attachments-card .quotation-attachment-error {
  display: block;
  margin-top: 6px;
  color: var(--danger-text, #a3301f);
  font-size: 12px;
  line-height: 18px;
}

@media (max-width: 700px) {
  .quotation-attachments-card .quotation-attachment-upload {
    height: 44px;
    font-size: 14px;
  }
}
.quotation-customer-modal .quotation-customer-field-error {
  display: block;
  color: var(--danger-text, #a3301f);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.quotation-customer-modal .quotation-input-box.error {
  border-color: var(--danger-default, #c23a2b);
}

.quotation-customer-modal .quotation-input-box.error:focus-within {
  box-shadow: none;
}

:is(.quotation-editor-page, .invoice-editor-shell, .rcti-editor-shell)
  .quotation-field-error,
:is(.invoice-editor-shell, .rcti-editor-shell)
  .figma-datepicker__helper--error {
  display: block;
  margin-top: 4px;
  color: var(--danger-text, #a3301f);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  line-height: 18px;
}

.quotation-editor-page .quotation-input-box:has([aria-invalid="true"]),
.quotation-editor-page .quotation-item-search-box:has([aria-invalid="true"]),
.quotation-editor-page .quotation-item-details-row input[aria-invalid="true"] {
  border-color: var(--danger-default, #c23a2b);
}

:is(.quotation-editor-page, .invoice-editor-shell)
  .quotation-item-details-row:has([aria-invalid="true"]) {
  align-items: flex-start;
}

/* Keep quotation field focus borders thin and green without a glow. */
.quotation-editor-shell
  :is(.quotation-input-box, .quotation-item-search-box, .quotation-select-box):not(.disabled):not(.quotation-input-readonly):not(.quotation-custom-dropdown-wrap):not(.error):not(:has(:disabled, [readonly], [aria-invalid="true"])):focus-within,
.quotation-editor-shell
  .quotation-item-details-row
  input:not(:disabled):not([readonly]):not([aria-invalid="true"]):focus,
.quotation-editor-shell .quotation-textarea-box:focus,
.quotation-editor-shell .quotation-history-composer textarea:focus,
.quotation-editor-shell
  .quotation-dialog-field
  input:not(:disabled):not([readonly]):not([aria-invalid="true"]):focus,
.quotation-editor-shell
  .quotation-figma-dropdown-trigger:not(:disabled):focus-visible,
.quotation-editor-shell
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger {
  border: 1px solid var(--interactive-default, #0f766e);
  box-shadow: none;
  outline: none;
}

.quotation-editor-shell
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger,
.quotation-editor-shell
  .quotation-item-details-row
  .quotation-col-gst-select.quotation-custom-dropdown-wrap
  .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger {
  padding-inline: 12px 10px;
}

.quotation-editor-shell
  .figma-datepicker__input-container:not(.figma-datepicker__input-container--disabled):not(.figma-datepicker__input-container--error):focus-within {
  border: 1px solid var(--interactive-default, #0f766e) !important;
  box-shadow: none !important;
  outline: none !important;
}
.quotation-sent-success-dialog {
  width: min(100%, 520px);
}
.quotation-send-success-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3, 12px);
  padding: var(--space-8, 32px);
  text-align: center;
}
.quotation-send-success-panel h4,
.quotation-send-success-panel p {
  margin: 0;
}
.quotation-send-success-icon {
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  color: var(--success-text, #166534);
  background: var(--success-soft, #ecfdf3);
  border-radius: var(--radius-full, 9999px);
}
.quotation-send-success-icon svg {
  width: 24px;
  height: 24px;
}

/* Match the invoice register's customer filter without changing date pickers. */
.quotation-page .quotation-customer-filter > .quotation-select-trigger {
  min-width: 134px;
  gap: 10px;
}
.quotation-page
  .quotation-customer-filter
  > .quotation-select-trigger:is(.is-open, :focus-visible),
.quotation-page
  .quotation-select-trigger[aria-label="Filter by date range"]:is(.is-open, :focus-visible) {
  border-color: var(--interactive-default);
  box-shadow: none;
}
.quotation-page .quotation-customer-filter .select-arrow {
  width: 16px;
  height: 16px;
  color: inherit;
  transform: none;
}
.quotation-page .quotation-customer-filter > .quotation-dropdown-panel {
  box-sizing: border-box;
  top: calc(100% + 6px);
  right: 0;
  left: auto;
  width: auto;
  min-width: 210px;
  max-width: calc(100vw - 32px);
  max-height: min(240px, 40vh);
  gap: 0;
  padding: 6px;
  border-color: var(--border-subtle);
  background: var(--surface-primary);
  box-shadow: 0 12px 30px rgba(14, 26, 32, 0.16);
  overscroll-behavior: contain;
  scrollbar-width: thin;
}
.quotation-page .quotation-customer-filter .quotation-dropdown-item {
  flex-shrink: 0;
  width: 100%;
  height: auto;
  gap: 12px;
  padding: 9px 10px;
  border-radius: 7px;
  font-weight: 400;
  line-height: normal;
  white-space: normal;
}
.quotation-page .quotation-customer-filter .quotation-dropdown-item-label {
  overflow: visible;
  white-space: normal;
  overflow-wrap: anywhere;
}
.quotation-page
  .quotation-customer-filter
  .quotation-dropdown-item:is(:hover, .is-selected) {
  background: var(--interactive-soft);
  color: var(--interactive-default);
}
.quotation-page .quotation-customer-filter .quotation-dropdown-check-icon {
  width: 16px;
  height: 16px;
  color: inherit;
}
@media (max-width: 600px) {
  .quotation-page .quotation-customer-filter > .quotation-select-trigger {
    min-width: 0;
  }
  .quotation-page .quotation-customer-filter > .quotation-dropdown-panel {
    right: auto;
    left: 0;
    width: max-content !important;
    max-width: calc(100vw - 32px) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Quotation/quotation.css"],"names":[],"mappings":"AAAA;;;;;;+EAM+E;;AAE/E;;+EAE+E;AAC/E;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,mDAAmD;EACnD,kDAAkD;EAClD,4CAA4C;EAC5C,oDAAoD;EACpD,yCAAyC;EACzC,4CAA4C;EAC5C,iDAAiD;EACjD,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,8EAA8E;EAC9E,+CAA+C;;EAE/C,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;+EAE+E;AAC/E;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,uBAAuB;EACvB,sCAAsC;EACtC,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6DAA6D;AAC7D;;EAEE,aAAa;AACf;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;EAC3C,gDAAgD;EAChD,sDAAsD;EACtD,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,uCAAuC;EACvC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB;yBACuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;;EAEE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;;;EAIE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,qCAAqC;AACvC;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,gDAAgD;EAChD,4CAA4C;EAC5C;sCACoC;EACpC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,4CAA4C;EAC5C,4CAA4C;EAC5C,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;+EAE+E;AAC/E;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,2CAA2C;EAC3C,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA,eAAe;AACf;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;EACpD,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,0CAA0C;EAC1C,gDAAgD;EAChD,gCAAgC;AAClC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,wCAAwC;EACxC,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4EAA4E;EAC5E,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;;EAEE,0CAA0C;EAC1C,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;;EAEE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;;;EAGE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;EAChC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,gDAAgD;EAChD,4CAA4C;EAC5C;sCACoC;EACpC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,4CAA4C;EAC5C,4CAA4C;EAC5C,4EAA4E;AAC9E;;AAEA;;;EAGE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;;;;;;EAME,mCAAmC;AACrC;;AAEA;;;EAGE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;;;;;;EAME,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;;;EAGE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;;;;;EAME,6CAA6C;AAC/C;;AAEA;;EAEE,kDAAkD;EAClD,6CAA6C;AAC/C;;AAEA;;;;;;EAME,kDAAkD;EAClD,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;+EAE+E;AAC/E;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;;+EAE+E;AAC/E;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA,6DAA6D;EAC7D;IACE,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,YAAY;EACZ;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA,iEAAiE;EACjE;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA,YAAY;EACZ;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,oBAAkB;IAClB,sBAAsB;EACxB;;EAEA,uBAAuB;EACvB;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,gCAAgC;EAChC;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;EAC3B;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA,+BAA+B;EAC/B;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA,WAAW;EACX;IACE,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA,yCAAyC;EACzC;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA,qCAAqC;EACrC;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,YAAY;EACZ;IACE,iCAAiC;IACjC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,yCAAyC;IACzC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA,+CAA+C;EAC/C;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,2CAA2C;IAC3C,iCAAiC;IACjC,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sCAAsC;IACtC,cAAc;IACd,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;EACb;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;IAC9B,+CAA+C;EACjD;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;;EAEE,wCAAwC;AAC1C;;AAEA;;;;;;;;;;EAUE,oCAAoC;AACtC;;AAEA,mCAAmC;AACnC;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;;EAEE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;EACf;AACF;;AAEA;;+EAE+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;;;+EAG+E;AAC/E;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;EAC5C,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;EACrC;0CACwC;EACxC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;EAEE,2CAA2C;EAC3C,2CAA2C;EAC3C;sCACoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,oEAAoE;AACtE;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,4BAA4B;EAC5B,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;AACtE;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,4CAA4C;EAC5C,mCAAmC;EACnC,aAAa;AACf;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;;;EAGE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;EACnC,kEAAkE;EAClE,oEAAoE;AACtE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sDAAsD;EACtD,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,oEAAoE;AACtE;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,+CAA+C;EAC/C,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB;qEACmE;EACnE,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6DAA6D;AAC/D;AACA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,6CAA6C;EAC7C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,2CAA2C;AAC7C;;AAEA;;EAEE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;;EAGE,6CAA6C;EAC7C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,+CAA+C;EAC/C,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;EACA;;;IAGE,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,uCAAuC;EACvC,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,oCAAoC;EACpC,6CAA6C;EAC7C,wCAAwC;EACxC,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,wCAAwC;EACxC,4CAA4C;EAC5C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,wCAAwC;EACxC,gDAAgD;EAChD,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,6CAA6C;EAC7C,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oCAAoC;IACpC,wCAAwC;IACxC,iDAAiD;EACnD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,6CAA6C;EAC7C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,6CAA6C;EAC7C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,+CAA+C;EAC/C,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,cAAc;AACd;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kDAAkD;AACpD;;AAEA;;EAEE,2CAA2C;EAC3C,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,cAAc;EACd,SAAS;EACT,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,WAAW;EACX,0DAA0D;AAC5D;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;;;;;;EAME,4DAA4D;AAC9D;;AAEA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,uEAAuE;AACzE;;AAEA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,mCAAmC;AACrC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,6CAA6C;EAC7C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;;;;;;;;;;EAUE,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4CAA4C;EAC5C,gDAAgD;EAChD,qCAAqC;EACrC,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,4CAA4C;EAC5C,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,4CAA4C;EAC5C,4CAA4C;EAC5C,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;;;;;;;EAQE,4CAA4C;EAC5C,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;;;EAKE,mCAAmC;AACrC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,sDAAsD;EACtD,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA,wEAAwE;AACxE;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,gDAAgD;EAChD,qCAAqC;EACrC,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;;;EAIE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;;;;;EAME,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,mCAAmC;AACrC;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;;;;;;EAQE,qCAAqC;AACvC;;AAEA,2EAA2E;AAC3E;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;EAEE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,6CAA6C;EAC7C,gBAAgB;EAChB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;;EAEE,6CAA6C;EAC7C,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,aAAa;EACb,mCAAmC;AACrC;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;;EAEE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,2DAA2D;EAC3D,sDAAsD;EACtD,8CAA8C;EAC9C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;EAEE,sDAAsD;EACtD,uDAAuD;EACvD,8CAA8C;AAChD;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sDAAsD;EACtD,2DAA2D;EAC3D,qCAAqC;EACrC,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,8CAA8C;EAC9C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,6CAA6C;EAC7C,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;;;EAGE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;;EAEE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,6CAA6C;EAC7C,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;EAIE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;;;;;EAME,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA,oCAAoC;AACpC;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kDAAkD;AACpD;;AAEA;;EAEE,2CAA2C;EAC3C,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,WAAW;AACb;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;;;EAME,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;;;EAME,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,+CAA+C;EAC/C,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;+EAE+E;AAC/E;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;EACrC;0CACwC;EACxC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,2CAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;AACf;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,oDAAoD;EACpD,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yDAAyD;EACzD,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,wCAAwC;EACxC,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC;oCACkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,iEAAiE;EACjE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA,sFAAsF;AACtF;;;;EAIE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;mFACmF;AACnF;;;;;;;;EAQE,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;;EAEE,2CAA2C;EAC3C,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sDAAsD;AACxD;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,+CAA+C;EAC/C,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,WAAW;AACb;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,qCAAqC;AACvC;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,8DAA8D;AAC9D;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,wDAAwD;EACxD,6BAA6B;EAC7B,uBAAuB;EACvB,uCAAuC;EACvC,0BAA0B;EAC1B,2BAA2B;EAC3B,gDAAgD;EAChD,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;EAIE,wDAAwD;EACxD,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;;EAEE,SAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,sDAAsD;EACtD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;EAGE,+DAA+D;EAC/D;+BAC6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;;;;EAIE,kDAAkD;AACpD;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,4CAA4C;EAC5C,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;;;;EAIE,2EAA2E;AAC7E;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;;EAEE,4CAA4C;EAC5C,gBAAgB;EAChB,YAAY;EACZ,uDAAuD;EACvD,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,oCAAoC;EACpC,4BAA4B;EAC5B,qCAAqC;EACrC,2CAA2C;EAC3C;qCACmC;EACnC,aAAa;EACb,sDAAsD;EACtD,oBAAoB;EACpB;;;;;gBAKc;EACd;gDAC8C;EAC9C,sBAAsB;EACtB,kDAAkD;EAClD,oBAAoB;AACtB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,4CAA4C;EAC5C,oDAAoD;AACtD;AACA;EACE,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;;;;EAIE,4CAA4C;EAC5C,2EAA2E;AAC7E;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,WAAW;EACX,0DAA0D;AAC5D;;AAEA;;EAEE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;;EAGE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,8EAA8E;AAC9E;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,SAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,+CAA+C;EAC/C,2CAA2C;EAC3C,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,aAAa;EACb,mCAAmC;AACrC;;AAEA;;;;;;;;;;;;;;;;EAgBE,2CAA2C;EAC3C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,uCAAuC;EACvC,eAAe;EACf,mCAAmC;EACnC,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;EAgBE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,oCAAoC;EACpC,eAAe;EACf,mCAAmC;EACnC,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;EAgBE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,eAAe;EACf,mCAAmC;EACnC,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;EAgBE,mCAAmC;AACrC;;AAEA;;;;EAIE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;EAgBE,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,6CAA6C;EAC7C,qCAAqC;EACrC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;;;;;;;;;EAYE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;EAClC,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,+CAA+C;EAC/C,qCAAqC;EACrC,6CAA6C;EAC7C,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;;EAGE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE,mCAAmC;AACrC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;EAcE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;EAME,mCAAmC;AACrC;;AAEA;;EAEE,qCAAqC;EACrC,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA;;EAEE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;;;;;;;;;;EAUE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;;;;;;;;;;;;EAYE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,eAAe;EACf,mCAAmC;AACrC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4CAA4C;EAC5C,gDAAgD;EAChD,qCAAqC;EACrC;0CACwC;EACxC,gBAAgB;AAClB;;AAEA;;EAEE,4CAA4C;EAC5C,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;EACjC,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;;;;;;EAME,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;EAEE,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;;EAIE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,WAAW;AACb;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;;;;EAIE,0CAA0C;AAC5C;;AAEA,6EAA6E;AAC7E;EACE;IACE;mCAC+B;EACjC;;EAEA;;IAEE,wBAAwB;IACxB,mDAAmD;IACnD,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;;IAEE,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mDAAmD;IACnD,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,mCAAmC;EACrC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;;;IAGE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,OAAO;IACP,qCAAqC;IACrC,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;;;;IAME,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;;;IAKE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,uCAAuC;IACvC,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;IACd,8BAA8B;EAChC;AACF;;AAEA;EACE;;IAEE,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,cAAc;IACd,uBAAuB;EACzB;AACF;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,oDAAoD;EACpD,wCAAwC;EACxC,mCAAmC;EACnC,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,0CAA0C;EAC1C,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,kDAAkD;AACpD;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,+CAA+C;EAC/C,WAAW;EACX,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,2CAA2C;EAC3C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,+CAA+C;EACjD;AACF;;AAEA,iDAAiD;AACjD;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,uCAAuC;AACzC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,iEAAiE;EACjE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gDAAgD;EAChD,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,+CAA+C;EAC/C,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,iEAAiE;EACjE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iEAAiE;EACjE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,iEAAiE;EACjE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mDAAmD;EACnD,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;AACf;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE;IACE,kBAAkB;EACpB;EACA;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,gDAAgD;EAClD;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;;IAGE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAO;EACT;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6CAA6C;EAC7C,+CAA+C;EAC/C,qCAAqC;EACrC,WAAW;AACb;;AAEA;;EAEE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,6CAA6C;EAC7C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,6CAA6C;EAC7C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;+EAE+E;;AAE/E;EACE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,qCAAqC;EACrC,uBAAuB;EACvB,gCAAgC;EAChC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,+CAA+C;EAC/C,WAAW;EACX,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;EACxC,+CAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oEAAoE;EACpE,6CAA6C;EAC7C,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oEAAoE;EACpE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,+CAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,+CAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,+CAA+C;EAC/C,WAAW;EACX,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,gDAAgD;EAChD,qCAAqC;EACrC,6CAA6C;EAC7C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,wCAAwC;EACxC,+CAA+C;EAC/C,qCAAqC;EACrC,kDAAkD;EAClD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,0CAA0C;AAC1C;;;EAGE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,mCAAmC;AACrC;;AAEA;;;;EAIE,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;;;EAGE,6CAA6C;EAC7C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;EAIE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;;;;EAIE,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;EAEE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,+CAA+C;EAC/C,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gDAAgD;EAChD,qCAAqC;EACrC,6CAA6C;EAC7C,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,sEAAsE;AACtE;;;;;;;;;;;;;;;EAeE,qDAAqD;EACrD,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;;EAEE,gEAAgE;EAChE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;;EAEE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,wCAAwC;EACxC,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;;;;;EAKE,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,MAAM;EACN,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,8CAA8C;EAC9C,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,OAAO;IACP,6BAA6B;IAC7B,wCAAwC;EAC1C;AACF","sourcesContent":["/* ==========================================================================\n   QUOTATIONS PAGE — FIGMA SPEC IMPLEMENTATION\n   Nodes:\n   - Desktop Light: 534:47752 | Dark: 533:51767\n   - Tablet Light:  539:64178 | Dark: 539:65371\n   - Mobile Light:  551:41126 | Dark: 551:42114\n   ========================================================================== */\n\n/* --------------------------------------------------------------------------\n   Root Container & Variables Fallback\n   -------------------------------------------------------------------------- */\n.quotation-page {\n  --dash-bg: var(--bg-primary, #f4f7f7);\n  --dash-surface: var(--surface-primary, #ffffff);\n  --dash-surface-2: var(--surface-secondary, #f4f7f7);\n  --dash-surface-3: var(--surface-tertiary, #e8edec);\n  --dash-border: var(--border-subtle, #dce3e2);\n  --dash-border-strong: var(--border-default, #cdd6d4);\n  --dash-text: var(--text-primary, #142624);\n  --dash-muted: var(--text-secondary, #506360);\n  --dash-brand: var(--interactive-default, #0f766e);\n  --interactive-default: #0f766e;\n  --interactive-pressed: #0a4a46;\n  --interactive-soft: #f0f8f7;\n  --text-link: #0f766e;\n  --info-soft: #eff6ff;\n  --info-text: #1d4ed8;\n  --success-soft: #f0fdf4;\n  --success-text: #15803d;\n  --danger-soft: #fef2f1;\n  --danger-text: #a3301f;\n  --warning-soft: #fef8ec;\n  --warning-text: #7d4412;\n  --font-family-primary: \"Lexend\", -apple-system, BlinkMacSystemFont, sans-serif;\n  --font-family-mono: \"JetBrains Mono\", monospace;\n\n  min-height: 100vh;\n  display: flex;\n  background: var(--dash-bg);\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.quotation-page.dark,\n.quotation-page[data-theme=\"dark\"] {\n  --dash-bg: #101113;\n  --dash-surface: #191b1f;\n  --dash-surface-2: #22252a;\n  --dash-surface-3: #2b2f35;\n  --dash-border: #2c3036;\n  --dash-border-strong: #3a3f47;\n  --dash-text: #f2f3f5;\n  --dash-muted: #b3b8c2;\n  --dash-brand: #43a79c;\n  --interactive-default: #43a79c;\n  --interactive-pressed: #83c7be;\n  --interactive-soft: #22252a;\n  --text-link: #83c7be;\n  --info-soft: #1e2b3c;\n  --info-text: #aec9ec;\n  --success-soft: #1b332b;\n  --success-text: #8cd2b2;\n  --danger-soft: #382324;\n  --danger-text: #f3a6a1;\n  --warning-soft: #3b2e19;\n  --warning-text: #e5c17d;\n}\n\n.quotation-page *,\n.quotation-page *::before,\n.quotation-page *::after {\n  box-sizing: border-box;\n}\n\n/* --------------------------------------------------------------------------\n   Layout Shell\n   -------------------------------------------------------------------------- */\nhtml:has(.quotation-page, .quotation-editor-main-area) {\n  scrollbar-gutter: stable;\n}\n\n.quotation-page[data-theme] > .screen-loading-modal {\n  left: 256px !important;\n  top: var(--app-topbar-height, 64px) !important;\n  padding: 32px 32px 48px;\n  background: var(--bg-primary, #f4f7f7);\n  backdrop-filter: none;\n}\n\n.quotation-page > .screen-loading-modal > .screen-loading-shell {\n  width: 100%;\n  min-width: 0;\n}\n\n@media (min-width: 1025px) {\n  body.sidebar-collapsed .quotation-page > .screen-loading-modal {\n    left: 0 !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .quotation-page[data-theme] > .screen-loading-modal {\n    left: 0 !important;\n    padding: 24px 24px 36px;\n  }\n}\n\n@media (max-width: 767px) {\n  .quotation-page[data-theme] > .screen-loading-modal {\n    padding: 16px 16px 28px;\n  }\n}\n\n.quotation-page .dashboard-main {\n  flex: 1;\n  min-width: 0;\n  margin-left: 256px;\n  display: flex;\n  flex-direction: column;\n}\n\n.quotation-content {\n  width: 100%;\n  min-width: 0;\n  /* max-width: 1440px; */\n  margin: 0 auto;\n  padding: 32px 32px 48px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Hide tablet & mobile identity rows on desktop by default */\n.quotation-tablet-identity-row,\n.quotation-mobile-identity {\n  display: none;\n}\n\n/* --------------------------------------------------------------------------\n   Page Header\n   -------------------------------------------------------------------------- */\n.quotation-page-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-page-identity h1 {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n  color: var(--dash-text);\n}\n\n.quotation-page-identity p {\n  margin: 4px 0 0;\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--dash-muted);\n}\n\n.quotation-create-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border: none;\n  border-radius: 10px;\n  background: var(--interactive-default);\n  color: #ffffff !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease;\n  flex-shrink: 0;\n}\n\n.quotation-page.dark .quotation-create-btn,\n.quotation-page[data-theme=\"dark\"] .quotation-create-btn {\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.quotation-create-btn:hover {\n  background: var(--interactive-pressed);\n}\n\n.quotation-create-btn svg {\n  font-size: 16px;\n}\n\n.quotation-snapshot-context {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--dash-muted);\n}\n\n/* --------------------------------------------------------------------------\n   Quote Stat Summary Cards\n   -------------------------------------------------------------------------- */\n.quotation-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  width: 100%;\n  min-width: 0;\n}\n\n.quotation-stat-card {\n  min-width: 0;\n  max-width: 100%;\n  min-height: 154px;\n  padding: 24px;\n  border-radius: 14px;\n  border: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.quotation-stat-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n}\n\n.quotation-stat-card-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--dash-text);\n}\n\n.quotation-stat-card-header svg {\n  font-size: 20px;\n  color: var(--interactive-default);\n  flex-shrink: 0;\n}\n\n.quotation-stat-card-headline {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.quotation-stat-card-headline strong {\n  font-family: var(--font-family-mono);\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 26.4px;\n  color: var(--dash-text);\n}\n\n.quotation-stat-card-headline p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--dash-muted);\n}\n\n/* --------------------------------------------------------------------------\n   Quotations Management (Tabs & Filters)\n   -------------------------------------------------------------------------- */\n.quotation-management {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-tabs-wrap {\n  border-bottom: 1px solid var(--dash-border);\n  width: 100%;\n}\n\n.quotation-tabs {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.quotation-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.quotation-tab-btn {\n  height: 40px;\n  padding: 0 12px;\n  border: none;\n  background: transparent;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: var(--font-size-label-md, 14px);\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-label-md, 18.2px);\n  letter-spacing: var(--letter-spacing-label-md, 0.07px);\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n  white-space: nowrap;\n  position: relative;\n  transition: color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.quotation-tab-btn:hover {\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-tab-btn.active {\n  color: var(--text-link);\n}\n\n.quotation-tab-btn.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: var(--interactive-default);\n  border-radius: 2px 2px 0 0;\n}\n\n/* Filter Controls Row */\n.quotation-filter-controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n}\n\n.quotation-filter-search {\n  height: 40px;\n  width: 320px;\n  min-width: 80px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--dash-surface);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.quotation-filter-search:hover {\n  border-color: var(--border-strong, #aebab8);\n}\n\n.quotation-filter-search:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n}\n\n.quotation-filter-search svg {\n  font-size: 16px;\n  color: var(--dash-muted);\n  flex-shrink: 0;\n}\n\n.quotation-filter-search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  color: var(--dash-text);\n}\n\n.quotation-filter-search input::placeholder {\n  color: var(--dash-muted);\n}\n\n.quotation-dropdowns-group {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.quotation-select-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.quotation-select-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  outline: none;\n  white-space: nowrap;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease,\n    background 0.15s ease;\n}\n\n.quotation-select-trigger:hover {\n  border-color: var(--border-strong, #aebab8);\n}\n\n.quotation-select-trigger.is-open,\n.quotation-select-trigger:focus-visible {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n\n.quotation-select-value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.quotation-select-trigger .select-arrow {\n  font-size: 16px;\n  color: var(--text-secondary, #506360);\n  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.quotation-select-trigger.is-open .select-arrow {\n  transform: rotate(180deg);\n}\n\n/* Dark mode for select trigger */\n.quotation-page.dark .quotation-select-trigger,\n.quotation-page[data-theme=\"dark\"] .quotation-select-trigger {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-page.dark .quotation-select-trigger:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-select-trigger:hover {\n  border-color: var(--border-strong, #69727e);\n}\n\n.quotation-page.dark .quotation-select-trigger.is-open,\n.quotation-page.dark .quotation-select-trigger:focus-visible,\n.quotation-page[data-theme=\"dark\"] .quotation-select-trigger.is-open,\n.quotation-page[data-theme=\"dark\"] .quotation-select-trigger:focus-visible {\n  border-color: var(--interactive-default, #43a79c);\n  box-shadow: none;\n}\n\n.quotation-page.dark .quotation-select-trigger .select-arrow,\n.quotation-page[data-theme=\"dark\"] .quotation-select-trigger .select-arrow {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* Native select fallback */\n.quotation-select-wrap select {\n  appearance: none;\n  -webkit-appearance: none;\n  height: 40px;\n  padding: 0 32px 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.quotation-select-wrap select:hover {\n  border-color: var(--border-strong, #aebab8);\n}\n\n.quotation-select-wrap select:focus {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n\n.quotation-page.dark .quotation-select-wrap select,\n.quotation-page[data-theme=\"dark\"] .quotation-select-wrap select {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-select-wrap select option {\n  background: var(--surface-elevated, #ffffff);\n  color: var(--text-primary, #142624);\n}\n\n.quotation-page.dark .quotation-select-wrap select option,\n.quotation-page[data-theme=\"dark\"] .quotation-select-wrap select option {\n  background: var(--surface-elevated, #25282e);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-select-wrap > .select-arrow {\n  position: absolute;\n  right: 12px;\n  pointer-events: none;\n  font-size: 16px;\n  color: var(--text-secondary, #506360);\n}\n\n/* Dropdown Menu Panel (Figma Node 122:3500) */\n.quotation-dropdown-panel {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 100;\n  min-width: 100%;\n  width: max-content;\n  max-width: 280px;\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 4px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-elevated, #ffffff);\n  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),\n    0px 1px 1px rgba(14, 26, 32, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.quotation-page.dark .quotation-dropdown-panel,\n.quotation-page[data-theme=\"dark\"] .quotation-dropdown-panel {\n  background: var(--surface-elevated, #25282e);\n  border-color: var(--border-default, #3a3f47);\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.35), 0px 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.quotation-dropdown-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  height: 36px;\n  padding: 0 12px;\n  border-radius: 4px;\n  border: none;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease;\n  white-space: nowrap;\n}\n\n.quotation-dropdown-item:hover {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n\n.quotation-dropdown-item.is-selected {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n  font-weight: 500;\n}\n\n.quotation-dropdown-item-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.quotation-dropdown-check-icon {\n  font-size: 16px;\n  color: var(--interactive-default, #0f766e);\n  flex-shrink: 0;\n}\n\n.quotation-page.dark .quotation-dropdown-item,\n.quotation-page[data-theme=\"dark\"] .quotation-dropdown-item {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-page.dark .quotation-dropdown-item:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-dropdown-item:hover {\n  background: var(--surface-secondary, #22252a);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-page.dark .quotation-dropdown-item.is-selected,\n.quotation-page[data-theme=\"dark\"] .quotation-dropdown-item.is-selected {\n  background: var(--interactive-soft, #22252a);\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-page.dark .quotation-dropdown-check-icon,\n.quotation-page[data-theme=\"dark\"] .quotation-dropdown-check-icon {\n  color: var(--interactive-default, #43a79c);\n}\n\n/* --------------------------------------------------------------------------\n   Table Card & Layout\n   -------------------------------------------------------------------------- */\n.quotation-table-card {\n  width: 100%;\n  min-width: 0;\n  border-radius: 14px;\n  border: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n  box-shadow: 0px 1px 2px rgba(14, 26, 32, 0.06);\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n}\n\n.quotation-table-context {\n  height: 48px;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--dash-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n}\n\n.quotation-table-context strong {\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.07px;\n  color: var(--dash-text);\n}\n\n.quotation-table-context span {\n  font-size: 13px;\n  letter-spacing: 0.065px;\n  color: var(--dash-muted);\n}\n\n.quotation-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.quotation-table-card table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.quotation-table-card th {\n  height: 44px;\n  padding: 0 16px;\n  background: var(--dash-surface-2);\n  border-bottom: 1px solid var(--dash-border);\n  color: var(--dash-muted);\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.07px;\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.quotation-table-card td {\n  height: 52px;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--dash-border);\n  font-size: 14px;\n  color: var(--dash-text);\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.quotation-table-card tbody tr:hover {\n  background: var(--dash-surface-2);\n}\n\n.quotation-clickable-row {\n  cursor: pointer;\n}\n\n.quotation-clickable-row:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: -2px;\n}\n\n.quotation-clickable-row a,\n.quotation-clickable-row button,\n.quotation-clickable-row input {\n  cursor: pointer;\n}\n\n/* Checkboxes */\n.quotation-table-card input[type=\"checkbox\"],\n.quotation-mobile-checkbox {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  border-radius: 4px;\n  accent-color: var(--interactive-default);\n  cursor: pointer;\n}\n\n/* Desktop Columns Widths */\n.col-checkbox {\n  width: 48px;\n  text-align: center;\n  padding: 0 8px !important;\n}\n\n.quotation-table-card .col-checkbox > input[type=\"checkbox\"] {\n  display: block;\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n.col-quoteno {\n  width: 140px;\n}\n.col-customer {\n  width: 232px;\n}\n.col-created {\n  width: 124px;\n  color: var(--dash-muted) !important;\n}\n.col-valid {\n  width: 124px;\n  color: var(--dash-muted) !important;\n}\n.col-status {\n  width: 112px;\n}\n.col-amount {\n  width: 128px;\n  text-align: right;\n  font-family: var(--font-family-mono);\n  font-weight: 500;\n  font-size: 16px !important;\n}\n.col-actions {\n  width: 220px;\n  text-align: right;\n  padding: 0 16px !important;\n}\n\n.quotation-page\n  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)\n  table {\n  table-layout: fixed;\n}\n\n.quotation-page\n  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)\n  :is(th, td):is(.col-quoteno, .col-customer, .col-created, .col-valid, .col-status, .col-amount, .col-actions, .tab-col-custquote, .tab-col-statusvalid, .tab-col-amount, .tab-col-actions) {\n  width: auto;\n  text-align: left;\n}\n\n.quotation-page\n  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)\n  :is(th, td) {\n  padding-inline: 16px;\n  vertical-align: middle;\n}\n\n.quotation-page\n  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)\n  :is(.col-checkbox, .tab-col-checkbox) {\n  width: 48px;\n  text-align: center;\n}\n\n.quotation-page\n  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)\n  :is(.col-amount, .col-actions, .tab-col-amount, .tab-col-actions) {\n  text-align: right;\n}\n\n.quotation-page .quotation-desktop-table-card td.col-customer {\n  max-width: 28ch;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n/* Reserve room for inline actions; headings and loading rows share the columns. */\n.quotation-page .quotation-desktop-table-card table {\n  --quotation-actions-width: 208px;\n  min-width: 0;\n}\n\n.quotation-page .quotation-desktop-table-card col {\n  width: calc((100% - var(--quotation-actions-width)) / 6);\n}\n\n.quotation-page .quotation-desktop-table-card col.col-actions {\n  width: var(--quotation-actions-width);\n}\n\n.quotation-page .quotation-desktop-table-card :is(th, td) {\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.quotation-page\n  .quotation-desktop-table-card\n  :is(th, td):is(.col-amount, .col-actions) {\n  text-align: left;\n}\n\n.quotation-page .quotation-desktop-table-card th.col-amount {\n  font-family: var(--font-family-primary);\n  font-size: 14px !important;\n}\n\n.quotation-page .quotation-desktop-table-card td.col-amount {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quotation-page .quotation-desktop-table-card th.col-actions {\n  text-align: center;\n}\n\n.quotation-page .quotation-desktop-table-card .quotation-row-actions-group {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  gap: 8px;\n  align-items: center;\n  padding-block: 8px;\n}\n\n.quotation-page .quotation-desktop-table-card .quotation-row-action-btn {\n  flex: 0 0 auto;\n  min-height: 32px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: var(--radius-sm, 6px);\n  white-space: nowrap;\n}\n\n.quotation-page\n  .quotation-desktop-table-card\n  .quotation-row-actions-group\n  .quotation-dots-btn {\n  flex: 0 0 24px;\n  width: 24px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  box-shadow: none;\n}\n\n.quotation-page\n  .quotation-desktop-table-card\n  .quotation-row-actions-group\n  .quotation-dots-btn:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-page .quotation-tablet-table-card .tab-cust-name {\n  max-width: 28ch;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.quotation-row-actions-group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  position: relative;\n}\n\n.quotation-page\n  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)\n  :is(th, td):is(.col-actions, .tab-col-actions) {\n  text-align: center;\n}\n\n.quotation-page\n  :is(.quotation-desktop-table-card, .quotation-tablet-table-card)\n  .quotation-row-actions-group {\n  justify-content: center;\n}\n\n.quotation-row-action-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 132px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 10px;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.quotation-invoice-created {\n  box-sizing: border-box;\n  text-decoration: none;\n}\n\n.quotation-invoice-created:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\n.quotation-row-send-btn {\n  background: var(--dash-surface-2, #f4f7f7);\n  border: 1px solid var(--dash-border-strong, #cdd6d4);\n  color: var(--dash-text, #142624);\n}\n\n.quotation-row-send-btn:hover {\n  background: var(--dash-surface-3, #e8edec);\n}\n\n.quotation-row-send-btn > svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  stroke-width: 1.75;\n}\n\n.quotation-page.dark .quotation-row-send-btn,\n.quotation-page[data-theme=\"dark\"] .quotation-row-send-btn {\n  background: var(--dash-surface-2, #22252a);\n  border-color: var(--dash-border-strong, #3a3f47);\n  color: var(--dash-text, #f2f3f5);\n}\n\n.quotation-page.dark .quotation-row-send-btn:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-row-send-btn:hover {\n  background: var(--dash-surface-3, #2b2f35);\n}\n\n.quotation-row-invoice-btn {\n  background: var(--interactive-default);\n  color: #ffffff !important;\n  border: none;\n}\n\n.quotation-page.dark .quotation-row-invoice-btn,\n.quotation-page[data-theme=\"dark\"] .quotation-row-invoice-btn {\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.quotation-row-invoice-btn:hover {\n  background: var(--interactive-pressed);\n}\n\n.quotation-row-send-btn-sm,\n.quotation-row-invoice-btn-sm {\n  height: 28px;\n  padding: 0 8px;\n  font-size: 12px;\n  border-radius: 8px;\n}\n\n.quotation-dots-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  border: 1px solid var(--dash-border-strong, #cdd6d4);\n  background: var(--dash-surface, #ffffff);\n  color: var(--dash-muted, #506360);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.quotation-dots-btn:hover {\n  background: var(--dash-surface-2, #f4f7f7);\n  color: var(--dash-text, #142624);\n}\n\n.quotation-page.dark .quotation-dots-btn,\n.quotation-page[data-theme=\"dark\"] .quotation-dots-btn {\n  background: var(--dash-surface-2, #22252a);\n  border-color: var(--dash-border-strong, #3a3f47);\n  color: var(--dash-muted, #b3b8c2);\n}\n\n.quotation-page.dark .quotation-dots-btn:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-dots-btn:hover {\n  background: var(--dash-surface-3, #2b2f35);\n  color: var(--dash-text, #f2f3f5);\n}\n\n.quotation-dots-btn svg {\n  font-size: 16px;\n}\n\n/* Monospace links */\n.quotation-mono-link,\n.quotation-mono-link:link,\n.quotation-mono-link:visited {\n  font-family: var(--font-family-mono);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.28px;\n  color: var(--text-link, #0f766e);\n  text-transform: uppercase;\n  text-decoration: none;\n}\n\n.quotation-mono-link:hover,\n.quotation-mono-link:active {\n  color: var(--text-link, #0f766e);\n  text-decoration: underline !important;\n  text-underline-offset: 2px;\n}\n\n.quotation-mono-link:focus-visible {\n  color: var(--text-link, #0f766e);\n  border-radius: 2px;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n.quotation-contact-link {\n  color: var(--interactive-default, #0f766e);\n  font: inherit;\n  text-decoration: none;\n  text-underline-offset: 2px;\n}\n\n.quotation-contact-link:hover {\n  text-decoration: underline !important;\n  color: var(--interactive-default, #0f766e);\n}\n\n.quotation-contact-link:focus-visible {\n  border-radius: 2px;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n.tab-cust-name.quotation-contact-link {\n  color: var(--interactive-default, #0f766e);\n}\n\n.quote-customer-link {\n  color: inherit;\n  text-decoration: none;\n  text-underline-offset: 2px;\n}\n\n.quote-customer-link:hover {\n  text-decoration: underline !important;\n  color: #0f766e;\n}\n\n.quote-customer-link:focus-visible {\n  border-radius: 2px;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n/* --------------------------------------------------------------------------\n   Status Badges (Light & Dark matching Figma)\n   -------------------------------------------------------------------------- */\n.quotation-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.12px;\n  white-space: nowrap;\n}\n\n.quotation-status.viewed,\n.quotation-status.sent {\n  background: var(--info-soft);\n  color: var(--info-text);\n}\n\n.quotation-status.approved {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n\n.quotation-status.draft {\n  background: var(--dash-surface-3);\n  color: var(--dash-muted);\n}\n\n.quotation-status.declined {\n  background: var(--danger-soft);\n  color: var(--danger-text);\n}\n\n.quotation-status.expired {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n\n.quotation-status.voided {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n\n/* --------------------------------------------------------------------------\n   Row Actions & Action Menu Dropdown\n   -------------------------------------------------------------------------- */\n.quotation-row-action {\n  position: relative;\n  text-align: center;\n}\n\n.quotation-dots-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--dash-muted);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.quotation-dots-btn:hover {\n  background: var(--dash-surface-3);\n  color: var(--dash-text);\n}\n\n.quotation-dots-btn svg {\n  font-size: 16px;\n}\n\n.quotation-action-menu {\n  box-sizing: border-box;\n  position: absolute;\n  top: 38px;\n  right: 0;\n  z-index: 50;\n  width: 240px;\n  padding: 4px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-elevated, #ffffff);\n  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),\n    0px 1px 1px rgba(14, 26, 32, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left;\n}\n\n.quotation-page.dark .quotation-action-menu,\n.quotation-page[data-theme=\"dark\"] .quotation-action-menu {\n  background: var(--surface-elevated, #25282e);\n  border-color: var(--border-default, #3a3f47);\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.35), 0px 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.quotation-action-menu a,\n.quotation-action-menu button,\n.quotation-menu-item {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: normal;\n  text-align: left;\n  text-transform: none;\n  color: var(--text-primary, #142624);\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease;\n  white-space: nowrap;\n}\n\n.quotation-menu-item > span {\n  font: inherit;\n  letter-spacing: inherit;\n}\n\n.quotation-menu-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  color: inherit;\n}\n\n.quotation-page.dark .quotation-action-menu a,\n.quotation-page.dark .quotation-action-menu button,\n.quotation-page.dark .quotation-menu-item,\n.quotation-page[data-theme=\"dark\"] .quotation-action-menu a,\n.quotation-page[data-theme=\"dark\"] .quotation-action-menu button,\n.quotation-page[data-theme=\"dark\"] .quotation-menu-item {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-action-menu a:hover,\n.quotation-action-menu button:hover,\n.quotation-menu-item:hover {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n\n.quotation-page.dark .quotation-action-menu a:hover,\n.quotation-page.dark .quotation-action-menu button:hover,\n.quotation-page.dark .quotation-menu-item:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-action-menu a:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-action-menu button:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-menu-item:hover {\n  background: var(--surface-secondary, #22252a);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-action-menu .disabled,\n.quotation-menu-item.disabled,\n.quotation-menu-item:disabled {\n  opacity: 0.45;\n  pointer-events: auto;\n  cursor: not-allowed;\n}\n\n.quotation-menu-item:disabled:hover {\n  background: transparent !important;\n}\n\n.quotation-action-menu .quotation-action-delete,\n.quotation-menu-item-delete {\n  color: var(--danger-text, #a3301f) !important;\n}\n\n.quotation-page.dark .quotation-action-menu .quotation-action-delete,\n.quotation-page.dark .quotation-menu-item-delete,\n.quotation-page[data-theme=\"dark\"]\n  .quotation-action-menu\n  .quotation-action-delete,\n.quotation-page[data-theme=\"dark\"] .quotation-menu-item-delete {\n  color: var(--danger-text, #f3aaa4) !important;\n}\n\n.quotation-action-menu .quotation-action-delete:hover,\n.quotation-menu-item-delete:hover {\n  background: var(--danger-soft, #fef2f1) !important;\n  color: var(--danger-text, #a3301f) !important;\n}\n\n.quotation-page.dark .quotation-action-menu .quotation-action-delete:hover,\n.quotation-page.dark .quotation-menu-item-delete:hover,\n.quotation-page[data-theme=\"dark\"]\n  .quotation-action-menu\n  .quotation-action-delete:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-menu-item-delete:hover {\n  background: var(--danger-soft, #332022) !important;\n  color: var(--danger-text, #f3aaa4) !important;\n}\n\n.quotation-empty-cell {\n  height: 120px !important;\n  text-align: center !important;\n  color: var(--dash-muted);\n  font-size: 14px;\n}\n\n/* --------------------------------------------------------------------------\n   Pagination Footer\n   -------------------------------------------------------------------------- */\n.quotation-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n  padding: 0 16px;\n  border-top: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n  border-radius: 0 0 14px 14px;\n}\n\n.quotation-pagination span {\n  font-size: 13px;\n  color: var(--dash-muted);\n}\n\n.quotation-pagination-btns {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.quotation-pagination-btns button {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  border: 1px solid var(--dash-border-strong);\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.quotation-pagination-btns button:hover:not(:disabled) {\n  background: var(--dash-surface-2);\n}\n\n.quotation-pagination-btns button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.quotation-pagination-btns svg {\n  font-size: 16px;\n}\n\n/* --------------------------------------------------------------------------\n   Disclaimer Note\n   -------------------------------------------------------------------------- */\n.quotation-disclaimer {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--dash-muted);\n}\n\n/* ==========================================================================\n   DESKTOP / TABLET / MOBILE VISIBILITY SWITCHES\n   ========================================================================== */\n.quotation-desktop-table-card {\n  display: flex;\n}\n.quotation-tablet-table-card {\n  display: none;\n}\n.quotation-mobile-view {\n  display: none;\n}\n\n/* ==========================================================================\n   TABLET VIEW (768px - 1024px) — Figma Node 539:64178 / 539:65371\n   ========================================================================== */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .quotation-page .dashboard-main {\n    margin-left: 0 !important;\n  }\n\n  .quotation-content {\n    padding: 24px 24px 36px !important;\n    gap: 20px !important;\n  }\n\n  /* Identity row in tablet content (Launcher + Org selector) */\n  .quotation-tablet-identity-row {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    width: 100% !important;\n  }\n\n  .quotation-tablet-identity-row .dashboard-product-identity {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n  }\n\n  .quotation-tablet-identity-row .dashboard-mobile-org {\n    max-width: 220px !important;\n    width: 100% !important;\n  }\n\n  .quotation-tablet-identity-row .dashboard-mobile-org .org-switch-icon {\n    color: var(--interactive-default) !important;\n  }\n\n  .quotation-mobile-identity {\n    display: none !important;\n  }\n\n  /* Heading */\n  .quotation-page-identity h1 {\n    font-size: 28px !important;\n    line-height: 35px !important;\n    letter-spacing: -0.42px !important;\n  }\n\n  .quotation-page-identity p {\n    font-size: 13px !important;\n    line-height: 20.2px !important;\n  }\n\n  /* Summary Grid: 2 columns in row 1, 1 full-width card in row 2 */\n  .quotation-summary-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 12px !important;\n  }\n\n  .quotation-stat-card {\n    padding: 20px !important;\n    gap: 16px !important;\n  }\n\n  .quotation-stat-card-full {\n    grid-column: 1 / -1 !important;\n  }\n\n  .quotation-stat-card-header h3 {\n    font-size: 17px !important;\n    line-height: 23.8px !important;\n  }\n\n  .quotation-stat-card-headline strong {\n    font-size: 20px !important;\n    line-height: 24px !important;\n  }\n\n  /* Filters */\n  .quotation-filter-controls {\n    display: flex !important;\n    gap: 12px !important;\n  }\n\n  .quotation-filter-search {\n    flex: 1 !important;\n    width: auto !important;\n  }\n\n  /* Switch Table views */\n  .quotation-desktop-table-card {\n    display: none !important;\n  }\n\n  .quotation-tablet-table-card {\n    display: flex !important;\n  }\n\n  .quotation-mobile-view {\n    display: none !important;\n  }\n\n  /* Tablet Table Column styling */\n  .tab-col-checkbox {\n    width: 48px;\n    text-align: center;\n    padding: 0 8px !important;\n  }\n  .tab-col-custquote {\n    width: 225px;\n  }\n  .tab-col-statusvalid {\n    width: 184px;\n  }\n  .tab-col-amount {\n    width: 144px;\n    text-align: right;\n    font-family: var(--font-family-mono);\n    font-weight: 500;\n    font-size: 15px !important;\n  }\n  .tab-col-actions {\n    text-align: center;\n  }\n\n  .tab-custquote-inner {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .tab-cust-name {\n    font-size: 13px;\n    line-height: 20.2px;\n    color: var(--dash-text);\n  }\n\n  .tab-created-date {\n    font-size: 13px;\n    line-height: 18.2px;\n    color: var(--dash-muted);\n  }\n\n  .tab-statusvalid-inner {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    align-items: flex-start;\n  }\n\n  .tab-valid-text {\n    font-size: 13px;\n    line-height: 18.2px;\n    color: var(--dash-muted);\n  }\n\n  .quotation-tablet-table-card td {\n    height: 104px !important;\n    padding: 16px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE VIEW (max-width: 767px) — Figma Node 551:41126 / 551:42114\n   ========================================================================== */\n@media (max-width: 767px) {\n  .quotation-page .dashboard-main {\n    margin-left: 0 !important;\n  }\n\n  .quotation-content {\n    padding: 16px 16px 28px !important;\n    gap: 20px !important;\n  }\n\n  /* Identity in mobile content */\n  .quotation-tablet-identity-row {\n    display: none !important;\n  }\n\n  .quotation-mobile-identity {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 12px !important;\n    width: 100% !important;\n  }\n\n  .quotation-mobile-brand-title {\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16.9px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n  }\n\n  .quotation-mobile-identity .dashboard-mobile-org {\n    width: 100% !important;\n  }\n\n  .quotation-mobile-identity .dashboard-mobile-org .org-switch-icon {\n    color: var(--interactive-default) !important;\n  }\n\n  /* Header */\n  .quotation-page-header {\n    gap: 12px !important;\n  }\n\n  .quotation-title-row {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 12px !important;\n  }\n\n  .quotation-page-identity h1 {\n    font-size: 24px !important;\n    line-height: 30px !important;\n    letter-spacing: -0.36px !important;\n  }\n\n  .quotation-page-identity p {\n    font-size: 13px !important;\n    line-height: 20.2px !important;\n  }\n\n  .quotation-create-btn {\n    width: 100% !important;\n    height: 40px !important;\n  }\n\n  .quotation-snapshot-context {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 4px !important;\n  }\n\n  /* Summary Stat Cards: 1 column stacked */\n  .quotation-summary-grid {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 12px !important;\n  }\n\n  .quotation-stat-card {\n    padding: 16px !important;\n    min-height: auto !important;\n    gap: 16px !important;\n  }\n\n  .quotation-stat-card-header h3 {\n    font-size: 16px !important;\n    line-height: 22.4px !important;\n  }\n\n  .quotation-stat-card-headline strong {\n    font-size: 20px !important;\n    line-height: 24px !important;\n  }\n\n  /* Tabs horizontal scroll with fade */\n  .quotation-tabs-wrap {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .quotation-tab-btn {\n    padding: 0 8px !important;\n  }\n\n  /* Filters */\n  .quotation-filter-controls {\n    flex-direction: column !important;\n    gap: 12px !important;\n    width: 100% !important;\n  }\n\n  .quotation-filter-search {\n    width: 100% !important;\n  }\n\n  .quotation-dropdowns-group {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr !important;\n    gap: 12px !important;\n    width: 100% !important;\n  }\n\n  .quotation-select-wrap {\n    width: 100% !important;\n  }\n\n  .quotation-select-trigger {\n    width: 100% !important;\n  }\n\n  .quotation-select-wrap select {\n    width: 100% !important;\n  }\n\n  .quotation-dropdown-panel {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  /* Hide table cards on mobile, show card list */\n  .quotation-desktop-table-card {\n    display: none !important;\n  }\n\n  .quotation-tablet-table-card {\n    display: none !important;\n  }\n\n  .quotation-mobile-view {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 12px !important;\n    width: 100% !important;\n  }\n\n  .quotation-mobile-list-header {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    margin-top: 4px;\n  }\n\n  .quotation-mobile-list-heading-left strong {\n    display: block;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n    color: var(--dash-text);\n  }\n\n  .quotation-mobile-list-heading-left span {\n    font-size: 13px;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n  }\n\n  .quotation-mobile-select-btn {\n    height: 40px;\n    padding: 0 16px;\n    border-radius: 10px;\n    border: 1px solid var(--dash-border-strong);\n    background: var(--dash-surface-2);\n    color: var(--dash-text);\n    font-family: var(--font-family-primary);\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n  }\n\n  .quotation-mobile-select-btn.active {\n    background: var(--interactive-default);\n    color: #ffffff;\n    border-color: var(--interactive-default);\n  }\n\n  .quotation-mobile-cards-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .quotation-mobile-card {\n    min-width: 0;\n    max-width: 100%;\n    padding: 16px;\n    border-radius: 14px;\n    border: 1px solid var(--dash-border);\n    background: var(--dash-surface);\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .quotation-mobile-card-top {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n  }\n\n  .quotation-mobile-card[aria-hidden=\"true\"] .quotation-mobile-card-top > *,\n  .quotation-mobile-card[aria-hidden=\"true\"] .quotation-mobile-card-mid > * {\n    min-width: 0;\n  }\n\n  .quotation-mobile-card-top .quotation-mono-link {\n    flex: 1;\n  }\n\n  .quotation-mobile-card-top:has(.quotation-row-action-btn) {\n    flex-wrap: wrap;\n  }\n\n  .quotation-mobile-dots:has(.quotation-row-action-btn) {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin-left: auto;\n  }\n\n  .quotation-mobile-card-client strong {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20.2px;\n    color: var(--dash-text);\n  }\n\n  .quotation-mobile-card-mid {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .quotation-mobile-validity {\n    font-size: 13px;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n  }\n\n  .quotation-mobile-amount {\n    font-family: var(--font-family-mono);\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 19.5px;\n    color: var(--dash-text);\n  }\n\n  .quotation-mobile-card-footer {\n    font-size: 13px;\n    line-height: 18.2px;\n    letter-spacing: 0.065px;\n    color: var(--dash-muted);\n  }\n\n  .quotation-mobile-pagination {\n    border-radius: 14px !important;\n    border: 1px solid var(--dash-border) !important;\n  }\n\n  .quotation-empty-mobile {\n    padding: 32px 16px;\n    text-align: center;\n    color: var(--dash-muted);\n    font-size: 14px;\n  }\n}\n\n/* ==========================================================================\n   BULK SELECTION TOOLBAR & HIGHLIGHTS (Nodes 533:53489 / 534:20604)\n   ========================================================================== */\n.quotation-bulk-toolbar {\n  height: 64px;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-radius: 14px 14px 0 0;\n}\n\n.quotation-bulk-summary {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--dash-text);\n  letter-spacing: 0.07px;\n}\n\n.quotation-bulk-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.quotation-bulk-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  white-space: nowrap;\n}\n\n.quotation-bulk-send {\n  background: var(--interactive-default);\n  color: #ffffff !important;\n  border: none;\n}\n\n.quotation-page.dark .quotation-bulk-send,\n.quotation-page[data-theme=\"dark\"] .quotation-bulk-send {\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.quotation-bulk-send:hover {\n  background: var(--interactive-pressed);\n}\n\n.quotation-bulk-send svg {\n  font-size: 16px;\n}\n\n.quotation-bulk-deselect {\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  border: 1px solid var(--dash-border-strong);\n}\n\n.quotation-bulk-deselect:hover {\n  background: var(--dash-surface-2);\n}\n\n/* Selected row highlight */\n.quotation-table-card tbody tr.is-selected-row,\n.quotation-table-card tbody tr.is-selected-row:hover {\n  background: var(--success-soft, #f0fdf4);\n}\n\n.quotation-page.dark .quotation-table-card tbody tr.is-selected-row,\n.quotation-page.dark .quotation-table-card tbody tr.is-selected-row:hover,\n.quotation-page[data-theme=\"dark\"]\n  .quotation-table-card\n  tbody\n  tr.is-selected-row,\n.quotation-page[data-theme=\"dark\"]\n  .quotation-table-card\n  tbody\n  tr.is-selected-row:hover {\n  background: rgba(67, 167, 156, 0.12);\n}\n\n/* Selected mobile card highlight */\n.quotation-mobile-card.is-selected-card {\n  background: var(--success-soft, #f0fdf4);\n  border-color: var(--interactive-default);\n}\n\n.quotation-page.dark .quotation-mobile-card.is-selected-card,\n.quotation-page[data-theme=\"dark\"] .quotation-mobile-card.is-selected-card {\n  background: rgba(67, 167, 156, 0.12);\n  border-color: var(--interactive-default);\n}\n\n/* Mobile toolbar */\n.quotation-bulk-toolbar-mobile {\n  border-radius: 14px;\n  border: 1px solid var(--dash-border);\n  margin-bottom: 8px;\n}\n\n@media (max-width: 767px) {\n  .quotation-bulk-toolbar-mobile {\n    height: auto;\n    min-height: 52px;\n    padding: 12px 16px;\n    flex-wrap: wrap;\n    row-gap: 10px;\n  }\n}\n\n/* ==========================================================================\n   FILTER ACTION BUTTON\n   ========================================================================== */\n.quotation-clear-filters-action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.quotation-clear-filters-action:hover {\n  background: var(--dash-surface-2);\n  border-color: var(--dash-border-strong);\n}\n\n/* ==========================================================================\n   STATE MESSAGE DISPLAYS (Initial Empty, Filtered Empty, Loading)\n   Nodes: 533:52988 / 534:20434, 533:53198 / 534:20393, 533:53420 / 534:20372\n   ========================================================================== */\n.quotation-state-cell {\n  height: 320px !important;\n  text-align: center !important;\n  vertical-align: middle !important;\n  padding: 40px 16px !important;\n}\n\n.quotation-state-mobile {\n  border-radius: 14px;\n  border: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 280px;\n  padding: 32px 16px;\n}\n\n.quotation-state-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  max-width: 520px;\n  text-align: center;\n}\n\n.quotation-state-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: var(--dash-surface-2);\n  border: 1px solid var(--dash-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  color: var(--interactive-default);\n  margin-bottom: 16px;\n}\n\n.quotation-state-message h4 {\n  margin: 0 0 8px;\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.2px;\n  color: var(--dash-text);\n}\n\n.quotation-state-message p {\n  margin: 0 0 20px;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--dash-muted);\n  max-width: 480px;\n}\n\n.quotation-clear-filters-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: 1px solid var(--dash-border-strong);\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quotation-clear-filters-btn:hover {\n  background: var(--dash-surface-2);\n}\n\n/* Loading spinner */\n.quotation-loading-spinner {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 3px solid var(--dash-border);\n  border-top-color: var(--interactive-default);\n  animation: quotation-spin 0.8s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes quotation-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* ==========================================================================\n   SEND QUOTE MODAL DIALOG — Figma Node 574:39806 / 574:41037\n   ========================================================================== */\n.quotation-dialog-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(14, 26, 32, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.catalogue-item-modal.quotation-editor-shell {\n  background: transparent !important;\n}\n\n.quotation-page.dark .quotation-dialog-scrim,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-scrim {\n  background: rgba(16, 17, 19, 0.64);\n}\n\n.quotation-send-dialog {\n  width: 100%;\n  max-width: 640px;\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #e8edec);\n  border-radius: var(--radius-lg, 14px);\n  box-shadow: 0px 6px 16px -4px rgba(14, 26, 32, 0.1),\n    0px 1px 2px 0px rgba(14, 26, 32, 0.04);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: quotation-dialog-appear 0.18s ease-out;\n}\n\n@keyframes quotation-dialog-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.97) translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.quotation-page.dark .quotation-send-dialog,\n.quotation-page[data-theme=\"dark\"] .quotation-send-dialog {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n  box-shadow: 0px 10px 25px -4px rgba(0, 0, 0, 0.5),\n    0px 2px 4px 0px rgba(0, 0, 0, 0.3);\n}\n\n.quotation-dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 24px 24px 20px;\n  border-bottom: 1px solid var(--border-subtle, #e8edec);\n}\n\n.quotation-page.dark .quotation-dialog-header,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-header {\n  border-bottom-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-dialog-header h3 {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-page.dark .quotation-dialog-header h3,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-header h3 {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-dialog-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md, 10px);\n  border: none;\n  background: transparent;\n  color: var(--dash-muted, #506360);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.quotation-dialog-close-btn:hover {\n  background: var(--dash-surface-2, #f4f7f7);\n  color: var(--dash-text, #142624);\n}\n\n.quotation-page.dark .quotation-dialog-close-btn,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-close-btn {\n  color: var(--dash-muted, #b3b8c2);\n}\n\n.quotation-page.dark .quotation-dialog-close-btn:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-close-btn:hover {\n  background: var(--dash-surface-2, #22252a);\n  color: var(--dash-text, #f2f3f5);\n}\n\n.quotation-dialog-close-btn svg {\n  font-size: 18px;\n}\n\n.quotation-dialog-body {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n  max-height: calc(85vh - 140px);\n}\n\n.quotation-dialog-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.quotation-dialog-field label {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-page.dark .quotation-dialog-field label,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-field label {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-dialog-field input {\n  height: 40px;\n  width: 100%;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  line-height: 21.7px;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.quotation-page.dark .quotation-dialog-field input,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-field input {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-dialog-field input:focus {\n  border-color: var(--interactive-default, #43a79c);\n  box-shadow: none;\n}\n\n.quotation-page .quotation-dialog-field input[aria-invalid=\"true\"] {\n  border-color: var(--danger-text, #a3301f);\n}\n.quotation-page .quotation-dialog-field input[aria-invalid=\"true\"]:focus {\n  box-shadow: none;\n}\n.quotation-send-dialog .quotation-field-error {\n  margin: 0;\n  color: var(--danger-text, #a3301f);\n  font: 400 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.quotation-send-dialog .quotation-recipient-box {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-2, 8px);\n  min-height: 44px;\n  padding: var(--space-2, 8px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 14px/20px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.quotation-send-dialog .quotation-recipient-box:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.quotation-send-dialog .quotation-recipient-box.has-error {\n  border-color: var(--danger-text, #a3301f);\n}\n.quotation-recipient-box .quotation-recipient-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1, 4px);\n  max-width: 100%;\n  min-height: 28px;\n  padding: 4px 8px;\n  border-radius: var(--radius-sm, 6px);\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--text-primary, #142624);\n  font: inherit;\n}\n.quotation-recipient-chip > span {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.quotation-recipient-box .quotation-recipient-chip--saved {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n.quotation-send-dialog .quotation-recipient-chip button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n.quotation-send-dialog .quotation-recipient-chip button:hover {\n  background: var(--surface-tertiary, #e8edec);\n}\n.quotation-send-dialog .quotation-recipient-chip button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.quotation-recipient-chip svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n.quotation-send-dialog\n  .quotation-recipient-box\n  input.quotation-recipient-entry {\n  flex: 1 1 160px;\n  width: auto;\n  min-width: 0;\n  height: 32px;\n  padding: 4px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  outline: none;\n  box-shadow: none;\n}\n.quotation-recipient-loading {\n  color: var(--text-secondary, #506360);\n}\n.quotation-page .quotation-notifications {\n  position: fixed;\n  top: 72px;\n  right: 24px;\n  z-index: 1200;\n  width: 360px;\n  max-width: calc(100vw - 32px);\n  max-height: 70vh;\n  overflow-y: auto;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 12px;\n  background: var(--surface-elevated, #fff);\n  color: var(--text-primary, #142624);\n  box-shadow: var(--elevation-md, 0 6px 16px rgba(14, 26, 32, 0.14));\n  font: 400 13px/20px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.quotation-notifications > header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.quotation-notifications > header strong {\n  font-weight: 500;\n}\n.quotation-notifications > header button {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n.quotation-notifications > button {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n  padding: 14px 16px;\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n.quotation-notifications > button:hover,\n.quotation-notifications > button.is-unread {\n  background: var(--interactive-soft, #f0f8f7);\n}\n.quotation-notifications small {\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n}\n.quotation-notifications > p {\n  margin: 0;\n  padding: 20px 16px;\n  color: var(--text-secondary, #506360);\n}\n.quotation-recipient-hint {\n  color: var(--text-secondary, #506360);\n  font: 400 12px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.quotation-send-dialog .quotation-email-preview-cta {\n  cursor: default;\n}\n\n.quotation-dialog-preview-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.quotation-dialog-preview-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-page.dark .quotation-dialog-preview-heading,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-preview-heading {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-dialog-preview-heading svg {\n  font-size: 16px;\n}\n\n.quotation-dialog-email-card {\n  padding: 20px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-subtle, #e8edec);\n  background: var(--surface-secondary, #f4f7f7);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.quotation-page.dark .quotation-dialog-email-card,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-email-card {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-followup-message {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #e8edec);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  line-height: 1.55;\n  resize: vertical;\n}\n\n.quotation-email-greeting {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-page.dark .quotation-email-greeting,\n.quotation-page[data-theme=\"dark\"] .quotation-email-greeting {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-email-text {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-page.dark .quotation-email-text,\n.quotation-page[data-theme=\"dark\"] .quotation-email-text {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-email-validity {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-page.dark .quotation-email-validity,\n.quotation-page[data-theme=\"dark\"] .quotation-email-validity {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-email-preview-cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  width: fit-content;\n  user-select: none;\n}\n\n.quotation-approval-success {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2, 8px);\n  margin-top: var(--space-2, 8px);\n  color: var(--success-text, #115a33);\n  font: 600 14px var(--font-family-primary);\n}\n.quotation-approval-success svg {\n  width: 18px;\n  height: 18px;\n}\n\n.quotation-send-success-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 0 20px;\n  padding: 12px 14px;\n  border: 1px solid\n    color-mix(in srgb, var(--success-text, #15803d) 28%, transparent);\n  border-radius: 10px;\n  background: var(--success-soft, #f0fdf4);\n  color: var(--success-text, #15803d);\n  font: 500 13px/18px var(--font-family-primary);\n}\n\n.quotation-send-success-banner > svg {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n}\n\n.quotation-send-success-banner > span {\n  flex: 1;\n}\n\n.quotation-send-success-banner > button {\n  display: grid;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  place-items: center;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n.quotation-send-success-banner > button:hover {\n  background: color-mix(in srgb, currentColor 10%, transparent);\n}\n.quotation-review-dialog.MuiPaper-root {\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n}\n.quotation-review-body {\n  padding: var(--space-4, 16px);\n  overflow-y: auto;\n}\n.quotation-review-dialog .quotation-modal-header,\n.quotation-review-dialog .quotation-modal-footer {\n  flex-shrink: 0;\n}\n.quotation-review-dialog .quotation-preview-details strong {\n  overflow-wrap: anywhere;\n}\n.quotation-review-dialog .quotation-preview-copy p {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n.quotation-review-dialog .quotation-preview-table {\n  min-width: 720px;\n}\n\n.quotation-page.dark .quotation-email-preview-cta,\n.quotation-page[data-theme=\"dark\"] .quotation-email-preview-cta,\n.quotation-preview-shell.dark .quotation-email-preview-cta {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-email-signoff {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-email-signoff p {\n  margin: 0;\n  line-height: 21.7px;\n}\n\n.quotation-page.dark .quotation-email-signoff,\n.quotation-page[data-theme=\"dark\"] .quotation-email-signoff {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-dialog-delivery-options {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.quotation-dialog-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.quotation-dialog-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--interactive-default, #43a79c);\n  cursor: pointer;\n  margin: 0;\n}\n\n.quotation-dialog-checkbox span {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-page.dark .quotation-dialog-checkbox span,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-checkbox span {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-dialog-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-subtle, #e8edec);\n  background: var(--surface-primary, #ffffff);\n}\n\n.quotation-page.dark .quotation-dialog-footer,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-footer {\n  border-top-color: var(--border-subtle, #2c3036);\n  background: var(--surface-primary, #191b1f);\n}\n\n.quotation-dialog-cancel-btn {\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.quotation-dialog-cancel-btn:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-page.dark .quotation-dialog-cancel-btn,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-cancel-btn,\n.quotation-preview-shell.dark .quotation-dialog-cancel-btn {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-page.dark .quotation-dialog-cancel-btn:hover,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-cancel-btn:hover,\n.quotation-preview-shell.dark .quotation-dialog-cancel-btn:hover {\n  background: var(--surface-tertiary, #2b2f35);\n}\n\n.quotation-dialog-send-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: none;\n  background: var(--interactive-default, #43a79c);\n  color: #ffffff !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.quotation-page.dark .quotation-dialog-send-btn,\n.quotation-page[data-theme=\"dark\"] .quotation-dialog-send-btn {\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.quotation-dialog-send-btn:hover:not(:disabled) {\n  background: var(--interactive-pressed, #36877e);\n}\n\n.quotation-dialog-send-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.quotation-dialog-send-btn svg {\n  font-size: 16px;\n}\n\n@media (max-width: 767px) {\n  .quotation-send-dialog {\n    max-width: 100%;\n    margin: 8px;\n  }\n  .quotation-dialog-header,\n  .quotation-dialog-body,\n  .quotation-dialog-footer {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  .quotation-dialog-delivery-options {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 12px !important;\n  }\n}\n\n/* ==========================================================================\n   DRAFT QUOTE EDITOR (Create & Edit) — Figma Node 582:37868 / 890:53450\n   ========================================================================== */\n.quotation-editor-page {\n  font-family: var(--font-family-primary);\n  display: flex;\n  min-height: calc(100vh - 64px);\n  background: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-shell {\n  min-height: 100vh;\n  background: var(--bg-primary, #f4f7f7);\n}\n\n.quotation-editor-main-area {\n  min-width: 0;\n  background: var(--bg-primary, #f4f7f7);\n}\n\n.quotation-editor-page.dark,\n.quotation-editor-page[data-theme=\"dark\"] {\n  background: var(--bg-primary, #101113);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-content {\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n@media (max-width: 1023px) {\n  .quotation-editor-content {\n    padding: 24px 20px;\n    gap: 20px;\n  }\n}\n\n@media (max-width: 767px) {\n  .quotation-editor-content {\n    padding: 16px;\n    gap: 20px;\n  }\n}\n\n/* Header */\n.quotation-editor-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent !important;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  height: 40px;\n  padding: 0 12px !important;\n  color: var(--text-link, #0f766e);\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  width: fit-content;\n  transition: opacity 0.15s ease;\n}\n\n.quotation-back-link span {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n  white-space: nowrap;\n}\n\n.quotation-back-link svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.quotation-page.dark .quotation-back-link,\n.quotation-editor-page.dark .quotation-back-link,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-back-link {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-back-link:hover {\n  text-decoration: underline;\n}\n\n.quotation-editor-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--space-6, 24px);\n  flex-wrap: wrap;\n}\n\n.quotation-editor-identity {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.quotation-editor-identity h1 {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-h1, 32px);\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: var(--line-height-h1, 1.25);\n  letter-spacing: var(--letter-spacing-h1, -0.48px);\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-editor-identity h1,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-editor-identity h1 {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-meta-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3, 12px);\n}\n\n.quotation-draft-status-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 6px;\n  border: 0;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14.3px;\n  font-style: normal;\n  letter-spacing: 0.11px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.quotation-meta-docno {\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--font-family-mono);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n  color: var(--text-primary, #142624);\n  white-space: nowrap;\n}\n\n.quotation-editor-page.dark .quotation-meta-docno,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-meta-docno {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-meta-notsent {\n  display: inline-flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n  white-space: nowrap;\n}\n\n.quotation-editor-page.dark .quotation-meta-notsent,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-meta-notsent {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-save-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1, 4px);\n  min-height: 21px;\n  padding: 2px 8px;\n  border: 0;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--interactive-selected, #dcefec);\n  color: var(--interactive-default, #0f766e);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 15.4px;\n  letter-spacing: 0.11px;\n  white-space: nowrap;\n}\n\n.quotation-editor-header .quotation-save-indicator svg {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.quotation-editor-page.dark .quotation-save-indicator,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-save-indicator {\n  background: rgba(67, 167, 156, 0.15);\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-editor-header .quotation-save-indicator.unsaved {\n  border: 1px solid var(--warning-border, #f9d98f);\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n\n.quotation-save-indicator.unsaved i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.quotation-history-link-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-md, 10px);\n  color: var(--interactive-default, #0f766e);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n  cursor: pointer;\n}\n\n.quotation-history-link-btn:hover {\n  background: var(--interactive-hover-soft, #edf8f7);\n  text-decoration: none;\n}\n\n.quotation-history-link-btn svg,\n.quotation-history-link-btn img {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n\n.quotation-history-link-btn:focus-visible {\n  border-radius: 4px;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 3px;\n}\n\n.quotation-editor-page.dark .quotation-history-link-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-history-link-btn {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-meta-attribution {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-1, 4px);\n  font-size: 13px;\n  color: var(--text-secondary, #506360);\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  overflow-wrap: anywhere;\n}\n\n.quotation-editor-header-details {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-2, 8px) var(--space-4, 16px);\n  padding-top: var(--space-3, 12px);\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.quotation-editor-header-details strong {\n  color: var(--text-primary, #142624);\n  font-weight: var(--font-weight-medium, 500);\n}\n\n.quotation-editor-page.dark .quotation-meta-attribution,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-meta-attribution {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* Header Action Buttons */\n.quotation-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.quotation-editor-subtitle {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-2, 8px);\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  overflow-wrap: anywhere;\n}\n\n.quotation-editor-page.dark .quotation-draft-status-pill,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-draft-status-pill {\n  background: var(--surface-tertiary, #2b2f35);\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-editor-page.dark .quotation-editor-subtitle,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-editor-subtitle {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n@media (max-width: 1199px) {\n  .quotation-editor-title-row {\n    align-items: flex-start;\n    flex-wrap: wrap;\n    overflow: visible;\n  }\n\n  .quotation-editor-meta-row {\n    flex-wrap: wrap;\n    overflow: visible;\n  }\n}\n\n@media (max-width: 767px) {\n  .quotation-editor-identity h1 {\n    font-size: var(--font-size-h1, 24px);\n    line-height: var(--line-height-h1, 30px);\n    letter-spacing: var(--letter-spacing-h1, -0.36px);\n  }\n\n  .quotation-header-actions {\n    display: none;\n  }\n\n  .quotation-editor-header {\n    gap: 20px;\n  }\n\n  .quotation-back-link {\n    height: 44px;\n  }\n\n  .quotation-editor-identity {\n    gap: 12px;\n  }\n\n  .quotation-editor-meta-row {\n    align-items: center;\n    gap: 12px;\n  }\n\n  .quotation-meta-notsent,\n  .quotation-meta-attribution {\n    flex: 1 0 100%;\n    white-space: normal;\n  }\n\n  .quotation-meta-notsent {\n    order: 4;\n  }\n\n  .quotation-meta-attribution {\n    order: 5;\n  }\n\n  .quotation-history-link-btn {\n    order: 6;\n    height: 44px;\n    margin-left: -12px;\n  }\n\n  .quotation-editor-header-details {\n    display: none;\n  }\n}\n\n.quotation-save-draft-action-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quotation-save-draft-action-btn[aria-busy=\"true\"]\n  > :not(.quotation-save-draft-spinner) {\n  visibility: hidden;\n}\n\n.quotation-save-draft-action-btn .quotation-save-draft-spinner {\n  position: absolute;\n}\n\n.quotation-save-draft-action-btn:hover {\n  background: var(--surface-tertiary, #e8edec);\n}\n\n.quotation-editor-page.dark .quotation-save-draft-action-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-save-draft-action-btn {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-page.dark .quotation-save-draft-action-btn:hover,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-save-draft-action-btn:hover {\n  background: var(--surface-tertiary, #2b2f35);\n}\n\n.quotation-send-quote-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: none;\n  background: var(--interactive-default, #0f766e);\n  color: #ffffff !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quotation-send-quote-action-btn:hover {\n  background: var(--interactive-pressed, #0d5f58);\n}\n\n.quotation-editor-page.dark .quotation-send-quote-action-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-send-quote-action-btn {\n  background: var(--interactive-default, #43a79c);\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n/* Two-column layout */\n.quotation-editor-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 1023px) {\n  .quotation-editor-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .quotation-editor-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .quotation-totals-sidebar {\n    display: contents;\n  }\n\n  .quotation-grand-total-card {\n    order: -1;\n  }\n\n  .quotation-editor-main {\n    order: 0;\n  }\n\n  .quotation-summary-card {\n    order: 1;\n  }\n\n  .quotation-sidebar-doc-actions {\n    order: 2;\n  }\n\n  .quotation-guidance-card {\n    order: 3;\n  }\n}\n\n.quotation-editor-cards-column {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n/* Form Card */\n.quotation-editor-card {\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n}\n\n.quotation-editor-page.dark .quotation-editor-card,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-editor-card {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);\n}\n\n.quotation-editor-card-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.quotation-editor-card-header h3 {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-editor-card-header h3,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-editor-card-header h3 {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-card-header p {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-editor-card-header p,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-editor-card-header p {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* Form Row & Fields */\n.quotation-form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-field-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n  position: relative;\n}\n\n.quotation-field-label-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.quotation-field-wrap > label,\n.quotation-field-label-row label,\n.quotation-field-label {\n  display: block;\n  margin: 0;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n  color: var(--text-primary, #142624);\n  user-select: none;\n}\n\n.quotation-editor-page.dark .quotation-field-wrap > label,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-field-wrap > label,\n.quotation-editor-page.dark .quotation-field-label-row label,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-field-label-row label,\n.quotation-editor-page.dark .quotation-field-label,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-field-label,\n.quotation-editor-shell.dark .quotation-field-wrap > label,\n.quotation-editor-shell.dark .quotation-field-label-row label,\n.quotation-editor-shell.dark .quotation-field-label {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-auto-generated-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 12px;\n  height: 12px;\n  color: var(--text-tertiary, #6b7b78);\n  flex-shrink: 0;\n}\n\n.quotation-auto-generated-icon svg {\n  width: 12px;\n  height: 12px;\n  display: block;\n}\n\n.quotation-editor-page.dark .quotation-auto-generated-icon,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-auto-generated-icon,\n.quotation-editor-shell.dark .quotation-auto-generated-icon {\n  color: var(--text-tertiary, #828b94);\n}\n\n.quotation-field-tag {\n  font-size: 12px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-input-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  width: 100%;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.quotation-editor-page.dark .quotation-input-box,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-input-box {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.quotation-editor-page.dark\n  .quotation-quote-date-field\n  .figma-datepicker__input-container,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-quote-date-field\n  .figma-datepicker__input-container {\n  background-color: var(--surface-primary, #191b1f) !important;\n}\n\n.quotation-input-box:focus-within {\n  border: 2px solid var(--interactive-default, #0f766e);\n  padding-inline: 11px;\n  box-shadow: var(--field-focus-ring, 0 0 0 3px rgba(15, 186, 196, 0.22));\n}\n\n.quotation-editor-page.dark .quotation-input-box:focus-within,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-input-box:focus-within {\n  border-color: var(--interactive-default, #43a79c);\n  box-shadow: none;\n}\n\n.quotation-editor-page\n  .quotation-input-box:has(> #quotation-customer-input):focus-within {\n  box-shadow: none;\n}\n\n.quotation-input-box input,\n.quotation-input-box select {\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-input-box input,\n.quotation-editor-page.dark .quotation-input-box select,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-input-box input,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-input-box select {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-input-box input::placeholder {\n  color: var(--text-tertiary, #6b7b78);\n}\n\n.quotation-input-box svg {\n  color: var(--text-secondary, #506360);\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.quotation-editor-page.dark .quotation-input-box svg,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-input-box svg {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-input-box.quotation-input-readonly,\n.quotation-input-box.disabled {\n  background: var(--surface-secondary, #f4f7f7);\n  border-color: var(--border-subtle, #dce3e2);\n  cursor: default;\n}\n\n.quotation-input-box.quotation-input-readonly input,\n.quotation-input-box.disabled input {\n  color: var(--text-secondary, #506360);\n  cursor: default;\n  font-size: 13px;\n  background: transparent;\n}\n\n.quotation-editor-page.dark .quotation-input-box.quotation-input-readonly,\n.quotation-editor-page.dark .quotation-input-box.disabled,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-input-box.quotation-input-readonly,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-input-box.disabled,\n.quotation-editor-shell.dark .quotation-input-box.quotation-input-readonly,\n.quotation-editor-shell.dark .quotation-input-box.disabled {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-editor-page.dark .quotation-input-box.quotation-input-readonly input,\n.quotation-editor-page.dark .quotation-input-box.disabled input,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-input-box.quotation-input-readonly\n  input,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-input-box.disabled input,\n.quotation-editor-shell.dark\n  .quotation-input-box.quotation-input-readonly\n  input,\n.quotation-editor-shell.dark .quotation-input-box.disabled input {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* Combobox Autocomplete Dropdown */\n.quotation-autocomplete-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 80;\n  background: var(--surface-elevated, #ffffff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  box-shadow: 0 8px 20px rgba(14, 26, 32, 0.12);\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 4px;\n}\n\n.quotation-editor-page.dark .quotation-autocomplete-dropdown,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-autocomplete-dropdown {\n  background: var(--surface-elevated, #25282e);\n  border-color: var(--border-default, #3a3f47);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.quotation-autocomplete-item {\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  transition: background 0.12s ease;\n}\n\n.quotation-autocomplete-item:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-editor-page.dark .quotation-autocomplete-item:hover,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-autocomplete-item:hover {\n  background: var(--surface-secondary, #22252a);\n}\n\n.quotation-autocomplete-item strong {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-autocomplete-item strong,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-autocomplete-item strong {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-autocomplete-item span {\n  font-size: 12px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-autocomplete-item.quotation-catalogue-option {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding-right: 52px;\n  align-items: stretch;\n  border: 0;\n  background: transparent;\n  font-family: var(--font-family-primary);\n  text-align: left;\n  overflow-wrap: anywhere;\n}\n\n.quotation-catalogue-option-row {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n}\n\n.quotation-catalogue-option-edit {\n  position: absolute;\n  top: 50%;\n  right: 4px;\n  z-index: 1;\n  display: grid;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  transform: translateY(-50%);\n  place-items: center;\n  border: 1px solid transparent;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.quotation-catalogue-option-edit svg {\n  width: 16px;\n  height: 16px;\n  stroke-width: 1.8;\n}\n\n.quotation-catalogue-option-edit:hover,\n.quotation-catalogue-option-edit:focus-visible {\n  border-color: var(--border-default, #ccd6d4);\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n  outline: none;\n}\n\n.quotation-editor-page.dark .quotation-catalogue-option-edit,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-catalogue-option-edit,\n.invoice-editor-shell.dark .quotation-catalogue-option-edit {\n  color: var(--text-secondary, #b7c1bf);\n}\n\n.quotation-editor-page.dark .quotation-catalogue-option-edit:hover,\n.quotation-editor-page.dark .quotation-catalogue-option-edit:focus-visible,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-catalogue-option-edit:hover,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-catalogue-option-edit:focus-visible,\n.invoice-editor-shell.dark .quotation-catalogue-option-edit:hover,\n.invoice-editor-shell.dark .quotation-catalogue-option-edit:focus-visible {\n  border-color: var(--border-default, #3a3f47);\n  background: rgba(67, 167, 156, 0.15);\n  color: var(--interactive-default, #43a79c);\n}\n\n@media (min-width: 481px) and (max-width: 900px) {\n  .quotation-autocomplete-item.quotation-catalogue-option {\n    padding-right: 56px;\n  }\n\n  .quotation-catalogue-option-edit {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n.quotation-autocomplete-item.quotation-catalogue-option:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-autocomplete-item.quotation-catalogue-option > strong {\n  align-self: stretch;\n  text-align: left;\n  font: 500 14px/21.7px var(--font-family-primary);\n}\n\n.quotation-catalogue-option:focus-visible {\n  outline: 1px solid var(--interactive-default, #0f766e);\n  outline-offset: -1px;\n}\n\n.quotation-editor-page .quotation-customer-option {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.quotation-customer-option-select {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.quotation-customer-option-select strong,\n.quotation-customer-option-select span {\n  max-width: 100%;\n  overflow-wrap: anywhere;\n}\n\n.quotation-customer-option-actions {\n  display: flex;\n  flex-shrink: 0;\n  margin-left: auto;\n  gap: 4px;\n}\n\n.quotation-customer-option-actions button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n\n.quotation-customer-option-actions button:hover {\n  background: var(--surface-primary, #ffffff);\n}\n\n.quotation-customer-option-actions button:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n\n.quotation-customer-option-actions button:focus-visible,\n.quotation-customer-option-select:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n.quotation-customer-option-actions .quotation-customer-delete-action {\n  color: var(--danger-text, #c23a2b);\n}\n\n.quotation-modal-submit-btn.quotation-customer-delete-confirm {\n  background: var(--danger-text, #c23a2b);\n  color: #ffffff !important;\n}\n\n.quotation-autocomplete-no-match {\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.quotation-autocomplete-no-match strong {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-autocomplete-no-match span {\n  font-size: 12px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-autocomplete-no-match strong,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-autocomplete-no-match\n  strong,\n.quotation-editor-shell.dark .quotation-autocomplete-no-match strong {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-page.dark .quotation-autocomplete-no-match span,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-autocomplete-no-match span,\n.quotation-editor-shell.dark .quotation-autocomplete-no-match span {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-autocomplete-add-action {\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  background: transparent;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n\n.quotation-autocomplete-add-action:hover {\n  background: var(--interactive-soft, #dcefec);\n}\n\n.quotation-editor-page.dark .quotation-autocomplete-add-action,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-autocomplete-add-action {\n  color: var(--text-primary, #f2f3f5);\n  border-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-editor-page.dark .quotation-autocomplete-add-action:hover,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-autocomplete-add-action:hover {\n  background: rgba(67, 167, 156, 0.15);\n}\n\n/* Pricing Basis Row (Figma Node 610:77741 — No background, no border) */\n.quotation-pricing-basis-row,\n.quotation-pricing-basis-bar {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 16px !important;\n  width: 100% !important;\n  background: transparent !important;\n  border: none !important;\n  padding: 0 !important;\n  margin-bottom: 8px !important;\n}\n\n.quotation-pricing-basis-label,\n.quotation-pricing-basis-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-pricing-basis-label,\n.quotation-editor-page.dark .quotation-pricing-basis-left,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-pricing-basis-label,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-pricing-basis-left {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-pricing-basis-select-wrap,\n.quotation-pricing-basis-select-box {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 40px;\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  padding: 0 12px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.quotation-editor-page.dark .quotation-pricing-basis-select-wrap,\n.quotation-editor-page.dark .quotation-pricing-basis-select-box,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-pricing-basis-select-wrap,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-pricing-basis-select-box {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.quotation-pricing-basis-select-wrap:focus-within,\n.quotation-pricing-basis-select-box:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n\n.quotation-editor-page.dark .quotation-pricing-basis-select-wrap:focus-within,\n.quotation-editor-page.dark .quotation-pricing-basis-select-box:focus-within,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-pricing-basis-select-wrap:focus-within,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-pricing-basis-select-box:focus-within {\n  border-color: var(--interactive-default, #43a79c);\n  box-shadow: none;\n}\n\n.quotation-pricing-basis-select-wrap select,\n.quotation-pricing-basis-select-box select,\n.quotation-pricing-basis-select {\n  appearance: none;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-primary, #142624);\n  padding-right: 22px;\n  cursor: pointer;\n}\n\n.quotation-editor-page.dark .quotation-pricing-basis-select-wrap select,\n.quotation-editor-page.dark .quotation-pricing-basis-select-box select,\n.quotation-editor-page.dark .quotation-pricing-basis-select,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-pricing-basis-select-wrap\n  select,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-pricing-basis-select-box\n  select,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-pricing-basis-select {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-pricing-basis-select-wrap svg,\n.quotation-pricing-basis-select-box svg {\n  position: absolute;\n  right: 12px;\n  pointer-events: none;\n  font-size: 16px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-pricing-basis-select-wrap svg,\n.quotation-editor-page.dark .quotation-pricing-basis-select-box svg,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-pricing-basis-select-wrap\n  svg,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-pricing-basis-select-box\n  svg {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* Items Table (Figma Node 610:77737 & 722:28069 — No outer table border) */\n.quotation-items-table-wrapper {\n  overflow: visible !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n\n.quotation-editor-page.dark .quotation-items-table-wrapper,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-items-table-wrapper {\n  background: transparent !important;\n  border: none !important;\n}\n\n.quotation-items-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 720px;\n}\n\n.quotation-items-table th {\n  height: 40px;\n  padding: 0 12px;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.12px;\n  color: var(--text-secondary, #506360);\n  background: var(--surface-secondary, #f4f7f7);\n  text-align: left;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  white-space: nowrap;\n}\n\n.quotation-editor-page.dark .quotation-items-table th,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-items-table th {\n  background: var(--surface-secondary, #22252a);\n  color: var(--text-secondary, #b3b8c2);\n  border-bottom-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-items-table td {\n  padding: 12px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  vertical-align: top;\n}\n\n.quotation-editor-page.dark .quotation-items-table td,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-items-table td {\n  border-bottom-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-col-item {\n  width: 220px;\n}\n.quotation-col-desc {\n  min-width: 180px;\n}\n.quotation-col-qty {\n  width: 80px;\n}\n.quotation-col-price {\n  width: 110px;\n}\n.quotation-col-tax {\n  width: 100px;\n}\n.quotation-col-total {\n  width: 110px;\n  text-align: right;\n}\n.quotation-col-del {\n  width: 44px;\n  text-align: center;\n}\n\n.quotation-cell-input {\n  width: 100%;\n  height: 36px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.15s ease;\n}\n\n.quotation-editor-page.dark .quotation-cell-input,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-cell-input {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-cell-input:focus {\n  border-color: var(--interactive-default, #0f766e);\n}\n\n.quotation-editor-page.dark .quotation-cell-input:focus,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-cell-input:focus {\n  border-color: var(--interactive-default, #43a79c);\n}\n\n.quotation-cell-amount {\n  font-family: var(--font-family-mono);\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n  line-height: 36px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.quotation-editor-page.dark .quotation-cell-amount,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-cell-amount {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-cell-delete-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-top: 2px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.quotation-cell-delete-btn:hover {\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n}\n\n.quotation-editor-page.dark .quotation-cell-delete-btn:hover,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-cell-delete-btn:hover {\n  background: var(--danger-soft, #332022);\n  color: var(--danger-text, #f3aaa4);\n}\n\n.quotation-cell-delete-btn svg {\n  font-size: 16px;\n}\n\n/* Discount row in cell */\n.quotation-line-discount-control {\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.quotation-line-discount-control select {\n  height: 28px;\n  padding: 0 6px;\n  font-size: 12px;\n  border-radius: 6px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  outline: none;\n}\n\n.quotation-line-discount-control input {\n  height: 28px;\n  width: 70px;\n  padding: 0 6px;\n  font-size: 12px;\n  border-radius: 6px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  outline: none;\n}\n\n/* Items Actions Bar (Figma Node 610:77737) */\n.quotation-items-actions-bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.quotation-items-buttons-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.quotation-action-outline-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4) !important;\n  background: var(--surface-primary, #ffffff) !important;\n  color: var(--text-primary, #142624) !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  outline: none;\n  transition: background 0.15s ease;\n}\n\n.quotation-action-outline-btn:hover {\n  background: var(--surface-tertiary, #e8edec) !important;\n}\n\n.quotation-editor-page.dark .quotation-action-outline-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-action-outline-btn {\n  background: var(--surface-primary, #191b1f) !important;\n  border-color: var(--border-default, #3a3f47) !important;\n  color: var(--text-primary, #f2f3f5) !important;\n}\n\n.quotation-editor-page.dark .quotation-action-outline-btn:hover,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-action-outline-btn:hover {\n  background: var(--surface-tertiary, #2b2f35) !important;\n}\n\n.quotation-action-outline-btn svg {\n  font-size: 16px;\n}\n\n.quotation-action-link-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--surface-primary, #ffffff) !important;\n  border: 1px solid var(--border-default, #cdd6d4) !important;\n  border-radius: var(--radius-md, 10px);\n  outline: none !important;\n  box-shadow: none !important;\n  padding: 0 16px !important;\n  color: var(--text-primary, #142624) !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  height: 40px;\n  transition: opacity 0.15s ease;\n}\n\n.quotation-action-link-btn:hover {\n  opacity: 0.85;\n  text-decoration: none;\n}\n\n.quotation-editor-page.dark .quotation-action-link-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-action-link-btn {\n  color: var(--text-primary, #f2f3f5) !important;\n}\n\n.quotation-action-link-btn svg {\n  font-size: 16px;\n}\n\n.quotation-items-spacer {\n  flex: 1;\n}\n\n.quotation-total-item-discounts-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 9999px;\n  background: var(--surface-secondary, #f4f7f7);\n  border: none;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  color: var(--text-secondary, #506360);\n  margin-left: auto;\n}\n\n.quotation-editor-page.dark .quotation-total-item-discounts-badge,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-total-item-discounts-badge {\n  background: var(--surface-secondary, #22252a);\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-total-item-discounts-badge strong {\n  font-family: var(--font-family-mono);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-total-item-discounts-badge strong,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-total-item-discounts-badge\n  strong {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-field-footnote {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-field-footnote,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-field-footnote,\n.quotation-editor-shell.dark .quotation-field-footnote {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* Notes & Attachments */\n.quotation-textarea-box {\n  width: 100%;\n  min-height: 90px;\n  padding: 10px 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  line-height: 20px;\n  outline: none;\n  resize: vertical;\n  transition: border-color 0.15s ease;\n}\n\n.quotation-editor-page.dark .quotation-textarea-box,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-textarea-box {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-textarea-box:focus {\n  border-color: var(--interactive-default, #0f766e);\n}\n\n.quotation-editor-page.dark .quotation-textarea-box:focus,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-textarea-box:focus {\n  border-color: var(--interactive-default, #43a79c);\n}\n\n#quotation-terms[readonly] {\n  border: none;\n  background: transparent;\n  resize: none;\n}\n\n/* Attachments dropzone */\n.quotation-attachments-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.quotation-dropzone {\n  border: 1.5px dashed var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n  padding: 24px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n  text-align: center;\n}\n\n.quotation-editor-page.dark .quotation-dropzone,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-dropzone {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.quotation-dropzone:hover {\n  border-color: var(--interactive-default, #0f766e);\n}\n\n.quotation-editor-page.dark .quotation-dropzone:hover,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-dropzone:hover {\n  border-color: var(--interactive-default, #43a79c);\n}\n\n.quotation-dropzone svg {\n  font-size: 24px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.quotation-editor-page.dark .quotation-dropzone svg,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-dropzone svg {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-dropzone p {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-dropzone p,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-dropzone p {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-dropzone span {\n  font-size: 12px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-dropzone span,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-dropzone span {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-attachments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.quotation-attachment-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  background: var(--surface-primary, #ffffff);\n}\n\n.quotation-editor-page.dark .quotation-attachment-item,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-attachment-item {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-attachment-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-attachment-info,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-attachment-info {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-attachment-remove-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n  padding: 4px;\n}\n\n.quotation-attachment-remove-btn:hover {\n  color: var(--danger-text, #a3301f);\n}\n\n/* Sidebar Totals & Review */\n.quotation-totals-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: sticky;\n  top: 88px;\n  max-height: calc(100vh - 112px);\n  overflow-y: auto;\n  overscroll-behavior: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.quotation-totals-sidebar::-webkit-scrollbar {\n  display: none;\n}\n\n@media (max-width: 1023px) {\n  .quotation-totals-sidebar {\n    position: static;\n    max-height: none;\n    overflow-y: visible;\n  }\n}\n\n.quotation-grand-total-card {\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.quotation-editor-page.dark .quotation-grand-total-card,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-grand-total-card {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-grand-total-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.quotation-grand-total-header span {\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-grand-total-header span,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-grand-total-header span {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-grand-total-header svg {\n  color: var(--interactive-default, #0f766e);\n  font-size: 20px;\n}\n\n.quotation-editor-page.dark .quotation-grand-total-header svg,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-grand-total-header svg {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-grand-total-headline {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.quotation-grand-total-headline strong {\n  font-family: var(--font-family-mono);\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 28px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-grand-total-headline strong,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-grand-total-headline\n  strong {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-grand-total-headline span {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-grand-total-headline span,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-grand-total-headline span {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* Sidebar Document Actions */\n.quotation-sidebar-doc-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  width: 100%;\n}\n\n.quotation-sidebar-download-btn,\n.quotation-sidebar-doc-hint {\n  grid-column: 1 / -1;\n}\n\n.quotation-sidebar-doc-hint {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  line-height: 20px;\n}\n\n.quotation-sidebar-doc-hint > svg {\n  flex: 0 0 16px;\n  margin-top: 2px;\n}\n\n.quotation-sidebar-save-btn,\n.quotation-sidebar-preview-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quotation-sidebar-save-btn:hover:not(:disabled),\n.quotation-sidebar-preview-btn:hover:not(:disabled) {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-sidebar-save-btn:disabled,\n.quotation-sidebar-preview-btn:disabled,\n.quotation-sidebar-download-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.quotation-editor-page.dark .quotation-sidebar-save-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-sidebar-save-btn,\n.quotation-editor-page.dark .quotation-sidebar-preview-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-sidebar-preview-btn {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-page.dark .quotation-sidebar-save-btn:hover:not(:disabled),\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-sidebar-save-btn:hover:not(:disabled),\n.quotation-editor-page.dark .quotation-sidebar-preview-btn:hover:not(:disabled),\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-sidebar-preview-btn:hover:not(:disabled) {\n  background: var(--surface-secondary, #22252a);\n}\n\n.quotation-sidebar-download-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--interactive-default, #0f766e);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quotation-sidebar-download-btn:hover:not(:disabled) {\n  background: var(--interactive-soft, #dcefec);\n}\n\n.quotation-editor-page.dark .quotation-sidebar-download-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-sidebar-download-btn {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-editor-page.dark\n  .quotation-sidebar-download-btn:hover:not(:disabled),\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-sidebar-download-btn:hover:not(:disabled) {\n  background: rgba(67, 167, 156, 0.15);\n}\n\n/* Sidebar Quote Summary Breakdown */\n.quotation-summary-card {\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n}\n\n.quotation-editor-page.dark .quotation-summary-card,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-summary-card {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);\n}\n\n.quotation-summary-card h4 {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-summary-card h4,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-summary-card h4 {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-summary-breakdown-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.quotation-summary-label {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-summary-label,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-summary-label {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-summary-value {\n  font-family: var(--font-family-mono);\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n  white-space: nowrap;\n}\n\n.quotation-editor-page.dark .quotation-summary-value,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-summary-value {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-summary-divider {\n  height: 1px;\n  background: var(--border-subtle, #dce3e2);\n  width: 100%;\n}\n\n.quotation-editor-page.dark .quotation-summary-divider,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-summary-divider {\n  background: var(--border-subtle, #2c3036);\n}\n\n.quotation-summary-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.quotation-summary-total-row .quotation-summary-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark\n  .quotation-summary-total-row\n  .quotation-summary-label,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-summary-total-row\n  .quotation-summary-label {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-summary-total-row .quotation-summary-value {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark\n  .quotation-summary-total-row\n  .quotation-summary-value,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-summary-total-row\n  .quotation-summary-value {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-summary-footnote {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 12px;\n  line-height: 16.8px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-summary-footnote,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-summary-footnote {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* Sidebar Draft Delivery Guidance */\n.quotation-guidance-card {\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.quotation-editor-page.dark .quotation-guidance-card,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-guidance-card {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-guidance-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-guidance-header,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-guidance-header {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-guidance-header svg {\n  color: var(--interactive-default, #0f766e);\n  font-size: 16px;\n}\n\n.quotation-editor-page.dark .quotation-guidance-header svg,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-guidance-header svg {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-guidance-card p {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-guidance-card p,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-guidance-card p {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-panel-send-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: none;\n  background: var(--interactive-default, #0f766e);\n  color: #ffffff !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  width: 100%;\n}\n\n.quotation-panel-send-btn:hover {\n  background: var(--interactive-pressed, #0d5f58);\n}\n\n.quotation-editor-page.dark .quotation-panel-send-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-panel-send-btn {\n  background: var(--interactive-default, #43a79c);\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n/* ==========================================================================\n   QUICK CREATE MODAL DIALOGS (Customer 835:55403 & Item 722:57203)\n   ========================================================================== */\n.quotation-modal-dialog {\n  width: 100%;\n  max-width: 560px;\n  background: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #e8edec);\n  border-radius: var(--radius-lg, 14px);\n  box-shadow: 0px 5px 14px 0px rgba(23, 59, 52, 0.13),\n    0px 1px 2px 0px rgba(14, 26, 32, 0.04);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: quotation-dialog-appear 0.18s ease-out;\n}\n\n/* Catalogue item modal — Figma 722:57203 */\n.quotation-document-preview {\n  position: relative;\n  width: min(100%, 900px);\n  height: 78vh;\n  max-height: min(760px, calc(100dvh - 48px));\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  overflow: hidden;\n  outline: none;\n}\n.quotation-document-preview > img,\n.quotation-document-preview > iframe {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  object-fit: contain;\n}\n.quotation-document-preview > iframe.quotation-document-preview-pdf {\n  /* Crop the native PDF viewer's dark outer gutter. */\n  width: calc(100% + 16px);\n  height: calc(100% + 8px);\n  max-width: none;\n  margin: -8px -8px 0;\n  background: #fff;\n}\n.quotation-document-preview:has(> iframe.quotation-document-preview-pdf)::after {\n  /* Cover the remaining PDF gutter beside the scrollbar. */\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 6px;\n  bottom: 0;\n  width: 10px;\n  background: #fff;\n  pointer-events: none;\n}\n.quotation-document-preview-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  padding: 6px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-sm, 6px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.quotation-document-preview-close:hover {\n  color: var(--text-primary, #142624);\n  background: var(--surface-secondary, #f4f7f7);\n}\n.quotation-document-preview-close:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n.quotation-catalogue-modal {\n  max-width: 640px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.1),\n    0 1px 2px rgba(14, 26, 32, 0.04);\n}\n\n.quotation-catalogue-modal .quotation-modal-header {\n  padding: 20px 20px 20px 24px;\n}\n\n.quotation-catalogue-modal .quotation-modal-body {\n  padding: 20px 24px;\n  gap: 16px;\n}\n\n.quotation-catalogue-modal .quotation-modal-footer {\n  padding: 16px 24px 20px;\n}\n\n.quotation-catalogue-modal .quotation-modal-cancel-btn,\n.quotation-catalogue-modal .quotation-modal-submit-btn {\n  padding-inline: 12px;\n}\n\n.quotation-catalogue-row {\n  display: grid;\n  gap: 16px;\n  width: 100%;\n  align-items: start;\n}\n\n.quotation-catalogue-row-three {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.quotation-catalogue-row-two {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.quotation-catalogue-row-two > .quotation-field-wrap:first-child {\n  grid-column: span 2;\n}\n\n.quotation-catalogue-modal .quotation-field-wrap {\n  gap: 8px;\n  min-width: 0;\n}\n\n.quotation-catalogue-modal .quotation-field-wrap > label {\n  margin: 0;\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n}\n\n.quotation-catalogue-modal\n  .quotation-field-wrap\n  > label.quotation-optional-label {\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-catalogue-modal .quotation-input-box,\n.quotation-catalogue-modal .quotation-select-box {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  height: 40px;\n  min-width: 0;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n}\n\n.quotation-catalogue-modal .quotation-select-box {\n  padding-right: 10px;\n  position: relative;\n}\n\n.quotation-catalogue-modal .quotation-input-box input,\n.quotation-catalogue-modal .quotation-select-box select {\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  appearance: none;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 21.7px;\n}\n\n.quotation-catalogue-modal .quotation-input-box input::placeholder {\n  color: var(--text-tertiary, #6b7b78);\n  opacity: 1;\n}\n\n.quotation-catalogue-modal .quotation-select-box svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  pointer-events: none;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-catalogue-modal .quotation-money-input > span {\n  color: var(--text-tertiary, #6b7b78);\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n}\n\n.quotation-catalogue-modal .quotation-money-input input {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.quotation-catalogue-modal .quotation-field-disabled {\n  opacity: 0.75;\n}\n\n.quotation-catalogue-modal .quotation-field-disabled > label {\n  color: var(--text-disabled, #8a9896);\n}\n\n.quotation-catalogue-modal .quotation-field-disabled .quotation-input-box {\n  border-color: var(--border-subtle, #dce3e2);\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-catalogue-modal .quotation-required-star {\n  color: var(--danger-default, #c23a2b);\n}\n\n.quotation-catalogue-modal .quotation-input-box.quotation-input-error {\n  border-color: var(--danger-default, #c23a2b);\n}\n\n.quotation-catalogue-modal .quotation-field-error {\n  display: block;\n  width: 100%;\n  margin: -2px 0 0;\n  color: var(--danger-default, #c23a2b);\n  font-family: var(--font-family-primary);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n/* Reuse the Figma dropdown in compact quotation-editor fields. */\n.quotation-custom-dropdown-wrap {\n  padding: 0 !important;\n  border: 0 !important;\n  background: transparent !important;\n}\n\n.quotation-custom-dropdown-wrap .quotation-figma-dropdown,\n.quotation-discount-type-wrap .quotation-figma-dropdown {\n  height: 40px;\n}\n\n.quotation-pricing-basis-select-wrap.quotation-custom-dropdown-wrap {\n  width: 164px;\n  height: 40px;\n}\n\n.quotation-item-details-row\n  .quotation-col-gst-select.quotation-custom-dropdown-wrap {\n  display: block;\n  width: 92px;\n  height: 40px;\n}\n\n.quotation-item-details-row\n  .quotation-col-gst-select.quotation-custom-dropdown-wrap\n  .quotation-figma-dropdown-trigger {\n  padding-inline: 12px 10px;\n}\n\n.quotation-item-details-row\n  .quotation-col-gst-select.quotation-custom-dropdown-wrap\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger {\n  padding-inline: 11px 9px;\n}\n\n.quotation-discount-type-wrap .quotation-figma-dropdown-menu {\n  min-width: 148px;\n}\n\n.quotation-item-details-row\n  .quotation-col-gst-select\n  .quotation-figma-dropdown-menu {\n  min-width: 92px;\n}\n\n/* Ensure open dropdowns float above following rows, discount rows, and card borders */\n.quotation-pricing-basis-row:has(.quotation-figma-dropdown.is-open),\n.quotation-item-row-card:has(.quotation-figma-dropdown.is-open),\n.quotation-item-details-row:has(.quotation-figma-dropdown.is-open),\n.quotation-item-discount-row:has(.quotation-figma-dropdown.is-open) {\n  position: relative;\n  z-index: 120;\n}\n\n.quotation-figma-dropdown.is-open {\n  position: relative;\n  z-index: 120;\n}\n\n/* The legacy GST field rule positions every nested SVG absolutely.\n   Reset both trigger chevron and option check so flexbox centers them naturally. */\n.quotation-item-details-row\n  .quotation-col-gst-select\n  .quotation-figma-dropdown-trigger\n  svg,\n.quotation-item-details-row\n  .quotation-col-gst-select\n  .quotation-figma-dropdown-option\n  svg {\n  position: static !important;\n  right: auto !important;\n  top: auto !important;\n  transform: none;\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  pointer-events: none;\n  transition: transform 0.15s ease;\n}\n\n.quotation-item-details-row\n  .quotation-col-gst-select\n  .quotation-figma-dropdown-option\n  svg {\n  color: currentColor;\n}\n\n.quotation-item-details-row\n  .quotation-col-gst-select\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger\n  svg {\n  transform: rotate(180deg) !important;\n}\n\n@media (max-width: 600px) {\n  .quotation-catalogue-row-three,\n  .quotation-catalogue-row-two {\n    grid-template-columns: 1fr;\n  }\n\n  .quotation-catalogue-row-two > .quotation-field-wrap:first-child {\n    grid-column: auto;\n  }\n\n  .quotation-catalogue-modal .quotation-modal-body {\n    max-height: calc(100vh - 180px);\n  }\n}\n\n.quotation-editor-shell.dark .quotation-modal-dialog,\n.quotation-editor-shell[data-theme=\"dark\"] .quotation-modal-dialog {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n  box-shadow: 0px 10px 25px -4px rgba(0, 0, 0, 0.5);\n}\n\n.quotation-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px;\n  border-bottom: 1px solid var(--border-subtle, #e8edec);\n}\n\n.quotation-editor-shell.dark .quotation-modal-header,\n.quotation-editor-shell[data-theme=\"dark\"] .quotation-modal-header {\n  border-bottom-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-modal-header h3 {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-shell.dark .quotation-modal-header h3,\n.quotation-editor-shell[data-theme=\"dark\"] .quotation-modal-header h3 {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-modal-body {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  max-height: calc(85vh - 140px);\n}\n\n.quotation-modal-caption {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-shell.dark .quotation-modal-caption,\n.quotation-editor-shell[data-theme=\"dark\"] .quotation-modal-caption {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-modal-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  width: 100%;\n}\n\n@media (max-width: 600px) {\n  .quotation-modal-form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.quotation-modal-switch-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n  cursor: pointer;\n}\n\n.quotation-modal-switch-track {\n  width: 38px;\n  height: 22px;\n  border-radius: 999px;\n  background: var(--surface-tertiary, #e8edec);\n  position: relative;\n  transition: background 0.2s ease;\n  flex-shrink: 0;\n}\n\n.quotation-modal-switch-track.active {\n  background: var(--interactive-default, #0f766e);\n}\n\n.quotation-editor-shell.dark .quotation-modal-switch-track {\n  background: var(--surface-tertiary, #2c3036);\n}\n\n.quotation-editor-shell.dark .quotation-modal-switch-track.active {\n  background: var(--interactive-default, #43a79c);\n}\n\n.quotation-modal-switch-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #ffffff;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  transition: transform 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.quotation-modal-switch-track.active .quotation-modal-switch-thumb {\n  transform: translateX(16px);\n}\n\n.quotation-modal-switch-label {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n  user-select: none;\n}\n\n.quotation-editor-shell.dark .quotation-modal-switch-label,\n.quotation-editor-shell[data-theme=\"dark\"] .quotation-modal-switch-label {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid var(--border-subtle, #e8edec);\n}\n\n.quotation-editor-shell.dark .quotation-modal-footer,\n.quotation-editor-shell[data-theme=\"dark\"] .quotation-modal-footer {\n  border-top-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-modal-cancel-btn {\n  height: 40px;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quotation-modal-cancel-btn:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-editor-shell.dark .quotation-modal-cancel-btn,\n.quotation-editor-shell[data-theme=\"dark\"] .quotation-modal-cancel-btn {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-modal-submit-btn {\n  height: 40px;\n  padding: 0 18px;\n  border-radius: var(--radius-md, 10px);\n  border: none;\n  background: var(--interactive-default, #0f766e);\n  color: #ffffff !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quotation-modal-submit-btn:hover {\n  background: var(--interactive-pressed, #0d5f58);\n}\n\n.quotation-modal-submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.quotation-editor-shell.dark .quotation-modal-submit-btn,\n.quotation-editor-shell[data-theme=\"dark\"] .quotation-modal-submit-btn {\n  background: var(--interactive-default, #43a79c);\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n/* ==========================================================================\n   FIGMA DRAFT EDITOR LIGHT/DARK & ITEM SEARCH FILTERED RESULTS (Nodes 582:37868 & 722:28011)\n   ========================================================================== */\n\n/* Aliases for Editor Header & Column Layout */\n.quotation-editor-main {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n  flex: 1;\n}\n\n.quotation-card-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 0;\n}\n\n.quotation-card-header h3 {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-card-header h3,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-card-header h3,\n.quotation-editor-shell.dark .quotation-card-header h3 {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-card-header p {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-card-header p,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-card-header p,\n.quotation-editor-shell.dark .quotation-card-header p {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n}\n\n.quotation-customer-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-quote-settings-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n  width: 100%;\n}\n\n/* Two-column and three-column row layouts in cards */\n.quotation-form-row.two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-form-row.three-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-form-row.full {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  width: 100%;\n}\n\n.quotation-combobox-wrap .quotation-input-box svg,\n.quotation-quote-settings-row .quotation-figma-dropdown-trigger svg {\n  width: 20px;\n  height: 20px;\n  font-size: 20px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-combobox-wrap .quotation-input-box svg,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-combobox-wrap\n  .quotation-input-box\n  svg,\n.quotation-editor-shell.dark .quotation-combobox-wrap .quotation-input-box svg,\n.quotation-editor-page.dark\n  .quotation-quote-settings-row\n  .quotation-figma-dropdown-trigger\n  svg,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-quote-settings-row\n  .quotation-figma-dropdown-trigger\n  svg,\n.quotation-editor-shell.dark\n  .quotation-quote-settings-row\n  .quotation-figma-dropdown-trigger\n  svg {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n@media (max-width: 768px) {\n  .quotation-form-row.two-col,\n  .quotation-form-row.three-col,\n  .quotation-quote-settings-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Items Table Header & Column Titles (Figma Node 610:77747) */\n.quotation-items-col-headings,\n.quotation-items-table-header {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  height: 40px !important;\n  padding: 0 12px !important;\n  background: var(--surface-secondary, #f4f7f7) !important;\n  border-radius: 6px !important;\n  border: none !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: var(--text-secondary, #506360) !important;\n  letter-spacing: 0.06px;\n  margin-bottom: 4px;\n}\n\n.quotation-editor-page.dark .quotation-items-col-headings,\n.quotation-editor-page.dark .quotation-items-table-header,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-items-col-headings,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-items-table-header {\n  background: var(--surface-secondary, #22252a) !important;\n  border: none !important;\n  color: var(--text-secondary, #b3b8c2) !important;\n}\n\n.quotation-items-col-headings .quotation-col-item,\n.quotation-items-table-header .quotation-col-item {\n  flex: 1 0 0;\n  min-width: 0;\n}\n\n.quotation-items-col-headings .quotation-col-qty,\n.quotation-items-table-header .quotation-col-qty {\n  width: 48px;\n  text-align: center;\n}\n\n.quotation-items-col-headings .quotation-col-price,\n.quotation-items-table-header .quotation-col-price {\n  width: 104px;\n}\n\n.quotation-items-col-headings .quotation-col-gst,\n.quotation-items-table-header .quotation-col-gst {\n  width: 92px;\n}\n\n.quotation-items-col-headings .quotation-col-total,\n.quotation-items-table-header .quotation-col-total {\n  width: 108px;\n  text-align: right;\n}\n\n.quotation-items-col-headings .quotation-col-action,\n.quotation-items-table-header .quotation-col-action {\n  width: 32px;\n}\n\n.quotation-items-table-body.is-scrollable {\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-strong, #aebab8) transparent;\n}\n\n.quotation-items-table-body.is-scrollable::-webkit-scrollbar {\n  width: 6px;\n}\n\n.quotation-items-table-body.is-scrollable::-webkit-scrollbar-thumb {\n  border-radius: var(--radius-pill, 999px);\n  background: var(--border-strong, #aebab8);\n}\n\n.quotation-items-table-body.is-scrollable:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n/* Individual Item Row Card (Node 582 & 722) */\n.quotation-item-row-card,\n.quotation-editable-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  width: 100%;\n  position: relative;\n}\n\n.quotation-editor-page .quotation-items-table-body.is-reordering {\n  cursor: grabbing;\n  user-select: none;\n}\n\n.quotation-editor-page\n  .quotation-items-table-body.is-reordering\n  .quotation-item-row-card:not(.is-dragging) {\n  transform: translate3d(0, var(--quotation-row-shift-y, 0px), 0);\n  transition: transform 180ms cubic-bezier(0.2, 0, 0, 1), box-shadow 180ms ease,\n    background-color 180ms ease;\n}\n\n.quotation-editor-page.quotation-item-drag-layer {\n  position: fixed;\n  z-index: 10000;\n  inset: 0;\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  min-height: 0;\n  overflow: visible !important;\n  background: transparent !important;\n  pointer-events: none;\n}\n\n.quotation-editor-page.dark .quotation-item-row-card,\n.quotation-editor-page.dark .quotation-editable-item,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-row-card,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-editable-item {\n  border-bottom-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-item-row-card:last-child,\n.quotation-editable-item:last-child {\n  border-bottom: none;\n}\n\n/* Row 1: Item Name Combobox */\n.quotation-editor-page .quotation-item-drag-handle {\n  display: inline-grid;\n  flex: 0 0 24px;\n  width: 24px;\n  height: 32px;\n  padding: 0;\n  place-items: center;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n.quotation-editor-page .quotation-item-drag-handle:active {\n  cursor: grabbing;\n}\n.quotation-editor-page\n  .quotation-item-row-card.is-dragging\n  .quotation-item-drag-handle {\n  background: var(--interactive-soft, #e6f4f2);\n  color: var(--interactive-default, #0f766e);\n  cursor: grabbing;\n}\n.quotation-editor-page\n  .quotation-item-row-card.is-dragging\n  .quotation-item-drag-handle\n  svg {\n  animation: quotation-drag-handle-pulse 700ms ease-in-out infinite alternate;\n}\n.quotation-editor-page .quotation-item-drag-handle:focus-visible {\n  outline: 2px solid var(--interactive-default);\n  outline-offset: 2px;\n}\n.quotation-editor-page .quotation-item-drag-handle:disabled {\n  cursor: default;\n  opacity: 0.4;\n}\n.quotation-editor-page\n  .quotation-item-row-card.is-dragging:not(.quotation-item-drag-preview) {\n  background: var(--interactive-soft, #e6f4f2);\n  box-shadow: none;\n  opacity: 0.2;\n  outline: 2px dashed var(--interactive-default, #0f766e);\n  outline-offset: -2px;\n}\n.quotation-editor-page .quotation-item-row-card.quotation-item-drag-preview {\n  position: fixed !important;\n  z-index: 1;\n  box-sizing: border-box;\n  margin: 0;\n  padding-inline: var(--space-3, 12px);\n  overflow: visible !important;\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #ffffff);\n  box-shadow: 0 18px 36px rgba(14, 38, 36, 0.18),\n    0 4px 10px rgba(14, 38, 36, 0.12);\n  opacity: 0.98;\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: -2px;\n  transform: translate3d(\n      var(--quotation-drag-offset-x, 0px),\n      var(--quotation-drag-offset-y, 0px),\n      0\n    )\n    scale(1.012);\n  transition: background-color 140ms ease, box-shadow 140ms ease,\n    opacity 140ms ease, outline-color 140ms ease;\n  will-change: transform;\n  animation: quotation-item-drag-lift 160ms ease-out;\n  pointer-events: none;\n}\n.quotation-editor-page .quotation-item-row-card.quotation-item-drag-preview * {\n  pointer-events: none !important;\n}\n.quotation-editor-page .quotation-item-row-card.drop-before {\n  background: var(--interactive-soft, #e6f4f2);\n  box-shadow: inset 0 3px 0 var(--interactive-default);\n}\n.quotation-editor-page .quotation-item-row-card.drop-after {\n  background: var(--interactive-soft, #e6f4f2);\n  box-shadow: inset 0 -3px 0 var(--interactive-default);\n}\n\n.quotation-editor-page.dark\n  .quotation-item-row-card.quotation-item-drag-preview,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-row-card.quotation-item-drag-preview {\n  background: var(--surface-elevated, #25282e);\n  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.48), 0 4px 12px rgba(0, 0, 0, 0.34);\n}\n\n@keyframes quotation-item-drag-lift {\n  from {\n    opacity: 0.72;\n    filter: saturate(0.8);\n  }\n  to {\n    opacity: 0.98;\n    filter: saturate(1);\n  }\n}\n\n@keyframes quotation-drag-handle-pulse {\n  from {\n    transform: scale(0.92);\n  }\n  to {\n    transform: scale(1.08);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .quotation-editor-page .quotation-item-row-card,\n  .quotation-editor-page .quotation-item-drag-handle svg {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n.quotation-item-search-row {\n  width: 100%;\n  position: relative;\n}\n\n.quotation-item-search-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  width: 100%;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.quotation-editor-page.dark .quotation-item-search-box,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-search-box {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.quotation-item-search-box:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n\n.quotation-editor-page.dark .quotation-item-search-box:focus-within,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-search-box:focus-within {\n  border-color: var(--interactive-default, #43a79c);\n  box-shadow: none;\n}\n\n.quotation-item-search-box svg {\n  color: var(--text-secondary, #506360);\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.quotation-item-search-toggle {\n  display: inline-grid;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  padding: 0;\n  place-items: center;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n\n.quotation-item-search-toggle:hover {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n\n.quotation-item-search-toggle:hover svg {\n  color: currentColor;\n}\n\n.quotation-item-search-toggle:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 1px;\n}\n\n.quotation-item-search-toggle svg {\n  transition: transform 0.15s ease;\n}\n\n.quotation-item-search-toggle[aria-expanded=\"true\"] svg {\n  transform: rotate(180deg);\n}\n\n.quotation-item-search-row:has(.quotation-item-search-dropdown)\n  .quotation-item-search-toggle\n  svg {\n  transform: rotate(180deg);\n}\n\n.quotation-editor-page.dark .quotation-item-search-toggle:hover,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-search-toggle:hover {\n  background: var(--surface-secondary, #22252a);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-page.dark .quotation-item-search-box svg,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-search-box svg {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-item-search-box input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-item-search-box input,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-search-box input {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-item-search-box input::placeholder {\n  color: var(--text-secondary, #6b7b78);\n}\n\n/* Row 2: Details Row (Description, Qty, Unit Price, GST, Line Total, Trash) */\n.quotation-item-details-row,\n.quotation-item-main-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.quotation-item-details-row .quotation-col-desc,\n.quotation-item-main-row .quotation-item-field-desc {\n  flex: 1 0 0;\n  min-width: 0;\n}\n\n.quotation-item-details-row .quotation-col-desc input,\n.quotation-item-main-row .quotation-item-field-desc input {\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  background: var(--surface-primary, #ffffff);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-primary, #142624);\n  outline: none;\n  transition: border-color 0.15s ease;\n}\n\n.quotation-editor-page.dark\n  .quotation-item-details-row\n  .quotation-col-desc\n  input,\n.quotation-editor-page.dark\n  .quotation-item-main-row\n  .quotation-item-field-desc\n  input,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-details-row\n  .quotation-col-desc\n  input,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-main-row\n  .quotation-item-field-desc\n  input {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-item-details-row .quotation-col-desc input::placeholder,\n.quotation-item-main-row .quotation-item-field-desc input::placeholder {\n  color: var(--text-disabled, #8a9896);\n}\n\n.quotation-item-details-row .quotation-col-desc input:focus,\n.quotation-item-main-row .quotation-item-field-desc input:focus {\n  border-color: var(--interactive-default, #0f766e);\n}\n\n.quotation-item-details-row .quotation-col-qty-input,\n.quotation-item-main-row .quotation-item-field-qty {\n  width: 48px;\n  flex-shrink: 0;\n}\n\n.quotation-item-details-row .quotation-col-qty-input input,\n.quotation-item-main-row .quotation-item-field-qty input {\n  width: 100%;\n  height: 40px;\n  padding: 0 8px;\n  text-align: center;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  color: var(--text-primary, #142624);\n  outline: none;\n}\n\n.quotation-editor-page.dark\n  .quotation-item-details-row\n  .quotation-col-qty-input\n  input,\n.quotation-editor-page.dark\n  .quotation-item-main-row\n  .quotation-item-field-qty\n  input,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-details-row\n  .quotation-col-qty-input\n  input,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-main-row\n  .quotation-item-field-qty\n  input {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-item-details-row .quotation-col-price-input,\n.quotation-item-main-row .quotation-item-field-price {\n  width: 104px;\n  flex-shrink: 0;\n}\n\n.quotation-item-details-row .quotation-col-price-input input,\n.quotation-item-main-row .quotation-item-field-price input {\n  width: 100%;\n  height: 40px;\n  padding: 0 10px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  font-family: var(--font-family-mono);\n  font-size: 14px;\n  color: var(--text-primary, #142624);\n  outline: none;\n}\n\n.quotation-editor-page.dark\n  .quotation-item-details-row\n  .quotation-col-price-input\n  input,\n.quotation-editor-page.dark\n  .quotation-item-main-row\n  .quotation-item-field-price\n  input,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-details-row\n  .quotation-col-price-input\n  input,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-main-row\n  .quotation-item-field-price\n  input {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-item-details-row .quotation-col-gst-select,\n.quotation-item-main-row .quotation-item-field-gst {\n  width: 92px;\n  height: 40px;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  padding: 0 8px;\n}\n\n.quotation-editor-page.dark\n  .quotation-item-details-row\n  .quotation-col-gst-select,\n.quotation-editor-page.dark .quotation-item-main-row .quotation-item-field-gst,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-details-row\n  .quotation-col-gst-select,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-main-row\n  .quotation-item-field-gst {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.quotation-item-details-row .quotation-col-gst-select select,\n.quotation-item-main-row .quotation-item-field-gst select {\n  width: 100%;\n  height: 100%;\n  padding-right: 20px;\n  border: none !important;\n  background: transparent !important;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  color: var(--text-primary, #142624);\n  outline: none;\n  cursor: pointer;\n  appearance: none;\n}\n\n.quotation-editor-page.dark\n  .quotation-item-details-row\n  .quotation-col-gst-select\n  select,\n.quotation-editor-page.dark\n  .quotation-item-main-row\n  .quotation-item-field-gst\n  select,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-details-row\n  .quotation-col-gst-select\n  select,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-main-row\n  .quotation-item-field-gst\n  select {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-item-details-row\n  .quotation-col-gst-select:not(.quotation-custom-dropdown-wrap)\n  svg,\n.quotation-item-main-row .quotation-item-field-gst svg {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--text-secondary, #506360);\n  font-size: 16px;\n}\n\n.quotation-editor-page.dark\n  .quotation-item-details-row\n  .quotation-col-gst-select\n  svg,\n.quotation-editor-page.dark\n  .quotation-item-main-row\n  .quotation-item-field-gst\n  svg,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-details-row\n  .quotation-col-gst-select\n  svg,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-details-row\n  .quotation-col-gst-select\n  svg {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-item-details-row .quotation-col-line-total,\n.quotation-item-main-row .quotation-item-cell-line-total {\n  width: 108px;\n  min-width: 0;\n  min-height: 40px;\n  height: auto;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: var(--space-2, 8px) 10px;\n  background: var(--surface-secondary, #f4f7f7);\n  border-radius: var(--radius-md, 10px);\n  font-family: var(--font-family-mono);\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n  white-space: normal;\n  overflow-wrap: anywhere;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.quotation-item-details-row .quotation-col-line-total > span,\n.quotation-item-main-row .quotation-item-cell-line-total > span {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.quotation-editor-page.dark\n  .quotation-item-details-row\n  .quotation-col-line-total,\n.quotation-editor-page.dark\n  .quotation-item-main-row\n  .quotation-item-cell-line-total,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-details-row\n  .quotation-col-line-total,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-main-row\n  .quotation-item-cell-line-total {\n  background: var(--surface-secondary, #22252a);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-item-details-row .quotation-col-row-action,\n.quotation-item-main-row .quotation-item-cell-remove {\n  width: 32px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.quotation-item-remove-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md, 10px);\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.15s ease;\n  padding: 0 !important;\n}\n\n.quotation-item-remove-btn:hover {\n  color: var(--text-primary, #142624);\n  background: transparent !important;\n}\n\n.quotation-editor-page.dark .quotation-item-remove-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-remove-btn {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-editor-page.dark .quotation-item-remove-btn:hover,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-remove-btn:hover {\n  color: #f2f3f5;\n  background: transparent !important;\n}\n\n.quotation-item-remove-btn svg {\n  font-size: inherit;\n}\n\n.quotation-item-remove-btn span {\n  display: none;\n}\n\n/* Row 3: Discount Row */\n.quotation-item-discount-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.quotation-total-discounts {\n  display: flex;\n  align-items: center;\n  gap: var(--space-5, 20px);\n  padding: var(--space-1, 4px) var(--space-3, 12px);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-xl, 20px);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  white-space: nowrap;\n}\n\n.quotation-total-discounts span {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14.3px;\n  letter-spacing: 0.11px;\n}\n\n.quotation-total-discounts strong {\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-mono);\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 19.5px;\n}\n\n.quotation-discount-type-wrap,\n.quotation-account-wrap,\n.quotation-item-field-disc-type {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 148px;\n}\n\n.quotation-discount-type-wrap label,\n.quotation-account-wrap label,\n.quotation-item-field-disc-type label {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-discount-type-wrap label,\n.quotation-editor-page.dark .quotation-account-wrap label,\n.quotation-editor-page.dark .quotation-item-field-disc-type label,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-discount-type-wrap label,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-account-wrap label,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-field-disc-type\n  label {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-discount-type-wrap .quotation-select-box,\n.quotation-account-wrap .quotation-select-box,\n.quotation-item-field-disc-type .quotation-select-input-container {\n  display: flex;\n  align-items: center;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  position: relative;\n}\n\n.quotation-editor-page.dark .quotation-discount-type-wrap .quotation-select-box,\n.quotation-editor-page.dark .quotation-account-wrap .quotation-select-box,\n.quotation-editor-page.dark\n  .quotation-item-field-disc-type\n  .quotation-select-input-container,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-discount-type-wrap\n  .quotation-select-box,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-account-wrap\n  .quotation-select-box,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-field-disc-type\n  .quotation-select-input-container {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.quotation-discount-type-wrap select,\n.quotation-account-wrap select,\n.quotation-item-field-disc-type select {\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  color: var(--text-primary, #142624);\n  appearance: none;\n  cursor: pointer;\n}\n\n.quotation-editor-page.dark .quotation-discount-type-wrap select,\n.quotation-editor-page.dark .quotation-item-field-disc-type select,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-discount-type-wrap select,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-field-disc-type\n  select {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-discount-type-wrap .quotation-select-box svg,\n.quotation-item-field-disc-type .quotation-select-input-container svg {\n  color: var(--text-secondary, #506360);\n  font-size: 16px;\n  pointer-events: none;\n}\n\n.quotation-discount-val-wrap,\n.quotation-item-field-disc-val {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 148px;\n}\n\n.quotation-discount-val-wrap label,\n.quotation-item-field-disc-val label {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-discount-val-wrap.disabled,\n.quotation-item-field-disc-val.disabled {\n  opacity: 0.65;\n}\n\n.quotation-discount-val-wrap.disabled label,\n.quotation-item-field-disc-val.disabled label {\n  color: var(--text-disabled, #8a9896);\n}\n\n.quotation-discount-val-wrap .quotation-input-box,\n.quotation-item-field-disc-val .quotation-input-container {\n  display: flex;\n  align-items: center;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n}\n\n.quotation-discount-val-wrap.disabled .quotation-input-box,\n.quotation-item-field-disc-val.disabled .quotation-input-container {\n  background: var(--surface-secondary, #f4f7f7);\n  border-color: var(--border-subtle, #dce3e2);\n}\n\n.quotation-editor-page.dark .quotation-discount-val-wrap .quotation-input-box,\n.quotation-editor-page.dark\n  .quotation-item-field-disc-val\n  .quotation-input-container,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-discount-val-wrap\n  .quotation-input-box,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-field-disc-val\n  .quotation-input-container {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.quotation-editor-page.dark\n  .quotation-discount-val-wrap.disabled\n  .quotation-input-box,\n.quotation-editor-page.dark\n  .quotation-item-field-disc-val.disabled\n  .quotation-input-container,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-discount-val-wrap.disabled\n  .quotation-input-box,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-field-disc-val.disabled\n  .quotation-input-container {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-discount-val-wrap input,\n.quotation-item-field-disc-val input {\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-mono);\n  font-size: 14px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-discount-val-wrap input,\n.quotation-editor-page.dark .quotation-item-field-disc-val input,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-discount-val-wrap input,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-field-disc-val input {\n  color: var(--text-primary, #f2f3f5);\n}\n\n/* ==========================================================================\n   ITEM SEARCH DROPDOWN (FIGMA NODE 722:28011)\n   ========================================================================== */\n.quotation-item-search-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 95;\n  background: var(--surface-elevated, #ffffff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  box-shadow: 0px 6px 16px -4px rgba(14, 26, 32, 0.1),\n    0px 1px 2px 0px rgba(14, 26, 32, 0.04);\n  overflow: hidden;\n}\n\n.quotation-editor-page.dark .quotation-item-search-dropdown,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-search-dropdown {\n  background: var(--surface-elevated, #25282e);\n  border-color: var(--border-default, #3a3f47);\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.quotation-item-search-results-list {\n  padding: 4px;\n  max-height: 250px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-strong, #aebab8) transparent;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.quotation-item-search-results-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.quotation-item-search-results-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.quotation-item-search-results-list::-webkit-scrollbar-thumb {\n  border-radius: var(--radius-pill, 999px);\n  background: var(--border-strong, #aebab8);\n}\n\n.quotation-item-result-card {\n  width: 100%;\n  padding: 8px;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  transition: background 0.12s ease;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n}\n\n.quotation-new-item-option {\n  margin: 4px;\n  width: calc(100% - 8px);\n  padding: 10px 12px;\n  gap: 3px;\n  border: 0;\n  background: transparent;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-new-item-option .quotation-item-result-name {\n  font-weight: 600;\n}\n\n.quotation-new-item-option .quotation-match-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.quotation-editor-page.dark .quotation-new-item-option,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-new-item-option {\n  border: 0;\n  background: transparent;\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-page\n  .quotation-item-search-results-list\n  .quotation-new-item-option\n  .quotation-item-result-name,\n.quotation-editor-page\n  .quotation-item-search-results-list\n  .quotation-new-item-option\n  .quotation-item-result-name-group\n  .quotation-match-icon {\n  color: inherit;\n}\n\n.quotation-item-result-card:hover,\n.quotation-item-result-card.selected {\n  background: var(--interactive-soft, #f0f8f7);\n}\n\n.quotation-editor-page.dark .quotation-item-result-card:hover,\n.quotation-editor-page.dark .quotation-item-result-card.selected,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-result-card:hover,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-result-card.selected {\n  background: rgba(67, 167, 156, 0.15);\n}\n\n.quotation-item-result-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.quotation-item-result-name-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.quotation-item-result-name-group .quotation-match-icon {\n  width: 14px;\n  height: 14px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.quotation-editor-page.dark\n  .quotation-item-result-name-group\n  .quotation-match-icon,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-result-name-group\n  .quotation-match-icon {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-item-result-name {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--interactive-default, #0f766e);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.quotation-editor-page.dark .quotation-item-result-name,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-result-name {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-item-result-price-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.quotation-item-result-gst-label {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-tertiary, #6b7b78);\n}\n\n.quotation-editor-page.dark .quotation-item-result-gst-label,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-result-gst-label {\n  color: var(--text-tertiary, #959fa8);\n}\n\n.quotation-item-result-price {\n  font-family: var(--font-family-mono);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20.8px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.quotation-editor-page.dark .quotation-item-result-price,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-result-price {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-item-result-sub {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--interactive-default, #0f766e);\n  opacity: 0.75;\n}\n\n.quotation-editor-page.dark .quotation-item-result-sub,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-result-sub {\n  color: var(--interactive-default, #43a79c);\n  opacity: 0.85;\n}\n\n:is(.quotation-editor-page, .invoice-editor-shell)\n  .quotation-item-search-results-list\n  .quotation-new-item-option:hover {\n  background: var(--surface-secondary);\n}\n\n:is(.quotation-editor-page, .invoice-editor-shell)\n  .quotation-item-search-results-list\n  .quotation-new-item-option\n  .quotation-item-result-sub {\n  color: var(--text-secondary);\n  opacity: 1;\n}\n\n.quotation-item-search-divider {\n  height: 1px;\n  background: var(--border-subtle, #dce3e2);\n  width: 100%;\n}\n\n.quotation-editor-page.dark .quotation-item-search-divider,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-search-divider {\n  background: var(--border-subtle, #2c3036);\n}\n\n.quotation-item-search-footer-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  width: 100%;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--interactive-default, #0f766e);\n  transition: background 0.12s ease;\n}\n\n.quotation-item-search-footer-btn:hover {\n  background: var(--interactive-soft, #f0f8f7);\n}\n\n.quotation-editor-page.dark .quotation-item-search-footer-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-search-footer-btn {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-editor-page.dark .quotation-item-search-footer-btn:hover,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-search-footer-btn:hover {\n  background: rgba(67, 167, 156, 0.15);\n}\n\n.quotation-item-search-footer-btn svg {\n  width: 16px;\n  height: 16px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.quotation-editor-page.dark .quotation-item-search-footer-btn svg,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-item-search-footer-btn\n  svg {\n  color: var(--interactive-default, #43a79c);\n}\n\n/* Editors share column tracks so headings and fields keep the same bounds. */\n@media (min-width: 768px) {\n  .document-items-aligned {\n    --document-item-columns: minmax(0, 4fr) minmax(40px, 0.5fr) minmax(72px, 1fr)\n      minmax(76px, 0.8fr) 96px 32px;\n  }\n\n  .document-items-aligned .quotation-items-table-header,\n  .document-items-aligned .quotation-item-details-row {\n    display: grid !important;\n    grid-template-columns: var(--document-item-columns);\n    column-gap: 8px;\n    align-items: start;\n  }\n\n  .document-items-aligned .quotation-items-table-header {\n    align-items: center !important;\n    padding-inline: 0 !important;\n  }\n\n  .document-items-aligned:has(> .quotation-items-table-body.is-scrollable)\n    .quotation-items-table-header {\n    overflow-y: hidden;\n    scrollbar-gutter: stable;\n    scrollbar-width: thin;\n  }\n\n  .document-items-aligned .quotation-items-table-body.is-scrollable {\n    scrollbar-gutter: stable;\n  }\n\n  .document-items-aligned .quotation-items-table-header::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  .document-items-aligned .quotation-items-table-header > div,\n  .document-items-aligned .quotation-item-details-row > div {\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n  }\n\n  .document-items-aligned .quotation-items-table-header\n    :is(.quotation-col-item, .quotation-col-price, .quotation-col-gst) {\n    padding-left: 12px;\n  }\n\n  .document-items-aligned .quotation-items-table-header .quotation-col-total {\n    padding-right: 10px;\n  }\n\n  .quotation-item-row-card.document-items-aligned {\n    display: grid;\n    grid-template-columns: var(--document-item-columns);\n    align-items: start;\n  }\n\n  .quotation-item-row-card.document-items-aligned > .quotation-item-search-row {\n    grid-column: 1;\n    grid-row: 1;\n    min-width: 0;\n  }\n\n  .quotation-item-row-card.document-items-aligned .quotation-item-search-box {\n    gap: var(--space-1, 4px);\n    padding-inline: var(--space-2, 8px);\n  }\n\n  .quotation-item-row-card.document-items-aligned > .quotation-item-details-row {\n    display: contents !important;\n  }\n\n  .document-items-aligned .quotation-item-details-row > .quotation-col-desc {\n    grid-column: 1;\n    grid-row: 2;\n  }\n\n  .document-items-aligned .quotation-item-details-row\n    > :is(.quotation-col-qty-input, .quotation-col-price-input,\n      .quotation-col-gst-select, .quotation-col-line-total, .quotation-col-row-action) {\n    grid-row: 1;\n  }\n\n  .document-items-aligned .quotation-item-details-row > .quotation-col-qty-input {\n    grid-column: 2;\n  }\n\n  .document-items-aligned .quotation-item-details-row > .quotation-col-price-input {\n    grid-column: 3;\n  }\n\n  .document-items-aligned .quotation-item-details-row > .quotation-col-gst-select {\n    grid-column: 4;\n    width: 100%;\n  }\n\n  .document-items-aligned .quotation-item-details-row > .quotation-col-line-total {\n    grid-column: 5;\n    justify-self: end;\n    width: fit-content;\n    max-width: 100%;\n  }\n\n  .document-items-aligned .quotation-item-details-row > .quotation-col-row-action {\n    grid-column: 6;\n  }\n\n  .quotation-item-row-card.document-items-aligned > .quotation-item-discount-row {\n    grid-column: 1 / -1;\n    grid-row: 3;\n  }\n}\n\n/* Responsive items and pricing layout */\n@media (max-width: 767px) {\n  .quotation-editor-card {\n    padding: 16px;\n    gap: 16px;\n  }\n\n  .quotation-editor-main {\n    gap: 20px;\n  }\n\n  .quotation-card-header h3,\n  .quotation-grand-total-header span,\n  .quotation-summary-card h4 {\n    font-size: 16px;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n  }\n\n  .quotation-grand-total-card,\n  .quotation-summary-card,\n  .quotation-guidance-card {\n    padding: 16px;\n  }\n\n  .quotation-grand-total-headline strong {\n    font-size: 20px;\n    line-height: 24px;\n  }\n\n  .quotation-card-body,\n  .quotation-items-table-body,\n  .quotation-item-row-card {\n    min-width: 0;\n  }\n\n  .quotation-items-table-header {\n    display: none !important;\n  }\n\n  .quotation-item-row-card {\n    gap: 12px;\n    padding: 16px 0;\n  }\n\n  .quotation-item-details-row {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n    align-items: end;\n  }\n\n  .quotation-item-details-row > [data-label] {\n    position: relative;\n    width: 100%;\n    min-width: 0;\n    margin-top: 22px;\n  }\n\n  .quotation-item-details-row > [data-label]::before {\n    content: attr(data-label);\n    position: absolute;\n    bottom: calc(100% + 6px);\n    left: 0;\n    color: var(--text-secondary, #506360);\n    font-family: var(--font-family-primary);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n  }\n\n  .quotation-editor-page.dark\n    .quotation-item-details-row\n    > [data-label]::before,\n  .quotation-editor-page[data-theme=\"dark\"]\n    .quotation-item-details-row\n    > [data-label]::before {\n    color: var(--text-secondary, #b3b8c2);\n  }\n\n  .quotation-item-details-row .quotation-col-desc {\n    grid-column: 1 / -1;\n  }\n\n  .quotation-item-details-row .quotation-col-qty-input,\n  .quotation-item-details-row .quotation-col-price-input,\n  .quotation-item-details-row .quotation-col-line-total,\n  .quotation-item-details-row\n    .quotation-col-gst-select.quotation-custom-dropdown-wrap {\n    width: 100%;\n  }\n\n  .quotation-item-details-row .quotation-col-line-total {\n    justify-content: flex-end;\n  }\n\n  .quotation-item-details-row .quotation-col-row-action {\n    grid-column: 1 / -1;\n    width: auto;\n    height: 32px;\n    justify-content: flex-end;\n  }\n\n  .quotation-item-details-row .quotation-col-row-action:empty {\n    display: none;\n  }\n\n  .quotation-item-remove-btn {\n    width: auto;\n    gap: 6px;\n    padding: 0 8px !important;\n  }\n\n  .quotation-item-remove-btn span {\n    display: inline;\n    font-family: var(--font-family-primary);\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .quotation-item-discount-row {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n  }\n\n  .quotation-discount-type-wrap,\n  .quotation-discount-val-wrap {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .quotation-items-spacer {\n    display: none;\n  }\n\n  .quotation-total-item-discounts-badge {\n    width: 100%;\n    margin-left: 0;\n    justify-content: space-between;\n  }\n}\n\n@media (max-width: 480px) {\n  .quotation-pricing-basis-row,\n  .quotation-pricing-basis-bar {\n    align-items: stretch !important;\n    flex-direction: column;\n    gap: 8px !important;\n  }\n\n  .quotation-pricing-basis-select-wrap.quotation-custom-dropdown-wrap {\n    width: 100%;\n  }\n\n  .quotation-item-discount-row {\n    grid-template-columns: 1fr;\n  }\n\n  .quotation-item-result-top {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .quotation-item-result-price-group {\n    padding-left: 22px;\n  }\n\n  .quotation-catalogue-option-row {\n    min-width: 0;\n  }\n\n  .quotation-catalogue-option-edit {\n    width: 44px;\n    height: 44px;\n  }\n\n  .quotation-autocomplete-item.quotation-catalogue-option {\n    padding: 10px 56px 10px 8px;\n  }\n\n  .quotation-action-outline-btn,\n  .quotation-action-link-btn {\n    flex: 1 1 auto;\n    justify-content: center;\n  }\n}\n\n/* History & notes drawer — Figma 604:62471 */\n.quotation-editor-main-area.history-open .quotation-editor-content {\n  margin-right: 480px;\n}\n\n.quotation-history-drawer {\n  position: fixed;\n  z-index: 850;\n  top: 64px;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 480px;\n  padding: 24px;\n  overflow-y: auto;\n  border-left: 1px solid var(--border-subtle, #dce3e2);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  box-shadow: -1px 0 2px rgba(14, 26, 32, 0.04);\n}\n\n.quotation-history-drawer-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.quotation-history-drawer-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n}\n\n.quotation-history-drawer-header p {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n\n.quotation-history-drawer-header button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  cursor: pointer;\n}\n\n.quotation-history-drawer-header button:hover {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-history-drawer-header svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quotation-history-private {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-history-private > svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n}\n\n.quotation-history-private strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n}\n\n.quotation-history-private p {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n\n.quotation-history-filters {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.quotation-history-filters button {\n  height: 40px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n}\n\n.quotation-history-filters button.active {\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n}\n\n.quotation-history-caption {\n  margin: -4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n\n.quotation-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.quotation-history-view-all {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  min-height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--interactive-default, #0f766e);\n  font: 500 13px / normal var(--font-family-primary);\n  cursor: pointer;\n}\n\n.quotation-history-view-all:hover {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-hover-soft, #edf8f7);\n}\n\n.quotation-history-view-all:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n.quotation-history-view-all svg,\n.quotation-history-view-all img {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n\n.quotation-history-event {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n}\n\n.quotation-history-event.note {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-history-event strong {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n}\n\n.quotation-history-event > span,\n.quotation-history-event > p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 21.7px;\n}\n\n.quotation-history-event time {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n\n.quotation-history-empty {\n  padding: 24px 16px;\n  border: 1px dashed var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  text-align: center;\n}\n\n.quotation-history-composer {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 6px 12px;\n  padding-bottom: 8px;\n}\n\n.quotation-history-composer label,\n.quotation-history-composer textarea {\n  grid-column: 1 / -1;\n}\n\n.quotation-history-composer label {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n}\n\n.quotation-history-composer textarea {\n  width: 100%;\n  height: 120px;\n  padding: 12px;\n  resize: vertical;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  outline: none;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 14px/21.7px var(--font-family-primary);\n}\n\n.quotation-history-composer textarea::placeholder {\n  color: var(--text-tertiary, #6b7b78);\n}\n\n.quotation-history-composer textarea:focus {\n  border: 2px solid var(--interactive-default, #0f766e);\n  padding: 11px;\n  box-shadow: none;\n}\n\n.quotation-history-composer > span {\n  align-self: center;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n\n.quotation-history-composer button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 10px;\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n}\n\n.quotation-history-composer button:disabled {\n  background: var(--interactive-disabled, #cdd6d4);\n  color: var(--on-interactive-disabled, #8a9896);\n  opacity: 0.75;\n  cursor: not-allowed;\n}\n\n.quotation-history-composer button svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quotation-editor-shell.dark .quotation-history-drawer,\n.quotation-editor-shell.dark .quotation-history-event,\n.quotation-editor-shell.dark .quotation-history-composer textarea {\n  border-color: var(--border-subtle, #2c3036);\n  background: var(--surface-primary, #191b1f);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-shell.dark .quotation-history-private,\n.quotation-editor-shell.dark .quotation-history-event.note {\n  background: var(--surface-secondary, #22252a);\n}\n\n.quotation-editor-shell.dark .quotation-history-view-all {\n  border-color: var(--border-default, #3a4048);\n  background: var(--surface-primary, #191b1f);\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-editor-shell.dark .quotation-history-view-all:hover {\n  border-color: var(--interactive-default, #43a79c);\n  background: var(--surface-secondary, #22252a);\n}\n\n@media (max-width: 1180px) {\n  .quotation-editor-main-area.history-open .quotation-editor-content {\n    margin-right: 0;\n  }\n  .quotation-history-drawer {\n    width: min(480px, 100vw);\n    box-shadow: -12px 0 30px rgba(14, 26, 32, 0.18);\n  }\n}\n\n/* Customer quotation preview — Figma 589:33102 */\n.quotation-preview-shell {\n  min-height: 100vh;\n  background: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n.quotation-preview-main {\n  min-width: 0;\n}\n.quotation-customer-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 32px;\n  font-family: var(--font-family-primary);\n}\n.quotation-preview-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: fit-content;\n  height: 40px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-link, #0f766e);\n  font: 500 13px var(--font-family-primary);\n  cursor: pointer;\n}\n.quotation-preview-back svg {\n  width: 16px;\n  height: 16px;\n}\n.quotation-preview-heading-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n}\n.quotation-preview-heading-row h1 {\n  margin: 0 0 8px;\n  color: var(--text-primary, #142624);\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}\n.quotation-preview-status-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.quotation-preview-number {\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n}\n.quotation-preview-status {\n  height: 22px;\n  padding: 3px 6px;\n  border-radius: 999px;\n  background: var(--surface-tertiary, #e8edec);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n}\n.quotation-preview-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.quotation-preview-actions button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  font: 500 14px var(--font-family-primary);\n  letter-spacing: 0.07px;\n  cursor: pointer;\n}\n.quotation-preview-actions svg {\n  width: 16px;\n  height: 16px;\n}\n.quotation-preview-secondary {\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n.quotation-preview-primary {\n  border: 0;\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n}\n.quotation-preview-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n.quotation-preview-notice > svg {\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  color: var(--text-secondary, #506360);\n}\n.quotation-preview-notice div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.quotation-preview-notice strong {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n}\n.quotation-preview-notice span {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.quotation-preview-document {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 32px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.quotation-preview-document-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.quotation-preview-document-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n}\n.quotation-preview-document-header > div {\n  text-align: right;\n}\n.quotation-preview-document-header h3 {\n  margin: 0 0 8px;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}\n.quotation-preview-document-header span {\n  color: var(--text-secondary, #506360);\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n}\n.quotation-preview-rule {\n  height: 1px;\n  background: var(--border-subtle, #dce3e2);\n}\n.quotation-preview-details {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 24px;\n}\n.quotation-preview-details div {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.quotation-preview-details span {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.quotation-preview-details strong {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n}\n.quotation-preview-items-section h4,\n.quotation-preview-approval h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n}\n.quotation-preview-items-section > p {\n  margin: 2px 0 12px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n.quotation-preview-table-wrap {\n  overflow-x: auto;\n}\n.quotation-preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n.quotation-preview-table th {\n  height: 44px;\n  padding: 0 12px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  font-weight: 500;\n  text-align: left;\n}\n.quotation-preview-table th:first-child {\n  width: 50%;\n}\n.quotation-preview-table th:not(:first-child),\n.quotation-preview-table td:not(:first-child) {\n  text-align: right;\n}\n.quotation-preview-table td {\n  padding: 8px 12px;\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 14px;\n  vertical-align: top;\n}\n.quotation-preview-table td:first-child {\n  font-family: var(--font-family-primary);\n  text-align: left;\n}\n.quotation-preview-table td:first-child strong,\n.quotation-preview-table td:first-child span {\n  display: block;\n}\n.quotation-preview-table td:first-child strong {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n}\n.quotation-preview-table td:first-child span {\n  margin-top: 4px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.quotation-preview-bottom-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.5fr) minmax(320px, 1fr);\n  gap: 40px;\n}\n.quotation-preview-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.quotation-preview-copy strong {\n  font-size: 14px;\n  font-weight: 500;\n}\n.quotation-preview-copy p {\n  margin: 8px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.quotation-preview-totals {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.quotation-preview-totals > div {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n.quotation-preview-totals strong {\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 14px;\n  font-weight: 500;\n}\n.quotation-preview-totals .quotation-preview-total {\n  align-items: center;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n  color: var(--text-primary, #142624);\n  font-weight: 500;\n}\n.quotation-preview-total strong {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  font-size: 20px;\n  font-weight: 700;\n}\n.quotation-preview-total small {\n  margin-top: 4px;\n  color: var(--text-secondary, #506360);\n  font: 400 12px var(--font-family-primary);\n}\n.quotation-preview-totals > p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n.quotation-preview-online {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.quotation-preview-online-label {\n  display: flex;\n  justify-content: space-between;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n.quotation-preview-online-label strong {\n  font-size: 14px;\n  font-weight: 500;\n}\n.quotation-preview-approval {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 32px;\n  padding: 24px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n.quotation-preview-approval p {\n  margin: 8px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 21.7px;\n}\n.quotation-preview-disabled-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n.quotation-preview-disabled-actions button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 10px;\n  color: var(--text-disabled, #8a9896);\n  background: transparent;\n  font: 500 13px var(--font-family-primary);\n  opacity: 0.75;\n}\n.quotation-preview-disabled-actions button:last-child {\n  background: var(--interactive-disabled, #cdd6d4);\n}\n.quotation-preview-shell.dark .quotation-preview-document,\n.quotation-preview-shell.dark .quotation-preview-approval {\n  background: var(--surface-primary, #191b1f);\n}\n@media (max-width: 900px) {\n  .quotation-customer-preview {\n    padding: 24px 16px;\n  }\n  .quotation-preview-heading-row,\n  .quotation-preview-approval {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .quotation-preview-details {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .quotation-preview-bottom-grid {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 600px) {\n  .quotation-preview-heading-row h1,\n  .quotation-preview-document-header h3 {\n    font-size: 26px;\n    line-height: 34px;\n  }\n  .quotation-preview-heading-row,\n  .quotation-preview-document-header,\n  .quotation-preview-online-label {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .quotation-preview-actions {\n    width: 100%;\n  }\n  .quotation-preview-actions button {\n    flex: 1;\n  }\n  .quotation-preview-document {\n    padding: 20px 16px;\n  }\n  .quotation-preview-details {\n    grid-template-columns: 1fr;\n  }\n  .quotation-preview-table {\n    min-width: 720px;\n  }\n  .quotation-preview-disabled-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n}\n\n.quotation-item-no-results {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.quotation-item-no-results strong {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-item-no-results strong,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-no-results strong {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-item-no-results span {\n  font-size: 12px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-item-no-results span,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-item-no-results span {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n/* ==========================================================================\n   EMPTY ATTACHMENTS CARD (FIGMA NODE 582:38601)\n   ========================================================================== */\n.quotation-empty-attachments-box {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: var(--surface-secondary, #f4f7f7);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  width: 100%;\n}\n\n.quotation-editor-page.dark .quotation-empty-attachments-box,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-empty-attachments-box {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-subtle, #2c3036);\n}\n\n.quotation-attachment-indicator-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--interactive-default, #0f766e);\n}\n\n.quotation-attachment-indicator-icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.quotation-editor-page.dark .quotation-attachment-indicator-icon,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-attachment-indicator-icon {\n  color: var(--interactive-default, #43a79c);\n}\n\n.quotation-attachment-guidance-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1 0 0;\n  min-width: 0;\n}\n\n.quotation-attachment-guidance-content h4 {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  color: var(--text-primary, #142624);\n}\n\n.quotation-editor-page.dark .quotation-attachment-guidance-content h4,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-attachment-guidance-content\n  h4 {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-attachment-guidance-content p {\n  margin: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quotation-editor-page.dark .quotation-attachment-guidance-content p,\n.quotation-editor-page[data-theme=\"dark\"]\n  .quotation-attachment-guidance-content\n  p {\n  color: var(--text-secondary, #b3b8c2);\n}\n\n.quotation-add-attachment-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 14px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  flex-shrink: 0;\n  white-space: nowrap;\n  transition: background 0.12s ease;\n}\n\n.quotation-add-attachment-btn:hover {\n  background: #e8edec;\n}\n\n.quotation-editor-page.dark .quotation-add-attachment-btn,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-add-attachment-btn {\n  background: var(--surface-secondary, #22252a);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quotation-editor-page.dark .quotation-add-attachment-btn:hover,\n.quotation-editor-page[data-theme=\"dark\"] .quotation-add-attachment-btn:hover {\n  background: #2a2e35;\n}\n\n.quotation-add-attachment-btn.outline {\n  background: transparent;\n  align-self: flex-start;\n  margin-top: 8px;\n}\n\n/* ==========================================================================\n   QUOTE DETAILS SCREEN (Figma Nodes 623:40457 - Sent & 623:51504 - Approved)\n   ========================================================================== */\n\n.quote-details-shell {\n  min-height: 100vh;\n  background: var(--bg-primary, #f4f7f7);\n}\n\n.quote-details-content {\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: var(--font-family-primary);\n}\n\n/* Header */\n.quote-details-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.quote-details-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: var(--radius-md, 10px);\n  background: transparent;\n  color: var(--text-link, #0f766e);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  align-self: flex-start;\n  transition: background 0.15s ease;\n}\n\n.quote-details-back-btn:hover {\n  background: var(--surface-secondary, #e8edec);\n}\n\n.quote-details-back-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quote-details-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.quote-details-title-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.quote-details-title {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-details-identity-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.quote-number-pill {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n  color: var(--text-primary, #142624);\n}\n\n.quote-identity-dot {\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n}\n\n.quote-customer-name {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-status-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: var(--radius-pill, 999px);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15.6px;\n  letter-spacing: 0.12px;\n  white-space: nowrap;\n}\n\n.quote-status-pill.sent {\n  background: var(--info-soft, #eff6ff);\n  color: var(--info-text, #1d4ed8);\n}\n\n.quote-status-pill.approved {\n  background: var(--success-soft, #f0fdf4);\n  color: var(--success-text, #15803d);\n}\n\n.quote-status-pill.draft {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.quote-status-pill.viewed {\n  background: var(--info-soft, #eff6ff);\n  color: var(--info-text, #1d4ed8);\n}\n\n.quote-status-pill.declined {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.quote-status-pill.expired {\n  background: #fff7ed;\n  color: #b45309;\n}\n\n.quote-details-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.quote-details-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.quote-details-action-btn:hover {\n  background: var(--surface-secondary, #f4f7f7);\n  border-color: var(--border-strong, #8a9896);\n}\n\n.quote-details-action-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quote-details-primary-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md, 10px);\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quote-details-primary-btn:hover {\n  background: var(--interactive-hover, #0d655e);\n}\n\n.quote-details-primary-btn:disabled {\n  background: var(--interactive-disabled, #cdd6d4);\n  color: var(--on-interactive-disabled, #8a9896);\n  cursor: not-allowed;\n}\n\n.quote-details-primary-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quote-details-meta-line {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n\n/* Two-column Grid */\n.quote-details-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 1024px) {\n  .quote-details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.quote-details-main-col {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n/* Card Structure */\n.quote-details-card {\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  padding: 24px;\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.quote-card-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.quote-card-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-card-subtitle {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-content-meta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n@media (max-width: 600px) {\n  .quote-content-meta-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.quote-meta-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.quote-meta-label {\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-meta-val {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-card-divider {\n  border: 0;\n  height: 1px;\n  background: var(--border-subtle, #dce3e2);\n  margin: 0;\n}\n\n/* Items & Pricing Table */\n.quote-items-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.quote-items-table-header {\n  display: grid;\n  grid-template-columns: minmax(180px, 1fr) 48px 112px 64px 96px 112px;\n  background: var(--surface-secondary, #f4f7f7);\n  border-radius: var(--radius-sm, 6px);\n  min-height: 44px;\n  align-items: center;\n  padding: 0 12px;\n  gap: 12px;\n}\n\n.quote-th {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15.6px;\n  letter-spacing: 0.12px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-th.text-right {\n  text-align: right;\n}\n\n.quote-items-table-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.quote-item-row {\n  display: grid;\n  grid-template-columns: minmax(180px, 1fr) 48px 112px 64px 96px 112px;\n  align-items: center;\n  padding: 12px;\n  gap: 12px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  min-height: 56px;\n}\n\n.quote-item-desc {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.quote-item-name {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-item-sub {\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-cell-qty {\n  font-size: 14px;\n  text-align: right;\n  color: var(--text-primary, #142624);\n}\n\n.quote-cell-money {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20.8px;\n  text-align: right;\n  color: var(--text-primary, #142624);\n}\n\n.quote-cell-gst {\n  font-size: 14px;\n  text-align: right;\n  color: var(--text-primary, #142624);\n}\n\n.quote-cell-discount {\n  font-size: 14px;\n  text-align: right;\n  color: var(--text-primary, #142624);\n}\n\n/* Scope, Terms & Totals Breakdown */\n.quote-scope-totals-row {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 32px;\n  padding-top: 8px;\n}\n\n@media (max-width: 860px) {\n  .quote-scope-totals-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.quote-scope-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.quote-scope-block {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.quote-scope-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-scope-desc {\n  margin: 0;\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n  white-space: pre-line;\n}\n\n.quote-totals-col {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.quote-total-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  line-height: 21.7px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-total-val {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quote-grand-total-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 10px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary, #142624);\n}\n\n.quote-grand-total-val {\n  font-family: var(--font-family-mono, monospace);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary, #142624);\n}\n\n.quote-totals-footnote {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 16.8px;\n  color: var(--text-secondary, #506360);\n}\n\n/* Attachments */\n.quote-attachments-body {\n  width: 100%;\n}\n\n.quote-attachments-empty {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-attachments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.quote-attachment-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quote-attachment-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n}\n\n.quote-attachment-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: 0;\n  color: var(--interactive-default, #0f766e);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: var(--radius-sm, 6px);\n}\n\n.quote-attachment-btn:hover {\n  background: #e8edec;\n}\n\n/* Sidebar */\n.quote-details-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.quote-summary-total-card {\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  padding: 24px;\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.quote-summary-total-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.quote-summary-total-header svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.quote-summary-amount {\n  margin: 0 0 6px;\n  font-family: var(--font-family-mono, monospace);\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 32px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-summary-caption {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-sidebar-status-card {\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  padding: 24px;\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.quote-sidebar-status-card.sent {\n  padding-top: 22px;\n}\n\n.quote-sidebar-status-card.approved {\n  border-top: 3px solid var(--success-text, #15803d);\n  padding-top: 22px;\n}\n\n.quote-sidebar-status-card.declined {\n  border-top: 3px solid #c24136;\n  padding-top: 22px;\n}\n\n.quote-sidebar-status-card.expired {\n  border-top: 3px solid #b45309;\n  padding-top: 22px;\n}\n\n.quote-status-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-status-card-header.approved svg {\n  color: var(--success-text, #15803d);\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.quote-status-card-header > svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.quote-sidebar-status-card.sent .quote-status-card-header > svg {\n  color: var(--info-text, #1d4ed8);\n}\n\n.quote-status-card-header.declined svg,\n.quote-status-card-header.expired svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.quote-status-card-header.declined svg {\n  color: #c24136;\n}\n\n.quote-status-card-header.expired svg {\n  color: #b45309;\n}\n\n.quote-status-meta-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.quote-status-meta-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.quote-status-meta-row-label {\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-status-meta-row-val {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--text-primary, #142624);\n  word-break: break-word;\n}\n\n.quote-meta-footnote {\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.ready-to-invoice-box {\n  background: var(--surface-secondary, #f4f7f7);\n  border-radius: var(--radius-md, 10px);\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ready-to-invoice-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  color: var(--text-primary, #142624);\n}\n\n.ready-to-invoice-desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-original-delivery-box {\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n  padding-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.quote-status-card-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.quote-status-sub-btn {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--interactive-default, #0f766e);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.quote-status-sub-btn:hover {\n  background: var(--interactive-soft, #f0f8f7);\n  border-color: var(--interactive-default, #0f766e);\n}\n\n.quote-status-sub-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quote-status-revise-btn {\n  width: 100%;\n  flex: none;\n}\n\n/* Viewed state status actions & subtexts (Figma 663:64332) */\n.quote-status-card-actions.viewed-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.quote-status-primary-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  width: 100%;\n  border: 0;\n  border-radius: var(--radius-md, 10px);\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.quote-status-primary-btn:hover {\n  background: var(--interactive-hover, #0d655e);\n}\n\n.quote-status-primary-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quote-status-secondary-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  width: 100%;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.quote-status-secondary-btn:hover {\n  background: #e8edec;\n  border-color: var(--border-strong, #8a9896);\n}\n\n.quote-status-secondary-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quote-meta-subtext {\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-sidebar-disclaimer {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n/* Bottom History & Notes Section */\n.quote-details-history-section {\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 24px;\n}\n\n.quotation-editor-shell.dark .quotation-editor-history-section {\n  border-color: var(--border-subtle, #2c3036);\n  background: var(--surface-primary, #191b1f);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quote-history-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.quote-history-header > div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.quote-history-header .quotation-history-link-btn {\n  flex-shrink: 0;\n  padding: 4px 0;\n}\n\n.quote-history-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 25.2px;\n  letter-spacing: -0.09px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-history-subtitle {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-history-privacy-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quote-history-privacy-banner svg {\n  width: 20px;\n  height: 20px;\n  color: var(--text-secondary, #506360);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.quote-history-privacy-banner strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18.2px;\n  letter-spacing: 0.07px;\n  color: var(--text-primary, #142624);\n}\n\n.quote-history-privacy-banner p {\n  margin: 4px 0 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n  color: var(--text-secondary, #506360);\n}\n\n.quote-history-two-col {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 900px) {\n  .quote-history-header {\n    flex-direction: column;\n  }\n\n  .quote-history-two-col {\n    grid-template-columns: 1fr;\n  }\n}\n\n.quote-history-activity-col {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.quote-details-history-section .quotation-history-event {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 8px 16px;\n}\n\n.quote-details-history-section .quotation-history-event > time {\n  grid-column: 2;\n  grid-row: 1;\n  white-space: nowrap;\n}\n\n.quote-details-history-section .quotation-history-event > span,\n.quote-details-history-section .quotation-history-event > p {\n  grid-column: 1 / -1;\n}\n\n.quote-history-composer-col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Dark Mode Overrides for Quote Details */\n.quote-details-shell.dark,\n.quote-details-page.dark,\n.quote-details-page[data-theme=\"dark\"] {\n  background: var(--bg-primary, #181b1f);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quote-details-page.dark .quote-details-title,\n.quote-details-page.dark .quote-number-pill,\n.quote-details-page.dark .quote-customer-name,\n.quote-details-page.dark .quote-card-title,\n.quote-details-page.dark .quote-meta-val,\n.quote-details-page.dark .quote-item-name,\n.quote-details-page.dark .quote-cell-qty,\n.quote-details-page.dark .quote-cell-money,\n.quote-details-page.dark .quote-cell-gst,\n.quote-details-page.dark .quote-cell-discount,\n.quote-details-page.dark .quote-scope-title,\n.quote-details-page.dark .quote-scope-desc,\n.quote-details-page.dark .quote-total-val,\n.quote-details-page.dark .quote-grand-total-row,\n.quote-details-page.dark .quote-grand-total-val,\n.quote-details-page.dark .quote-summary-amount,\n.quote-details-page.dark .quote-status-card-header,\n.quote-details-page.dark .quote-status-meta-row-val,\n.quote-details-page.dark .ready-to-invoice-title,\n.quote-details-page.dark .quote-history-title,\n.quote-details-page.dark .quote-history-privacy-banner strong,\n.quote-details-page.dark .quote-attachment-info {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quote-details-page.dark .quote-details-card,\n.quote-details-page.dark .quote-summary-total-card,\n.quote-details-page.dark .quote-sidebar-status-card,\n.quote-details-page.dark .quote-details-history-section {\n  background: var(--surface-primary, #20242a);\n  border-color: var(--border-subtle, #2f343b);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n}\n\n.quote-details-page.dark .quote-details-action-btn,\n.quote-details-page.dark .quote-status-sub-btn,\n.quote-details-page.dark .quote-status-secondary-btn {\n  background: var(--surface-secondary, #282c34);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quote-details-page.dark .quote-details-action-btn:hover,\n.quote-details-page.dark .quote-status-sub-btn:hover,\n.quote-details-page.dark .quote-status-secondary-btn:hover {\n  background: #323741;\n}\n\n.quote-details-page.dark .quote-items-table-header,\n.quote-details-page.dark .ready-to-invoice-box,\n.quote-details-page.dark .quote-attachment-item,\n.quote-details-page.dark .quote-history-privacy-banner {\n  background: var(--surface-secondary, #282c34);\n  border-color: var(--border-subtle, #2f343b);\n}\n\n.quote-details-page.dark .quote-card-divider,\n.quote-details-page.dark .quote-item-row,\n.quote-details-page.dark .quote-grand-total-row,\n.quote-details-page.dark .quote-original-delivery-box {\n  border-color: var(--border-subtle, #2f343b);\n}\n\n/* Create invoice dialog */\n.quote-create-invoice-scrim {\n  z-index: 1400;\n}\n\n.quote-create-invoice-dialog {\n  width: min(100% - 32px, 560px);\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 16px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 20px 48px rgba(20, 38, 36, 0.2);\n}\n\n.quote-create-invoice-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 24px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.quote-create-invoice-header h2 {\n  margin: 0;\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.quote-create-invoice-header p {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.quote-create-invoice-close {\n  display: inline-grid;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n\n.quote-create-invoice-close:hover:not(:disabled) {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n\n.quote-create-invoice-close svg {\n  width: 20px;\n  height: 20px;\n}\n\n.quote-create-invoice-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px;\n}\n\n.quote-create-invoice-source {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 4px 12px;\n  padding: 14px;\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quote-create-invoice-source-label {\n  grid-column: 1 / -1;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.quote-create-invoice-source strong,\n.quote-create-invoice-source span:last-child {\n  color: var(--text-primary, #142624);\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.quote-create-invoice-source strong {\n  font-weight: 600;\n}\n\n.quote-create-invoice-source span:last-child {\n  text-align: right;\n}\n\n.quote-create-invoice-summary {\n  display: grid;\n  grid-template-columns: 1.3fr 1.5fr 0.7fr;\n  gap: 12px;\n}\n\n.quote-create-invoice-summary div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.quote-create-invoice-summary span {\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.quote-create-invoice-summary strong {\n  overflow: hidden;\n  color: var(--text-primary, #142624);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.quote-create-invoice-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 10px;\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--text-secondary, #506360);\n}\n\n.quote-create-invoice-note svg {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.quote-create-invoice-note p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.quote-create-invoice-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.quote-create-invoice-cancel,\n.quote-create-invoice-confirm {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.quote-create-invoice-cancel {\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n}\n\n.quote-create-invoice-confirm {\n  border: 1px solid var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n}\n\n.quote-create-invoice-confirm:hover:not(:disabled) {\n  background: var(--interactive-hover, #0d655e);\n}\n\n.quote-create-invoice-cancel:disabled,\n.quote-create-invoice-confirm:disabled,\n.quote-create-invoice-close:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.quote-create-invoice-confirm svg {\n  width: 16px;\n  height: 16px;\n}\n\n.quote-details-page.dark .quote-create-invoice-dialog {\n  background: var(--surface-primary, #20242a);\n  border-color: var(--border-subtle, #2f343b);\n}\n\n.quote-details-page.dark .quote-create-invoice-header,\n.quote-details-page.dark .quote-create-invoice-footer {\n  border-color: var(--border-subtle, #2f343b);\n}\n\n.quote-details-page.dark .quote-create-invoice-header h2,\n.quote-details-page.dark .quote-create-invoice-source strong,\n.quote-details-page.dark .quote-create-invoice-source span:last-child,\n.quote-details-page.dark .quote-create-invoice-summary strong {\n  color: var(--text-primary, #f2f3f5);\n}\n\n.quote-details-page.dark .quote-create-invoice-source,\n.quote-details-page.dark .quote-create-invoice-cancel {\n  background: var(--surface-secondary, #282c34);\n  border-color: var(--border-default, #3a3f47);\n}\n\n.quote-details-page.dark .quote-create-invoice-cancel {\n  color: var(--text-primary, #f2f3f5);\n}\n\n@media (max-width: 767px) {\n  .quote-details-content {\n    padding: 20px 16px 32px;\n  }\n\n  .quote-details-header {\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n\n  .quote-details-title {\n    font-size: 28px;\n    line-height: 35px;\n  }\n\n  .quote-details-title-row,\n  .quote-details-actions {\n    width: 100%;\n  }\n\n  .quote-details-actions {\n    gap: 8px;\n  }\n\n  .quote-details-action-btn,\n  .quote-details-primary-btn {\n    flex: 1 1 150px;\n  }\n\n  .quote-details-card,\n  .quote-summary-total-card,\n  .quote-sidebar-status-card,\n  .quote-details-history-section {\n    padding: 20px;\n  }\n\n  .quote-items-table-header,\n  .quote-item-row {\n    min-width: 720px;\n  }\n\n  .quote-sidebar-status-card {\n    gap: 16px;\n  }\n}\n\n@media (max-width: 520px) {\n  .quote-create-invoice-header,\n  .quote-create-invoice-body {\n    padding: 20px;\n  }\n\n  .quote-create-invoice-footer {\n    padding: 14px 20px;\n  }\n\n  .quote-create-invoice-summary {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .quote-create-invoice-summary div:last-child {\n    grid-column: 1 / -1;\n  }\n}\n.quotation-send-failed-dialog {\n  max-width: 560px;\n}\n.quotation-send-failed-body {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n.quotation-send-failed-body > svg {\n  width: 22px;\n  height: 22px;\n  flex: 0 0 22px;\n  color: var(--danger-text, #c23a2b);\n}\n.quotation-send-failed-body strong {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-primary, #142624);\n  font-size: 14px;\n}\n.quotation-send-failed-body p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 20px;\n}\n.quotation-modal-submit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.quotation-send-success-dialog {\n  max-width: 560px;\n}\n.quotation-send-success-body {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n.quotation-send-success-body > svg {\n  width: 22px;\n  height: 22px;\n  flex: 0 0 22px;\n  color: var(--success-text, #15803d);\n}\n.quotation-send-success-body strong {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-primary, #142624);\n  font-size: 14px;\n}\n.quotation-send-success-body p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 20px;\n}\n.quotation-send-success-body p + p {\n  margin-top: 6px;\n}\n.quotation-editor-card.quotation-attachments-card {\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n\n.quotation-attachments-card .quotation-card-header {\n  margin-bottom: 0;\n}\n\n.quotation-attachments-card .quotation-card-body {\n  gap: 0;\n}\n\n.quotation-attachments-card .quotation-attachment-summary {\n  margin-bottom: var(--space-3, 12px);\n  padding: var(--space-4, 16px);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.quotation-attachments-card .quotation-attachment-summary strong {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 18px;\n}\n\n.quotation-attachments-card .quotation-attachment-summary p {\n  margin: 3px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 17px;\n}\n\n.quotation-attachments-card .quotation-attachments-list {\n  margin-bottom: var(--space-3, 12px);\n}\n\n.quotation-attachments-card .quotation-attachment-info {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.quotation-attachments-card .quotation-attachment-actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: var(--space-2, 8px);\n}\n\n.quotation-attachments-card .quotation-attachment-view-btn {\n  padding: 4px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n\n.quotation-attachments-card .quotation-attachment-view-btn:hover {\n  color: var(--interactive-default, #0f766e);\n}\n\n.quotation-attachments-card .quotation-attachment-upload {\n  display: inline-flex;\n  width: max-content;\n  align-self: flex-start;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  box-sizing: border-box;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.quotation-attachments-card .quotation-attachment-upload input {\n  display: none;\n}\n\n.quotation-attachments-card .quotation-attachment-info > svg,\n.quotation-attachments-card .quotation-attachment-upload > svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.quotation-attachments-card .quotation-attachment-error {\n  display: block;\n  margin-top: 6px;\n  color: var(--danger-text, #a3301f);\n  font-size: 12px;\n  line-height: 18px;\n}\n\n@media (max-width: 700px) {\n  .quotation-attachments-card .quotation-attachment-upload {\n    height: 44px;\n    font-size: 14px;\n  }\n}\n.quotation-customer-modal .quotation-customer-field-error {\n  display: block;\n  color: var(--danger-text, #a3301f);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.quotation-customer-modal .quotation-input-box.error {\n  border-color: var(--danger-default, #c23a2b);\n}\n\n.quotation-customer-modal .quotation-input-box.error:focus-within {\n  box-shadow: none;\n}\n\n:is(.quotation-editor-page, .invoice-editor-shell, .rcti-editor-shell)\n  .quotation-field-error,\n:is(.invoice-editor-shell, .rcti-editor-shell)\n  .figma-datepicker__helper--error {\n  display: block;\n  margin-top: 4px;\n  color: var(--danger-text, #a3301f);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n  line-height: 18px;\n}\n\n.quotation-editor-page .quotation-input-box:has([aria-invalid=\"true\"]),\n.quotation-editor-page .quotation-item-search-box:has([aria-invalid=\"true\"]),\n.quotation-editor-page .quotation-item-details-row input[aria-invalid=\"true\"] {\n  border-color: var(--danger-default, #c23a2b);\n}\n\n:is(.quotation-editor-page, .invoice-editor-shell)\n  .quotation-item-details-row:has([aria-invalid=\"true\"]) {\n  align-items: flex-start;\n}\n\n/* Keep quotation field focus borders thin and green without a glow. */\n.quotation-editor-shell\n  :is(.quotation-input-box, .quotation-item-search-box, .quotation-select-box):not(.disabled):not(.quotation-input-readonly):not(.quotation-custom-dropdown-wrap):not(.error):not(:has(:disabled, [readonly], [aria-invalid=\"true\"])):focus-within,\n.quotation-editor-shell\n  .quotation-item-details-row\n  input:not(:disabled):not([readonly]):not([aria-invalid=\"true\"]):focus,\n.quotation-editor-shell .quotation-textarea-box:focus,\n.quotation-editor-shell .quotation-history-composer textarea:focus,\n.quotation-editor-shell\n  .quotation-dialog-field\n  input:not(:disabled):not([readonly]):not([aria-invalid=\"true\"]):focus,\n.quotation-editor-shell\n  .quotation-figma-dropdown-trigger:not(:disabled):focus-visible,\n.quotation-editor-shell\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger {\n  border: 1px solid var(--interactive-default, #0f766e);\n  box-shadow: none;\n  outline: none;\n}\n\n.quotation-editor-shell\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger,\n.quotation-editor-shell\n  .quotation-item-details-row\n  .quotation-col-gst-select.quotation-custom-dropdown-wrap\n  .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger {\n  padding-inline: 12px 10px;\n}\n\n.quotation-editor-shell\n  .figma-datepicker__input-container:not(.figma-datepicker__input-container--disabled):not(.figma-datepicker__input-container--error):focus-within {\n  border: 1px solid var(--interactive-default, #0f766e) !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.quotation-sent-success-dialog {\n  width: min(100%, 520px);\n}\n.quotation-send-success-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-3, 12px);\n  padding: var(--space-8, 32px);\n  text-align: center;\n}\n.quotation-send-success-panel h4,\n.quotation-send-success-panel p {\n  margin: 0;\n}\n.quotation-send-success-icon {\n  display: grid;\n  place-items: center;\n  width: 48px;\n  height: 48px;\n  color: var(--success-text, #166534);\n  background: var(--success-soft, #ecfdf3);\n  border-radius: var(--radius-full, 9999px);\n}\n.quotation-send-success-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Match the invoice register's customer filter without changing date pickers. */\n.quotation-page .quotation-customer-filter > .quotation-select-trigger {\n  min-width: 134px;\n  gap: 10px;\n}\n.quotation-page\n  .quotation-customer-filter\n  > .quotation-select-trigger:is(.is-open, :focus-visible),\n.quotation-page\n  .quotation-select-trigger[aria-label=\"Filter by date range\"]:is(.is-open, :focus-visible) {\n  border-color: var(--interactive-default);\n  box-shadow: none;\n}\n.quotation-page .quotation-customer-filter .select-arrow {\n  width: 16px;\n  height: 16px;\n  color: inherit;\n  transform: none;\n}\n.quotation-page .quotation-customer-filter > .quotation-dropdown-panel {\n  box-sizing: border-box;\n  top: calc(100% + 6px);\n  right: 0;\n  left: auto;\n  width: auto;\n  min-width: 210px;\n  max-width: calc(100vw - 32px);\n  max-height: min(240px, 40vh);\n  gap: 0;\n  padding: 6px;\n  border-color: var(--border-subtle);\n  background: var(--surface-primary);\n  box-shadow: 0 12px 30px rgba(14, 26, 32, 0.16);\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n}\n.quotation-page .quotation-customer-filter .quotation-dropdown-item {\n  flex-shrink: 0;\n  width: 100%;\n  height: auto;\n  gap: 12px;\n  padding: 9px 10px;\n  border-radius: 7px;\n  font-weight: 400;\n  line-height: normal;\n  white-space: normal;\n}\n.quotation-page .quotation-customer-filter .quotation-dropdown-item-label {\n  overflow: visible;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n.quotation-page\n  .quotation-customer-filter\n  .quotation-dropdown-item:is(:hover, .is-selected) {\n  background: var(--interactive-soft);\n  color: var(--interactive-default);\n}\n.quotation-page .quotation-customer-filter .quotation-dropdown-check-icon {\n  width: 16px;\n  height: 16px;\n  color: inherit;\n}\n@media (max-width: 600px) {\n  .quotation-page .quotation-customer-filter > .quotation-select-trigger {\n    min-width: 0;\n  }\n  .quotation-page .quotation-customer-filter > .quotation-dropdown-panel {\n    right: auto;\n    left: 0;\n    width: max-content !important;\n    max-width: calc(100vw - 32px) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
